// @generated by protobuf-ts 2.11.1 with parameter client_generic,generate_dependencies
// @generated from protobuf file "app.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./google/protobuf/empty";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "./google/protobuf/timestamp";
// @generated message type with reflection information, may provide speed optimized methods
class Token$Type extends MessageType {
    constructor() {
        super("Token", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Token
 */
export const Token = new Token$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginResponse$Type extends MessageType {
    constructor() {
        super("LoginResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "requires2FA", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "tempToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.reason = "";
        message.token = "";
        message.status = 0;
        message.requires2FA = false;
        message.tempToken = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                case /* string token */ 3:
                    message.token = reader.string();
                    break;
                case /* int32 status */ 4:
                    message.status = reader.int32();
                    break;
                case /* bool requires2FA */ 5:
                    message.requires2FA = reader.bool();
                    break;
                case /* string tempToken */ 6:
                    message.tempToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* string token = 3; */
        if (message.token !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.token);
        /* int32 status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* bool requires2FA = 5; */
        if (message.requires2FA !== false)
            writer.tag(5, WireType.Varint).bool(message.requires2FA);
        /* string tempToken = 6; */
        if (message.tempToken !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.tempToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LoginResponse
 */
export const LoginResponse = new LoginResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommonResponse$Type extends MessageType {
    constructor() {
        super("CommonResponse", [
            { no: 4, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.status = 0;
        message.successFull = false;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 status */ 4:
                    message.status = reader.int32();
                    break;
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* string reason */ 2:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* string reason = 2; */
        if (message.reason !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.reason);
        /* int32 status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommonResponse
 */
export const CommonResponse = new CommonResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LoginRequest$Type extends MessageType {
    constructor() {
        super("LoginRequest", [
            { no: 1, name: "browserName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "osName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "userIp", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.browserName = "";
        message.osName = "";
        message.email = "";
        message.password = "";
        message.location = "";
        message.userIp = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string browserName */ 1:
                    message.browserName = reader.string();
                    break;
                case /* string osName */ 2:
                    message.osName = reader.string();
                    break;
                case /* string email */ 3:
                    message.email = reader.string();
                    break;
                case /* string password */ 4:
                    message.password = reader.string();
                    break;
                case /* string location */ 5:
                    message.location = reader.string();
                    break;
                case /* string userIp */ 6:
                    message.userIp = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string browserName = 1; */
        if (message.browserName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.browserName);
        /* string osName = 2; */
        if (message.osName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.osName);
        /* string email = 3; */
        if (message.email !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.email);
        /* string password = 4; */
        if (message.password !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.password);
        /* string location = 5; */
        if (message.location !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.location);
        /* string userIp = 6; */
        if (message.userIp !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.userIp);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LoginRequest
 */
export const LoginRequest = new LoginRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResetPasswordRequest$Type extends MessageType {
    constructor() {
        super("ResetPasswordRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resetCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "newPassword", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.resetCode = "";
        message.newPassword = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string resetCode */ 2:
                    message.resetCode = reader.string();
                    break;
                case /* string newPassword */ 3:
                    message.newPassword = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string resetCode = 2; */
        if (message.resetCode !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resetCode);
        /* string newPassword = 3; */
        if (message.newPassword !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.newPassword);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ResetPasswordRequest
 */
export const ResetPasswordRequest = new ResetPasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyEmailRequest$Type extends MessageType {
    constructor() {
        super("VerifyEmailRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VerifyEmailRequest
 */
export const VerifyEmailRequest = new VerifyEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyEmailByTokenRequest$Type extends MessageType {
    constructor() {
        super("VerifyEmailByTokenRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VerifyEmailByTokenRequest
 */
export const VerifyEmailByTokenRequest = new VerifyEmailByTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResendVerificationEmailRequest$Type extends MessageType {
    constructor() {
        super("ResendVerificationEmailRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ResendVerificationEmailRequest
 */
export const ResendVerificationEmailRequest = new ResendVerificationEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOAuthURLRequest$Type extends MessageType {
    constructor() {
        super("GetOAuthURLRequest", [
            { no: 1, name: "redirectUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.redirectUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string redirectUrl */ 1:
                    message.redirectUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string redirectUrl = 1; */
        if (message.redirectUrl !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.redirectUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetOAuthURLRequest
 */
export const GetOAuthURLRequest = new GetOAuthURLRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetOAuthURLResponse$Type extends MessageType {
    constructor() {
        super("GetOAuthURLResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "authUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.authUrl = "";
        message.state = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string authUrl */ 4:
                    message.authUrl = reader.string();
                    break;
                case /* string state */ 5:
                    message.state = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string authUrl = 4; */
        if (message.authUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.authUrl);
        /* string state = 5; */
        if (message.state !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.state);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetOAuthURLResponse
 */
export const GetOAuthURLResponse = new GetOAuthURLResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OAuthCallbackRequest$Type extends MessageType {
    constructor() {
        super("OAuthCallbackRequest", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.code = "";
        message.state = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string state */ 2:
                    message.state = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string state = 2; */
        if (message.state !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.state);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message OAuthCallbackRequest
 */
export const OAuthCallbackRequest = new OAuthCallbackRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OAuthCallbackResponse$Type extends MessageType {
    constructor() {
        super("OAuthCallbackResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "refreshToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "userExists", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "oauthProvider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "oauthProviderId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.token = "";
        message.refreshToken = "";
        message.userExists = false;
        message.email = "";
        message.firstName = "";
        message.lastName = "";
        message.avatarUrl = "";
        message.oauthProvider = "";
        message.oauthProviderId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string token */ 4:
                    message.token = reader.string();
                    break;
                case /* string refreshToken */ 5:
                    message.refreshToken = reader.string();
                    break;
                case /* bool userExists */ 6:
                    message.userExists = reader.bool();
                    break;
                case /* string email */ 7:
                    message.email = reader.string();
                    break;
                case /* string firstName */ 8:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 9:
                    message.lastName = reader.string();
                    break;
                case /* string avatarUrl */ 10:
                    message.avatarUrl = reader.string();
                    break;
                case /* string oauthProvider */ 11:
                    message.oauthProvider = reader.string();
                    break;
                case /* string oauthProviderId */ 12:
                    message.oauthProviderId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string token = 4; */
        if (message.token !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.token);
        /* string refreshToken = 5; */
        if (message.refreshToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.refreshToken);
        /* bool userExists = 6; */
        if (message.userExists !== false)
            writer.tag(6, WireType.Varint).bool(message.userExists);
        /* string email = 7; */
        if (message.email !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.email);
        /* string firstName = 8; */
        if (message.firstName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 9; */
        if (message.lastName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.lastName);
        /* string avatarUrl = 10; */
        if (message.avatarUrl !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.avatarUrl);
        /* string oauthProvider = 11; */
        if (message.oauthProvider !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.oauthProvider);
        /* string oauthProviderId = 12; */
        if (message.oauthProviderId !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.oauthProviderId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message OAuthCallbackResponse
 */
export const OAuthCallbackResponse = new OAuthCallbackResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Enable2FARequest$Type extends MessageType {
    constructor() {
        super("Enable2FARequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Enable2FARequest
 */
export const Enable2FARequest = new Enable2FARequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Enable2FAResponse$Type extends MessageType {
    constructor() {
        super("Enable2FAResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "qrCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "backupCodes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.secret = "";
        message.qrCode = "";
        message.backupCodes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string secret */ 4:
                    message.secret = reader.string();
                    break;
                case /* string qrCode */ 5:
                    message.qrCode = reader.string();
                    break;
                case /* repeated string backupCodes */ 6:
                    message.backupCodes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string secret = 4; */
        if (message.secret !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.secret);
        /* string qrCode = 5; */
        if (message.qrCode !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.qrCode);
        /* repeated string backupCodes = 6; */
        for (let i = 0; i < message.backupCodes.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.backupCodes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Enable2FAResponse
 */
export const Enable2FAResponse = new Enable2FAResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Verify2FARequest$Type extends MessageType {
    constructor() {
        super("Verify2FARequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Verify2FARequest
 */
export const Verify2FARequest = new Verify2FARequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Verify2FAResponse$Type extends MessageType {
    constructor() {
        super("Verify2FAResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Verify2FAResponse
 */
export const Verify2FAResponse = new Verify2FAResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Disable2FARequest$Type extends MessageType {
    constructor() {
        super("Disable2FARequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Disable2FARequest
 */
export const Disable2FARequest = new Disable2FARequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Disable2FAResponse$Type extends MessageType {
    constructor() {
        super("Disable2FAResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Disable2FAResponse
 */
export const Disable2FAResponse = new Disable2FAResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyLogin2FARequest$Type extends MessageType {
    constructor() {
        super("VerifyLogin2FARequest", [
            { no: 1, name: "tempToken", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tempToken = "";
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string tempToken */ 1:
                    message.tempToken = reader.string();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string tempToken = 1; */
        if (message.tempToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.tempToken);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VerifyLogin2FARequest
 */
export const VerifyLogin2FARequest = new VerifyLogin2FARequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyLogin2FAResponse$Type extends MessageType {
    constructor() {
        super("VerifyLogin2FAResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string token */ 4:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string token = 4; */
        if (message.token !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VerifyLogin2FAResponse
 */
export const VerifyLogin2FAResponse = new VerifyLogin2FAResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForgotPassowrdRequest$Type extends MessageType {
    constructor() {
        super("ForgotPassowrdRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ForgotPassowrdRequest
 */
export const ForgotPassowrdRequest = new ForgotPassowrdRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckUserNameIsAvailableRequest$Type extends MessageType {
    constructor() {
        super("CheckUserNameIsAvailableRequest", [
            { no: 1, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string userName */ 1:
                    message.userName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string userName = 1; */
        if (message.userName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CheckUserNameIsAvailableRequest
 */
export const CheckUserNameIsAvailableRequest = new CheckUserNameIsAvailableRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RegisterRequest$Type extends MessageType {
    constructor() {
        super("RegisterRequest", [
            { no: 1, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.password = "";
        message.userName = "";
        message.firstName = "";
        message.lastName = "";
        message.country = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 1:
                    message.email = reader.string();
                    break;
                case /* string password */ 2:
                    message.password = reader.string();
                    break;
                case /* string userName */ 4:
                    message.userName = reader.string();
                    break;
                case /* string firstName */ 5:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 6:
                    message.lastName = reader.string();
                    break;
                case /* string country */ 7:
                    message.country = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 1; */
        if (message.email !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.email);
        /* string password = 2; */
        if (message.password !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.password);
        /* string userName = 4; */
        if (message.userName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userName);
        /* string firstName = 5; */
        if (message.firstName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 6; */
        if (message.lastName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.lastName);
        /* string country = 7; */
        if (message.country !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.country);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RegisterRequest
 */
export const RegisterRequest = new RegisterRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserRoleChangeRequest$Type extends MessageType {
    constructor() {
        super("UserRoleChangeRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "targetUser", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "userType", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.targetUser = 0;
        message.userType = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 targetUser */ 2:
                    message.targetUser = reader.int32();
                    break;
                case /* int32 userType */ 3:
                    message.userType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 targetUser = 2; */
        if (message.targetUser !== 0)
            writer.tag(2, WireType.Varint).int32(message.targetUser);
        /* int32 userType = 3; */
        if (message.userType !== 0)
            writer.tag(3, WireType.Varint).int32(message.userType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserRoleChangeRequest
 */
export const UserRoleChangeRequest = new UserRoleChangeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvalidateTokenRequest$Type extends MessageType {
    constructor() {
        super("InvalidateTokenRequest", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.email = "";
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string token */ 3:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string token = 3; */
        if (message.token !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvalidateTokenRequest
 */
export const InvalidateTokenRequest = new InvalidateTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProfileRequest$Type extends MessageType {
    constructor() {
        super("UpdateProfileRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "bio", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.firstName = "";
        message.lastName = "";
        message.userName = "";
        message.bio = "";
        message.location = "";
        message.country = "";
        message.theme = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string firstName */ 2:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 3:
                    message.lastName = reader.string();
                    break;
                case /* string userName */ 4:
                    message.userName = reader.string();
                    break;
                case /* string bio */ 5:
                    message.bio = reader.string();
                    break;
                case /* string location */ 6:
                    message.location = reader.string();
                    break;
                case /* string country */ 7:
                    message.country = reader.string();
                    break;
                case /* string theme */ 8:
                    message.theme = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string firstName = 2; */
        if (message.firstName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 3; */
        if (message.lastName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lastName);
        /* string userName = 4; */
        if (message.userName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userName);
        /* string bio = 5; */
        if (message.bio !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.bio);
        /* string location = 6; */
        if (message.location !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.location);
        /* string country = 7; */
        if (message.country !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.country);
        /* string theme = 8; */
        if (message.theme !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.theme);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateProfileRequest
 */
export const UpdateProfileRequest = new UpdateProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestPasswordChangeCodeRequest$Type extends MessageType {
    constructor() {
        super("RequestPasswordChangeCodeRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RequestPasswordChangeCodeRequest
 */
export const RequestPasswordChangeCodeRequest = new RequestPasswordChangeCodeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChangePasswordRequest$Type extends MessageType {
    constructor() {
        super("ChangePasswordRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "newPassword", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.code = "";
        message.newPassword = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string code */ 2:
                    message.code = reader.string();
                    break;
                case /* string newPassword */ 3:
                    message.newPassword = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string code = 2; */
        if (message.code !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.code);
        /* string newPassword = 3; */
        if (message.newPassword !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.newPassword);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ChangePasswordRequest
 */
export const ChangePasswordRequest = new ChangePasswordRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserProfileRequest$Type extends MessageType {
    constructor() {
        super("GetUserProfileRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserProfileRequest
 */
export const GetUserProfileRequest = new GetUserProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProfile$Type extends MessageType {
    constructor() {
        super("UserProfile", [
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "bio", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "theme", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "is_2fa_enabled", kind: "scalar", jsonName: "is2faEnabled", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "userRole", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.email = "";
        message.firstName = "";
        message.lastName = "";
        message.userName = "";
        message.bio = "";
        message.location = "";
        message.country = "";
        message.avatarUrl = "";
        message.id = "";
        message.theme = "";
        message.is2FaEnabled = false;
        message.userRole = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string email */ 4:
                    message.email = reader.string();
                    break;
                case /* string firstName */ 5:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 6:
                    message.lastName = reader.string();
                    break;
                case /* string userName */ 7:
                    message.userName = reader.string();
                    break;
                case /* string bio */ 8:
                    message.bio = reader.string();
                    break;
                case /* string location */ 9:
                    message.location = reader.string();
                    break;
                case /* string country */ 10:
                    message.country = reader.string();
                    break;
                case /* string avatarUrl */ 11:
                    message.avatarUrl = reader.string();
                    break;
                case /* string id */ 12:
                    message.id = reader.string();
                    break;
                case /* string theme */ 13:
                    message.theme = reader.string();
                    break;
                case /* bool is_2fa_enabled */ 14:
                    message.is2FaEnabled = reader.bool();
                    break;
                case /* string userRole */ 15:
                    message.userRole = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string email = 4; */
        if (message.email !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* string firstName = 5; */
        if (message.firstName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 6; */
        if (message.lastName !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.lastName);
        /* string userName = 7; */
        if (message.userName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.userName);
        /* string bio = 8; */
        if (message.bio !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.bio);
        /* string location = 9; */
        if (message.location !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.location);
        /* string country = 10; */
        if (message.country !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.country);
        /* string avatarUrl = 11; */
        if (message.avatarUrl !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.avatarUrl);
        /* string id = 12; */
        if (message.id !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.id);
        /* string theme = 13; */
        if (message.theme !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.theme);
        /* bool is_2fa_enabled = 14; */
        if (message.is2FaEnabled !== false)
            writer.tag(14, WireType.Varint).bool(message.is2FaEnabled);
        /* string userRole = 15; */
        if (message.userRole !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.userRole);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserProfile
 */
export const UserProfile = new UserProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProfileResponse$Type extends MessageType {
    constructor() {
        super("UserProfileResponse", [
            { no: 1, name: "response", kind: "message", T: () => CommonResponse },
            { no: 2, name: "profile", kind: "message", T: () => UserProfile }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonResponse response */ 1:
                    message.response = CommonResponse.internalBinaryRead(reader, reader.uint32(), options, message.response);
                    break;
                case /* UserProfile profile */ 2:
                    message.profile = UserProfile.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* CommonResponse response = 1; */
        if (message.response)
            CommonResponse.internalBinaryWrite(message.response, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* UserProfile profile = 2; */
        if (message.profile)
            UserProfile.internalBinaryWrite(message.profile, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserProfileResponse
 */
export const UserProfileResponse = new UserProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPublicUserProfileRequest$Type extends MessageType {
    constructor() {
        super("GetPublicUserProfileRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                case /* string token */ 2:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        /* string token = 2; */
        if (message.token !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPublicUserProfileRequest
 */
export const GetPublicUserProfileRequest = new GetPublicUserProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PublicUserProfile$Type extends MessageType {
    constructor() {
        super("PublicUserProfile", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "bio", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "website", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "repositoryCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "starredCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "followersCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "followingCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        message.firstName = "";
        message.lastName = "";
        message.bio = "";
        message.location = "";
        message.email = "";
        message.website = "";
        message.avatarUrl = "";
        message.repositoryCount = 0;
        message.starredCount = 0;
        message.followersCount = 0;
        message.followingCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                case /* string firstName */ 2:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 3:
                    message.lastName = reader.string();
                    break;
                case /* string bio */ 4:
                    message.bio = reader.string();
                    break;
                case /* string location */ 5:
                    message.location = reader.string();
                    break;
                case /* string email */ 6:
                    message.email = reader.string();
                    break;
                case /* string website */ 7:
                    message.website = reader.string();
                    break;
                case /* string avatarUrl */ 8:
                    message.avatarUrl = reader.string();
                    break;
                case /* int32 repositoryCount */ 9:
                    message.repositoryCount = reader.int32();
                    break;
                case /* int32 starredCount */ 10:
                    message.starredCount = reader.int32();
                    break;
                case /* int32 followersCount */ 11:
                    message.followersCount = reader.int32();
                    break;
                case /* int32 followingCount */ 12:
                    message.followingCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        /* string firstName = 2; */
        if (message.firstName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 3; */
        if (message.lastName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.lastName);
        /* string bio = 4; */
        if (message.bio !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.bio);
        /* string location = 5; */
        if (message.location !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.location);
        /* string email = 6; */
        if (message.email !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.email);
        /* string website = 7; */
        if (message.website !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.website);
        /* string avatarUrl = 8; */
        if (message.avatarUrl !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.avatarUrl);
        /* int32 repositoryCount = 9; */
        if (message.repositoryCount !== 0)
            writer.tag(9, WireType.Varint).int32(message.repositoryCount);
        /* int32 starredCount = 10; */
        if (message.starredCount !== 0)
            writer.tag(10, WireType.Varint).int32(message.starredCount);
        /* int32 followersCount = 11; */
        if (message.followersCount !== 0)
            writer.tag(11, WireType.Varint).int32(message.followersCount);
        /* int32 followingCount = 12; */
        if (message.followingCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.followingCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PublicUserProfile
 */
export const PublicUserProfile = new PublicUserProfile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PublicUserProfileResponse$Type extends MessageType {
    constructor() {
        super("PublicUserProfileResponse", [
            { no: 1, name: "response", kind: "message", T: () => CommonResponse },
            { no: 2, name: "profile", kind: "message", T: () => PublicUserProfile },
            { no: 3, name: "repositories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositoryInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.repositories = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* CommonResponse response */ 1:
                    message.response = CommonResponse.internalBinaryRead(reader, reader.uint32(), options, message.response);
                    break;
                case /* PublicUserProfile profile */ 2:
                    message.profile = PublicUserProfile.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                case /* repeated RepositoryInfo repositories */ 3:
                    message.repositories.push(RepositoryInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* CommonResponse response = 1; */
        if (message.response)
            CommonResponse.internalBinaryWrite(message.response, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* PublicUserProfile profile = 2; */
        if (message.profile)
            PublicUserProfile.internalBinaryWrite(message.profile, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated RepositoryInfo repositories = 3; */
        for (let i = 0; i < message.repositories.length; i++)
            RepositoryInfo.internalBinaryWrite(message.repositories[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PublicUserProfileResponse
 */
export const PublicUserProfileResponse = new PublicUserProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStarredRepositoriesRequest$Type extends MessageType {
    constructor() {
        super("GetStarredRepositoriesRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetStarredRepositoriesRequest
 */
export const GetStarredRepositoriesRequest = new GetStarredRepositoriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetStarredRepositoriesResponse$Type extends MessageType {
    constructor() {
        super("GetStarredRepositoriesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositoryInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.repositories = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated RepositoryInfo repositories */ 4:
                    message.repositories.push(RepositoryInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated RepositoryInfo repositories = 4; */
        for (let i = 0; i < message.repositories.length; i++)
            RepositoryInfo.internalBinaryWrite(message.repositories[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetStarredRepositoriesResponse
 */
export const GetStarredRepositoriesResponse = new GetStarredRepositoriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StarRepositoryRequest$Type extends MessageType {
    constructor() {
        super("StarRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StarRepositoryRequest
 */
export const StarRepositoryRequest = new StarRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StarRepositoryResponse$Type extends MessageType {
    constructor() {
        super("StarRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StarRepositoryResponse
 */
export const StarRepositoryResponse = new StarRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnstarRepositoryRequest$Type extends MessageType {
    constructor() {
        super("UnstarRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnstarRepositoryRequest
 */
export const UnstarRepositoryRequest = new UnstarRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnstarRepositoryResponse$Type extends MessageType {
    constructor() {
        super("UnstarRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnstarRepositoryResponse
 */
export const UnstarRepositoryResponse = new UnstarRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsRepositoryStarredRequest$Type extends MessageType {
    constructor() {
        super("IsRepositoryStarredRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IsRepositoryStarredRequest
 */
export const IsRepositoryStarredRequest = new IsRepositoryStarredRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsRepositoryStarredResponse$Type extends MessageType {
    constructor() {
        super("IsRepositoryStarredResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "isStarred", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.isStarred = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* bool isStarred */ 4:
                    message.isStarred = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* bool isStarred = 4; */
        if (message.isStarred !== false)
            writer.tag(4, WireType.Varint).bool(message.isStarred);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IsRepositoryStarredResponse
 */
export const IsRepositoryStarredResponse = new IsRepositoryStarredResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WatchRepositoryRequest$Type extends MessageType {
    constructor() {
        super("WatchRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message WatchRepositoryRequest
 */
export const WatchRepositoryRequest = new WatchRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WatchRepositoryResponse$Type extends MessageType {
    constructor() {
        super("WatchRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message WatchRepositoryResponse
 */
export const WatchRepositoryResponse = new WatchRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnwatchRepositoryRequest$Type extends MessageType {
    constructor() {
        super("UnwatchRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnwatchRepositoryRequest
 */
export const UnwatchRepositoryRequest = new UnwatchRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnwatchRepositoryResponse$Type extends MessageType {
    constructor() {
        super("UnwatchRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnwatchRepositoryResponse
 */
export const UnwatchRepositoryResponse = new UnwatchRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsRepositoryWatchedRequest$Type extends MessageType {
    constructor() {
        super("IsRepositoryWatchedRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IsRepositoryWatchedRequest
 */
export const IsRepositoryWatchedRequest = new IsRepositoryWatchedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsRepositoryWatchedResponse$Type extends MessageType {
    constructor() {
        super("IsRepositoryWatchedResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "isWatched", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.isWatched = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* bool isWatched */ 4:
                    message.isWatched = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* bool isWatched = 4; */
        if (message.isWatched !== false)
            writer.tag(4, WireType.Varint).bool(message.isWatched);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IsRepositoryWatchedResponse
 */
export const IsRepositoryWatchedResponse = new IsRepositoryWatchedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForkRepositoryRequest$Type extends MessageType {
    constructor() {
        super("ForkRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        message.repositoryName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ForkRepositoryRequest
 */
export const ForkRepositoryRequest = new ForkRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForkRepositoryResponse$Type extends MessageType {
    constructor() {
        super("ForkRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "forkedRepositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.forkedRepositoryId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string forkedRepositoryId */ 4:
                    message.forkedRepositoryId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string forkedRepositoryId = 4; */
        if (message.forkedRepositoryId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.forkedRepositoryId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ForkRepositoryResponse
 */
export const ForkRepositoryResponse = new ForkRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FollowUserRequest$Type extends MessageType {
    constructor() {
        super("FollowUserRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FollowUserRequest
 */
export const FollowUserRequest = new FollowUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FollowUserResponse$Type extends MessageType {
    constructor() {
        super("FollowUserResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FollowUserResponse
 */
export const FollowUserResponse = new FollowUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnfollowUserRequest$Type extends MessageType {
    constructor() {
        super("UnfollowUserRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnfollowUserRequest
 */
export const UnfollowUserRequest = new UnfollowUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnfollowUserResponse$Type extends MessageType {
    constructor() {
        super("UnfollowUserResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnfollowUserResponse
 */
export const UnfollowUserResponse = new UnfollowUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsFollowingRequest$Type extends MessageType {
    constructor() {
        super("IsFollowingRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IsFollowingRequest
 */
export const IsFollowingRequest = new IsFollowingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IsFollowingResponse$Type extends MessageType {
    constructor() {
        super("IsFollowingResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "isFollowing", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.isFollowing = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* bool isFollowing */ 4:
                    message.isFollowing = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* bool isFollowing = 4; */
        if (message.isFollowing !== false)
            writer.tag(4, WireType.Varint).bool(message.isFollowing);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IsFollowingResponse
 */
export const IsFollowingResponse = new IsFollowingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserInfo$Type extends MessageType {
    constructor() {
        super("UserInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "bio", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "followersCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "followingCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.username = "";
        message.firstName = "";
        message.lastName = "";
        message.bio = "";
        message.avatarUrl = "";
        message.followersCount = 0;
        message.followingCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string username */ 2:
                    message.username = reader.string();
                    break;
                case /* string firstName */ 3:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 4:
                    message.lastName = reader.string();
                    break;
                case /* string bio */ 5:
                    message.bio = reader.string();
                    break;
                case /* string avatarUrl */ 6:
                    message.avatarUrl = reader.string();
                    break;
                case /* int32 followersCount */ 7:
                    message.followersCount = reader.int32();
                    break;
                case /* int32 followingCount */ 8:
                    message.followingCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string username = 2; */
        if (message.username !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.username);
        /* string firstName = 3; */
        if (message.firstName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 4; */
        if (message.lastName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.lastName);
        /* string bio = 5; */
        if (message.bio !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.bio);
        /* string avatarUrl = 6; */
        if (message.avatarUrl !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.avatarUrl);
        /* int32 followersCount = 7; */
        if (message.followersCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.followersCount);
        /* int32 followingCount = 8; */
        if (message.followingCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.followingCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserInfo
 */
export const UserInfo = new UserInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFollowersRequest$Type extends MessageType {
    constructor() {
        super("GetFollowersRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFollowersRequest
 */
export const GetFollowersRequest = new GetFollowersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFollowersResponse$Type extends MessageType {
    constructor() {
        super("GetFollowersResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "followers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.followers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated UserInfo followers */ 4:
                    message.followers.push(UserInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated UserInfo followers = 4; */
        for (let i = 0; i < message.followers.length; i++)
            UserInfo.internalBinaryWrite(message.followers[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFollowersResponse
 */
export const GetFollowersResponse = new GetFollowersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFollowingRequest$Type extends MessageType {
    constructor() {
        super("GetFollowingRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFollowingRequest
 */
export const GetFollowingRequest = new GetFollowingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFollowingResponse$Type extends MessageType {
    constructor() {
        super("GetFollowingResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "following", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.following = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated UserInfo following */ 4:
                    message.following.push(UserInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated UserInfo following = 4; */
        for (let i = 0; i < message.following.length; i++)
            UserInfo.internalBinaryWrite(message.following[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFollowingResponse
 */
export const GetFollowingResponse = new GetFollowingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SocialLinkInfo$Type extends MessageType {
    constructor() {
        super("SocialLinkInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "displayOrder", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.platform = "";
        message.url = "";
        message.displayOrder = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string platform */ 2:
                    message.platform = reader.string();
                    break;
                case /* string url */ 3:
                    message.url = reader.string();
                    break;
                case /* int32 displayOrder */ 4:
                    message.displayOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string platform = 2; */
        if (message.platform !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.platform);
        /* string url = 3; */
        if (message.url !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.url);
        /* int32 displayOrder = 4; */
        if (message.displayOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.displayOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SocialLinkInfo
 */
export const SocialLinkInfo = new SocialLinkInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSocialLinkRequest$Type extends MessageType {
    constructor() {
        super("AddSocialLinkRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "displayOrder", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.platform = "";
        message.url = "";
        message.displayOrder = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string platform */ 2:
                    message.platform = reader.string();
                    break;
                case /* string url */ 3:
                    message.url = reader.string();
                    break;
                case /* int32 displayOrder */ 4:
                    message.displayOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string platform = 2; */
        if (message.platform !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.platform);
        /* string url = 3; */
        if (message.url !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.url);
        /* int32 displayOrder = 4; */
        if (message.displayOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.displayOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddSocialLinkRequest
 */
export const AddSocialLinkRequest = new AddSocialLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSocialLinkResponse$Type extends MessageType {
    constructor() {
        super("AddSocialLinkResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "link", kind: "message", T: () => SocialLinkInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* SocialLinkInfo link */ 4:
                    message.link = SocialLinkInfo.internalBinaryRead(reader, reader.uint32(), options, message.link);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* SocialLinkInfo link = 4; */
        if (message.link)
            SocialLinkInfo.internalBinaryWrite(message.link, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddSocialLinkResponse
 */
export const AddSocialLinkResponse = new AddSocialLinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSocialLinkRequest$Type extends MessageType {
    constructor() {
        super("UpdateSocialLinkRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "linkId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "displayOrder", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.linkId = "";
        message.platform = "";
        message.url = "";
        message.displayOrder = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string linkId */ 2:
                    message.linkId = reader.string();
                    break;
                case /* string platform */ 3:
                    message.platform = reader.string();
                    break;
                case /* string url */ 4:
                    message.url = reader.string();
                    break;
                case /* int32 displayOrder */ 5:
                    message.displayOrder = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string linkId = 2; */
        if (message.linkId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.linkId);
        /* string platform = 3; */
        if (message.platform !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.platform);
        /* string url = 4; */
        if (message.url !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.url);
        /* int32 displayOrder = 5; */
        if (message.displayOrder !== 0)
            writer.tag(5, WireType.Varint).int32(message.displayOrder);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSocialLinkRequest
 */
export const UpdateSocialLinkRequest = new UpdateSocialLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateSocialLinkResponse$Type extends MessageType {
    constructor() {
        super("UpdateSocialLinkResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateSocialLinkResponse
 */
export const UpdateSocialLinkResponse = new UpdateSocialLinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSocialLinkRequest$Type extends MessageType {
    constructor() {
        super("DeleteSocialLinkRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "linkId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.linkId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string linkId */ 2:
                    message.linkId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string linkId = 2; */
        if (message.linkId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.linkId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteSocialLinkRequest
 */
export const DeleteSocialLinkRequest = new DeleteSocialLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSocialLinkResponse$Type extends MessageType {
    constructor() {
        super("DeleteSocialLinkResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteSocialLinkResponse
 */
export const DeleteSocialLinkResponse = new DeleteSocialLinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialLinksRequest$Type extends MessageType {
    constructor() {
        super("GetSocialLinksRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSocialLinksRequest
 */
export const GetSocialLinksRequest = new GetSocialLinksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSocialLinksResponse$Type extends MessageType {
    constructor() {
        super("GetSocialLinksResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SocialLinkInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.links = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated SocialLinkInfo links */ 4:
                    message.links.push(SocialLinkInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated SocialLinkInfo links = 4; */
        for (let i = 0; i < message.links.length; i++)
            SocialLinkInfo.internalBinaryWrite(message.links[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSocialLinksResponse
 */
export const GetSocialLinksResponse = new GetSocialLinksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPublicSocialLinksRequest$Type extends MessageType {
    constructor() {
        super("GetPublicSocialLinksRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPublicSocialLinksRequest
 */
export const GetPublicSocialLinksRequest = new GetPublicSocialLinksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPublicSocialLinksResponse$Type extends MessageType {
    constructor() {
        super("GetPublicSocialLinksResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SocialLinkInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.links = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated SocialLinkInfo links */ 4:
                    message.links.push(SocialLinkInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated SocialLinkInfo links = 4; */
        for (let i = 0; i < message.links.length; i++)
            SocialLinkInfo.internalBinaryWrite(message.links[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPublicSocialLinksResponse
 */
export const GetPublicSocialLinksResponse = new GetPublicSocialLinksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserEmailInfo$Type extends MessageType {
    constructor() {
        super("UserEmailInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "isPrimary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "isPublic", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "isVerified", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.email = "";
        message.isPrimary = false;
        message.isPublic = false;
        message.isVerified = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* bool isPrimary */ 3:
                    message.isPrimary = reader.bool();
                    break;
                case /* bool isPublic */ 4:
                    message.isPublic = reader.bool();
                    break;
                case /* bool isVerified */ 5:
                    message.isVerified = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* bool isPrimary = 3; */
        if (message.isPrimary !== false)
            writer.tag(3, WireType.Varint).bool(message.isPrimary);
        /* bool isPublic = 4; */
        if (message.isPublic !== false)
            writer.tag(4, WireType.Varint).bool(message.isPublic);
        /* bool isVerified = 5; */
        if (message.isVerified !== false)
            writer.tag(5, WireType.Varint).bool(message.isVerified);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UserEmailInfo
 */
export const UserEmailInfo = new UserEmailInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddUserEmailRequest$Type extends MessageType {
    constructor() {
        super("AddUserEmailRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "isPublic", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.email = "";
        message.isPublic = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* bool isPublic */ 3:
                    message.isPublic = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* bool isPublic = 3; */
        if (message.isPublic !== false)
            writer.tag(3, WireType.Varint).bool(message.isPublic);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddUserEmailRequest
 */
export const AddUserEmailRequest = new AddUserEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddUserEmailResponse$Type extends MessageType {
    constructor() {
        super("AddUserEmailResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "emailInfo", kind: "message", T: () => UserEmailInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* UserEmailInfo emailInfo */ 4:
                    message.emailInfo = UserEmailInfo.internalBinaryRead(reader, reader.uint32(), options, message.emailInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* UserEmailInfo emailInfo = 4; */
        if (message.emailInfo)
            UserEmailInfo.internalBinaryWrite(message.emailInfo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddUserEmailResponse
 */
export const AddUserEmailResponse = new AddUserEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateEmailPublicStatusRequest$Type extends MessageType {
    constructor() {
        super("UpdateEmailPublicStatusRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "emailId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "isPublic", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.emailId = "";
        message.isPublic = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string emailId */ 2:
                    message.emailId = reader.string();
                    break;
                case /* bool isPublic */ 3:
                    message.isPublic = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string emailId = 2; */
        if (message.emailId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.emailId);
        /* bool isPublic = 3; */
        if (message.isPublic !== false)
            writer.tag(3, WireType.Varint).bool(message.isPublic);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateEmailPublicStatusRequest
 */
export const UpdateEmailPublicStatusRequest = new UpdateEmailPublicStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateEmailPublicStatusResponse$Type extends MessageType {
    constructor() {
        super("UpdateEmailPublicStatusResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateEmailPublicStatusResponse
 */
export const UpdateEmailPublicStatusResponse = new UpdateEmailPublicStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPrimaryEmailRequest$Type extends MessageType {
    constructor() {
        super("SetPrimaryEmailRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "emailId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.emailId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string emailId */ 2:
                    message.emailId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string emailId = 2; */
        if (message.emailId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.emailId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetPrimaryEmailRequest
 */
export const SetPrimaryEmailRequest = new SetPrimaryEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetPrimaryEmailResponse$Type extends MessageType {
    constructor() {
        super("SetPrimaryEmailResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetPrimaryEmailResponse
 */
export const SetPrimaryEmailResponse = new SetPrimaryEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserEmailRequest$Type extends MessageType {
    constructor() {
        super("DeleteUserEmailRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "emailId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.emailId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string emailId */ 2:
                    message.emailId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string emailId = 2; */
        if (message.emailId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.emailId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteUserEmailRequest
 */
export const DeleteUserEmailRequest = new DeleteUserEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteUserEmailResponse$Type extends MessageType {
    constructor() {
        super("DeleteUserEmailResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteUserEmailResponse
 */
export const DeleteUserEmailResponse = new DeleteUserEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserEmailsRequest$Type extends MessageType {
    constructor() {
        super("GetUserEmailsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserEmailsRequest
 */
export const GetUserEmailsRequest = new GetUserEmailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserEmailsResponse$Type extends MessageType {
    constructor() {
        super("GetUserEmailsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "emails", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserEmailInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.emails = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated UserEmailInfo emails */ 4:
                    message.emails.push(UserEmailInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated UserEmailInfo emails = 4; */
        for (let i = 0; i < message.emails.length; i++)
            UserEmailInfo.internalBinaryWrite(message.emails[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserEmailsResponse
 */
export const GetUserEmailsResponse = new GetUserEmailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPublicEmailsRequest$Type extends MessageType {
    constructor() {
        super("GetPublicEmailsRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPublicEmailsRequest
 */
export const GetPublicEmailsRequest = new GetPublicEmailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPublicEmailsResponse$Type extends MessageType {
    constructor() {
        super("GetPublicEmailsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "emails", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.emails = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated string emails */ 4:
                    message.emails.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated string emails = 4; */
        for (let i = 0; i < message.emails.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.emails[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPublicEmailsResponse
 */
export const GetPublicEmailsResponse = new GetPublicEmailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyUserEmailRequest$Type extends MessageType {
    constructor() {
        super("VerifyUserEmailRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "emailId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "verificationCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.emailId = "";
        message.verificationCode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string emailId */ 2:
                    message.emailId = reader.string();
                    break;
                case /* string verificationCode */ 3:
                    message.verificationCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string emailId = 2; */
        if (message.emailId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.emailId);
        /* string verificationCode = 3; */
        if (message.verificationCode !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.verificationCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VerifyUserEmailRequest
 */
export const VerifyUserEmailRequest = new VerifyUserEmailRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VerifyUserEmailResponse$Type extends MessageType {
    constructor() {
        super("VerifyUserEmailResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message VerifyUserEmailResponse
 */
export const VerifyUserEmailResponse = new VerifyUserEmailResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRepositoryRequest$Type extends MessageType {
    constructor() {
        super("CreateRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "owner", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "visibility", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "template", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "addReadme", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "gitignore", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "license", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.owner = "";
        message.repositoryName = "";
        message.description = "";
        message.visibility = "";
        message.template = "";
        message.addReadme = false;
        message.gitignore = "";
        message.license = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string owner */ 2:
                    message.owner = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string visibility */ 5:
                    message.visibility = reader.string();
                    break;
                case /* string template */ 6:
                    message.template = reader.string();
                    break;
                case /* bool addReadme */ 7:
                    message.addReadme = reader.bool();
                    break;
                case /* string gitignore */ 8:
                    message.gitignore = reader.string();
                    break;
                case /* string license */ 9:
                    message.license = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string owner = 2; */
        if (message.owner !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.owner);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string visibility = 5; */
        if (message.visibility !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.visibility);
        /* string template = 6; */
        if (message.template !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.template);
        /* bool addReadme = 7; */
        if (message.addReadme !== false)
            writer.tag(7, WireType.Varint).bool(message.addReadme);
        /* string gitignore = 8; */
        if (message.gitignore !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.gitignore);
        /* string license = 9; */
        if (message.license !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.license);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateRepositoryRequest
 */
export const CreateRepositoryRequest = new CreateRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRepositoryResponse$Type extends MessageType {
    constructor() {
        super("CreateRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "repositoryPath", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.repositoryId = "";
        message.repositoryPath = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string repositoryId */ 4:
                    message.repositoryId = reader.string();
                    break;
                case /* string repositoryPath */ 5:
                    message.repositoryPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string repositoryId = 4; */
        if (message.repositoryId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.repositoryId);
        /* string repositoryPath = 5; */
        if (message.repositoryPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.repositoryPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateRepositoryResponse
 */
export const CreateRepositoryResponse = new CreateRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserRepositoriesRequest$Type extends MessageType {
    constructor() {
        super("GetUserRepositoriesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.userName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string userName */ 2:
                    message.userName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string userName = 2; */
        if (message.userName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserRepositoriesRequest
 */
export const GetUserRepositoriesRequest = new GetUserRepositoriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RepositoryInfo$Type extends MessageType {
    constructor() {
        super("RepositoryInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "visibility", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "starCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "forkCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 10, name: "updatedAt", kind: "message", T: () => Timestamp },
            { no: 11, name: "website", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "watchCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "issueCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "prCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "primaryLanguage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "primaryLanguageColor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "defaultBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "ownerUsername", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.ownerId = "";
        message.name = "";
        message.description = "";
        message.visibility = "";
        message.avatarUrl = "";
        message.starCount = 0;
        message.forkCount = 0;
        message.website = "";
        message.watchCount = 0;
        message.issueCount = 0;
        message.prCount = 0;
        message.primaryLanguage = "";
        message.primaryLanguageColor = "";
        message.defaultBranch = "";
        message.ownerUsername = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string visibility */ 5:
                    message.visibility = reader.string();
                    break;
                case /* string avatarUrl */ 6:
                    message.avatarUrl = reader.string();
                    break;
                case /* int32 starCount */ 7:
                    message.starCount = reader.int32();
                    break;
                case /* int32 forkCount */ 8:
                    message.forkCount = reader.int32();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 9:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 10:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string website */ 11:
                    message.website = reader.string();
                    break;
                case /* int32 watchCount */ 12:
                    message.watchCount = reader.int32();
                    break;
                case /* int32 issueCount */ 13:
                    message.issueCount = reader.int32();
                    break;
                case /* int32 prCount */ 14:
                    message.prCount = reader.int32();
                    break;
                case /* string primaryLanguage */ 15:
                    message.primaryLanguage = reader.string();
                    break;
                case /* string primaryLanguageColor */ 16:
                    message.primaryLanguageColor = reader.string();
                    break;
                case /* string defaultBranch */ 17:
                    message.defaultBranch = reader.string();
                    break;
                case /* string ownerUsername */ 18:
                    message.ownerUsername = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string visibility = 5; */
        if (message.visibility !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.visibility);
        /* string avatarUrl = 6; */
        if (message.avatarUrl !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.avatarUrl);
        /* int32 starCount = 7; */
        if (message.starCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.starCount);
        /* int32 forkCount = 8; */
        if (message.forkCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.forkCount);
        /* google.protobuf.Timestamp createdAt = 9; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 10; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string website = 11; */
        if (message.website !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.website);
        /* int32 watchCount = 12; */
        if (message.watchCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.watchCount);
        /* int32 issueCount = 13; */
        if (message.issueCount !== 0)
            writer.tag(13, WireType.Varint).int32(message.issueCount);
        /* int32 prCount = 14; */
        if (message.prCount !== 0)
            writer.tag(14, WireType.Varint).int32(message.prCount);
        /* string primaryLanguage = 15; */
        if (message.primaryLanguage !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.primaryLanguage);
        /* string primaryLanguageColor = 16; */
        if (message.primaryLanguageColor !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.primaryLanguageColor);
        /* string defaultBranch = 17; */
        if (message.defaultBranch !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.defaultBranch);
        /* string ownerUsername = 18; */
        if (message.ownerUsername !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.ownerUsername);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RepositoryInfo
 */
export const RepositoryInfo = new RepositoryInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserRepositoriesResponse$Type extends MessageType {
    constructor() {
        super("GetUserRepositoriesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositoryInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.repositories = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated RepositoryInfo repositories */ 4:
                    message.repositories.push(RepositoryInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated RepositoryInfo repositories = 4; */
        for (let i = 0; i < message.repositories.length; i++)
            RepositoryInfo.internalBinaryWrite(message.repositories[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserRepositoriesResponse
 */
export const GetUserRepositoriesResponse = new GetUserRepositoriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryFilesRequest$Type extends MessageType {
    constructor() {
        super("GetRepositoryFilesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.branch = "";
        message.path = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string branch */ 4:
                    message.branch = reader.string();
                    break;
                case /* string path */ 5:
                    message.path = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string branch = 4; */
        if (message.branch !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.branch);
        /* string path = 5; */
        if (message.path !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.path);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryFilesRequest
 */
export const GetRepositoryFilesRequest = new GetRepositoryFilesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FileInfo$Type extends MessageType {
    constructor() {
        super("FileInfo", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "updatedAt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "size", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "sha", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "children", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FileInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.type = "";
        message.message = "";
        message.updatedAt = "";
        message.size = 0n;
        message.sha = "";
        message.children = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string type */ 2:
                    message.type = reader.string();
                    break;
                case /* string message */ 3:
                    message.message = reader.string();
                    break;
                case /* string updatedAt */ 4:
                    message.updatedAt = reader.string();
                    break;
                case /* int64 size */ 5:
                    message.size = reader.int64().toBigInt();
                    break;
                case /* string sha */ 6:
                    message.sha = reader.string();
                    break;
                case /* repeated FileInfo children */ 7:
                    message.children.push(FileInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string type = 2; */
        if (message.type !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.type);
        /* string message = 3; */
        if (message.message !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.message);
        /* string updatedAt = 4; */
        if (message.updatedAt !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.updatedAt);
        /* int64 size = 5; */
        if (message.size !== 0n)
            writer.tag(5, WireType.Varint).int64(message.size);
        /* string sha = 6; */
        if (message.sha !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.sha);
        /* repeated FileInfo children = 7; */
        for (let i = 0; i < message.children.length; i++)
            FileInfo.internalBinaryWrite(message.children[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message FileInfo
 */
export const FileInfo = new FileInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryFilesResponse$Type extends MessageType {
    constructor() {
        super("GetRepositoryFilesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "files", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FileInfo },
            { no: 5, name: "currentPath", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "branch", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.files = [];
        message.currentPath = "";
        message.branch = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated FileInfo files */ 4:
                    message.files.push(FileInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string currentPath */ 5:
                    message.currentPath = reader.string();
                    break;
                case /* string branch */ 6:
                    message.branch = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated FileInfo files = 4; */
        for (let i = 0; i < message.files.length; i++)
            FileInfo.internalBinaryWrite(message.files[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string currentPath = 5; */
        if (message.currentPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.currentPath);
        /* string branch = 6; */
        if (message.branch !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.branch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryFilesResponse
 */
export const GetRepositoryFilesResponse = new GetRepositoryFilesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryDetailsRequest$Type extends MessageType {
    constructor() {
        super("GetRepositoryDetailsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryDetailsRequest
 */
export const GetRepositoryDetailsRequest = new GetRepositoryDetailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommitInfo$Type extends MessageType {
    constructor() {
        super("CommitInfo", [
            { no: 1, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "author", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sha", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.message = "";
        message.author = "";
        message.time = "";
        message.sha = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string message */ 1:
                    message.message = reader.string();
                    break;
                case /* string author */ 2:
                    message.author = reader.string();
                    break;
                case /* string time */ 3:
                    message.time = reader.string();
                    break;
                case /* string sha */ 4:
                    message.sha = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string message = 1; */
        if (message.message !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.message);
        /* string author = 2; */
        if (message.author !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.author);
        /* string time = 3; */
        if (message.time !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.time);
        /* string sha = 4; */
        if (message.sha !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.sha);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommitInfo
 */
export const CommitInfo = new CommitInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LanguageInfo$Type extends MessageType {
    constructor() {
        super("LanguageInfo", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "color", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.percentage = 0;
        message.color = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* double percentage */ 2:
                    message.percentage = reader.double();
                    break;
                case /* string color */ 3:
                    message.color = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* double percentage = 2; */
        if (message.percentage !== 0)
            writer.tag(2, WireType.Bit64).double(message.percentage);
        /* string color = 3; */
        if (message.color !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.color);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LanguageInfo
 */
export const LanguageInfo = new LanguageInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RepositoryOwner$Type extends MessageType {
    constructor() {
        super("RepositoryOwner", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userName = "";
        message.avatarUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string userName */ 2:
                    message.userName = reader.string();
                    break;
                case /* string avatarUrl */ 3:
                    message.avatarUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string userName = 2; */
        if (message.userName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userName);
        /* string avatarUrl = 3; */
        if (message.avatarUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.avatarUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RepositoryOwner
 */
export const RepositoryOwner = new RepositoryOwner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryDetailsResponse$Type extends MessageType {
    constructor() {
        super("GetRepositoryDetailsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "owner", kind: "message", T: () => RepositoryOwner },
            { no: 5, name: "repository", kind: "message", T: () => RepositoryInfo },
            { no: 6, name: "lastCommit", kind: "message", T: () => CommitInfo },
            { no: 7, name: "languages", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LanguageInfo },
            { no: 8, name: "readme", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.languages = [];
        message.readme = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* RepositoryOwner owner */ 4:
                    message.owner = RepositoryOwner.internalBinaryRead(reader, reader.uint32(), options, message.owner);
                    break;
                case /* RepositoryInfo repository */ 5:
                    message.repository = RepositoryInfo.internalBinaryRead(reader, reader.uint32(), options, message.repository);
                    break;
                case /* CommitInfo lastCommit */ 6:
                    message.lastCommit = CommitInfo.internalBinaryRead(reader, reader.uint32(), options, message.lastCommit);
                    break;
                case /* repeated LanguageInfo languages */ 7:
                    message.languages.push(LanguageInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string readme */ 8:
                    message.readme = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* RepositoryOwner owner = 4; */
        if (message.owner)
            RepositoryOwner.internalBinaryWrite(message.owner, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* RepositoryInfo repository = 5; */
        if (message.repository)
            RepositoryInfo.internalBinaryWrite(message.repository, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* CommitInfo lastCommit = 6; */
        if (message.lastCommit)
            CommitInfo.internalBinaryWrite(message.lastCommit, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated LanguageInfo languages = 7; */
        for (let i = 0; i < message.languages.length; i++)
            LanguageInfo.internalBinaryWrite(message.languages[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string readme = 8; */
        if (message.readme !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.readme);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryDetailsResponse
 */
export const GetRepositoryDetailsResponse = new GetRepositoryDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFileContentRequest$Type extends MessageType {
    constructor() {
        super("GetFileContentRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "filePath", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "branch", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.filePath = "";
        message.branch = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string filePath */ 4:
                    message.filePath = reader.string();
                    break;
                case /* string branch */ 5:
                    message.branch = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string filePath = 4; */
        if (message.filePath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.filePath);
        /* string branch = 5; */
        if (message.branch !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.branch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFileContentRequest
 */
export const GetFileContentRequest = new GetFileContentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFileContentResponse$Type extends MessageType {
    constructor() {
        super("GetFileContentResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "fileName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "size", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "mimeType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.content = "";
        message.fileName = "";
        message.size = 0n;
        message.mimeType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string content */ 4:
                    message.content = reader.string();
                    break;
                case /* string fileName */ 5:
                    message.fileName = reader.string();
                    break;
                case /* int64 size */ 6:
                    message.size = reader.int64().toBigInt();
                    break;
                case /* string mimeType */ 7:
                    message.mimeType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string content = 4; */
        if (message.content !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.content);
        /* string fileName = 5; */
        if (message.fileName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.fileName);
        /* int64 size = 6; */
        if (message.size !== 0n)
            writer.tag(6, WireType.Varint).int64(message.size);
        /* string mimeType = 7; */
        if (message.mimeType !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.mimeType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFileContentResponse
 */
export const GetFileContentResponse = new GetFileContentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LabelInfo$Type extends MessageType {
    constructor() {
        super("LabelInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "createdAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.color = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string color */ 3:
                    message.color = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string color = 3; */
        if (message.color !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.color);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp createdAt = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message LabelInfo
 */
export const LabelInfo = new LabelInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssigneeInfo$Type extends MessageType {
    constructor() {
        super("AssigneeInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "assignedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userName = "";
        message.avatarUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string userName */ 2:
                    message.userName = reader.string();
                    break;
                case /* string avatarUrl */ 3:
                    message.avatarUrl = reader.string();
                    break;
                case /* google.protobuf.Timestamp assignedAt */ 4:
                    message.assignedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.assignedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string userName = 2; */
        if (message.userName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userName);
        /* string avatarUrl = 3; */
        if (message.avatarUrl !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.avatarUrl);
        /* google.protobuf.Timestamp assignedAt = 4; */
        if (message.assignedAt)
            Timestamp.internalBinaryWrite(message.assignedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AssigneeInfo
 */
export const AssigneeInfo = new AssigneeInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommentInfo$Type extends MessageType {
    constructor() {
        super("CommentInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "authorId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "authorName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "authorAvatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 7, name: "updatedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.authorId = "";
        message.authorName = "";
        message.authorAvatar = "";
        message.content = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string authorId */ 2:
                    message.authorId = reader.string();
                    break;
                case /* string authorName */ 3:
                    message.authorName = reader.string();
                    break;
                case /* string authorAvatar */ 4:
                    message.authorAvatar = reader.string();
                    break;
                case /* string content */ 5:
                    message.content = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string authorId = 2; */
        if (message.authorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.authorId);
        /* string authorName = 3; */
        if (message.authorName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.authorName);
        /* string authorAvatar = 4; */
        if (message.authorAvatar !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.authorAvatar);
        /* string content = 5; */
        if (message.content !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.content);
        /* google.protobuf.Timestamp createdAt = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommentInfo
 */
export const CommentInfo = new CommentInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueInfo$Type extends MessageType {
    constructor() {
        super("IssueInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "authorId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "authorName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "authorAvatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "commentCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "labels", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LabelInfo },
            { no: 12, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 13, name: "updatedAt", kind: "message", T: () => Timestamp },
            { no: 14, name: "closedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.repositoryId = "";
        message.number = 0;
        message.title = "";
        message.description = "";
        message.authorId = "";
        message.authorName = "";
        message.authorAvatar = "";
        message.state = "";
        message.commentCount = 0;
        message.labels = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* int32 number */ 3:
                    message.number = reader.int32();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string authorId */ 6:
                    message.authorId = reader.string();
                    break;
                case /* string authorName */ 7:
                    message.authorName = reader.string();
                    break;
                case /* string authorAvatar */ 8:
                    message.authorAvatar = reader.string();
                    break;
                case /* string state */ 9:
                    message.state = reader.string();
                    break;
                case /* int32 commentCount */ 10:
                    message.commentCount = reader.int32();
                    break;
                case /* repeated LabelInfo labels */ 11:
                    message.labels.push(LabelInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp createdAt */ 12:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 13:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp closedAt */ 14:
                    message.closedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.closedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* int32 number = 3; */
        if (message.number !== 0)
            writer.tag(3, WireType.Varint).int32(message.number);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string authorId = 6; */
        if (message.authorId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.authorId);
        /* string authorName = 7; */
        if (message.authorName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.authorName);
        /* string authorAvatar = 8; */
        if (message.authorAvatar !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.authorAvatar);
        /* string state = 9; */
        if (message.state !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.state);
        /* int32 commentCount = 10; */
        if (message.commentCount !== 0)
            writer.tag(10, WireType.Varint).int32(message.commentCount);
        /* repeated LabelInfo labels = 11; */
        for (let i = 0; i < message.labels.length; i++)
            LabelInfo.internalBinaryWrite(message.labels[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp createdAt = 12; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 13; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp closedAt = 14; */
        if (message.closedAt)
            Timestamp.internalBinaryWrite(message.closedAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IssueInfo
 */
export const IssueInfo = new IssueInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IssueDetails$Type extends MessageType {
    constructor() {
        super("IssueDetails", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "authorId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "authorName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "authorAvatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "labels", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LabelInfo },
            { no: 11, name: "assignees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssigneeInfo },
            { no: 12, name: "comments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CommentInfo },
            { no: 13, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 14, name: "updatedAt", kind: "message", T: () => Timestamp },
            { no: 15, name: "closedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.repositoryId = "";
        message.number = 0;
        message.title = "";
        message.description = "";
        message.authorId = "";
        message.authorName = "";
        message.authorAvatar = "";
        message.state = "";
        message.labels = [];
        message.assignees = [];
        message.comments = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* int32 number */ 3:
                    message.number = reader.int32();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string authorId */ 6:
                    message.authorId = reader.string();
                    break;
                case /* string authorName */ 7:
                    message.authorName = reader.string();
                    break;
                case /* string authorAvatar */ 8:
                    message.authorAvatar = reader.string();
                    break;
                case /* string state */ 9:
                    message.state = reader.string();
                    break;
                case /* repeated LabelInfo labels */ 10:
                    message.labels.push(LabelInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated AssigneeInfo assignees */ 11:
                    message.assignees.push(AssigneeInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated CommentInfo comments */ 12:
                    message.comments.push(CommentInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp createdAt */ 13:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 14:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp closedAt */ 15:
                    message.closedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.closedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* int32 number = 3; */
        if (message.number !== 0)
            writer.tag(3, WireType.Varint).int32(message.number);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string authorId = 6; */
        if (message.authorId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.authorId);
        /* string authorName = 7; */
        if (message.authorName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.authorName);
        /* string authorAvatar = 8; */
        if (message.authorAvatar !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.authorAvatar);
        /* string state = 9; */
        if (message.state !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.state);
        /* repeated LabelInfo labels = 10; */
        for (let i = 0; i < message.labels.length; i++)
            LabelInfo.internalBinaryWrite(message.labels[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated AssigneeInfo assignees = 11; */
        for (let i = 0; i < message.assignees.length; i++)
            AssigneeInfo.internalBinaryWrite(message.assignees[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* repeated CommentInfo comments = 12; */
        for (let i = 0; i < message.comments.length; i++)
            CommentInfo.internalBinaryWrite(message.comments[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp createdAt = 13; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 14; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp closedAt = 15; */
        if (message.closedAt)
            Timestamp.internalBinaryWrite(message.closedAt, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message IssueDetails
 */
export const IssueDetails = new IssueDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateIssueRequest$Type extends MessageType {
    constructor() {
        super("CreateIssueRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "labelIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "assigneeIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.title = "";
        message.description = "";
        message.labelIds = [];
        message.assigneeIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* repeated string labelIds */ 6:
                    message.labelIds.push(reader.string());
                    break;
                case /* repeated string assigneeIds */ 7:
                    message.assigneeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* repeated string labelIds = 6; */
        for (let i = 0; i < message.labelIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.labelIds[i]);
        /* repeated string assigneeIds = 7; */
        for (let i = 0; i < message.assigneeIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.assigneeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateIssueRequest
 */
export const CreateIssueRequest = new CreateIssueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateIssueResponse$Type extends MessageType {
    constructor() {
        super("CreateIssueResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issue", kind: "message", T: () => IssueInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* IssueInfo issue */ 4:
                    message.issue = IssueInfo.internalBinaryRead(reader, reader.uint32(), options, message.issue);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* IssueInfo issue = 4; */
        if (message.issue)
            IssueInfo.internalBinaryWrite(message.issue, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateIssueResponse
 */
export const CreateIssueResponse = new CreateIssueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIssuesRequest$Type extends MessageType {
    constructor() {
        super("GetIssuesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.state = "";
        message.page = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string state */ 4:
                    message.state = reader.string();
                    break;
                case /* int32 page */ 5:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 6:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string state = 4; */
        if (message.state !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.state);
        /* int32 page = 5; */
        if (message.page !== 0)
            writer.tag(5, WireType.Varint).int32(message.page);
        /* int32 pageSize = 6; */
        if (message.pageSize !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetIssuesRequest
 */
export const GetIssuesRequest = new GetIssuesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIssuesResponse$Type extends MessageType {
    constructor() {
        super("GetIssuesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issues", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IssueInfo },
            { no: 5, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "openCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "closedCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.issues = [];
        message.totalCount = 0;
        message.openCount = 0;
        message.closedCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated IssueInfo issues */ 4:
                    message.issues.push(IssueInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 totalCount */ 5:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 openCount */ 6:
                    message.openCount = reader.int32();
                    break;
                case /* int32 closedCount */ 7:
                    message.closedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated IssueInfo issues = 4; */
        for (let i = 0; i < message.issues.length; i++)
            IssueInfo.internalBinaryWrite(message.issues[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 totalCount = 5; */
        if (message.totalCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCount);
        /* int32 openCount = 6; */
        if (message.openCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.openCount);
        /* int32 closedCount = 7; */
        if (message.closedCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.closedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetIssuesResponse
 */
export const GetIssuesResponse = new GetIssuesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIssueDetailsRequest$Type extends MessageType {
    constructor() {
        super("GetIssueDetailsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetIssueDetailsRequest
 */
export const GetIssueDetailsRequest = new GetIssueDetailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetIssueDetailsResponse$Type extends MessageType {
    constructor() {
        super("GetIssueDetailsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issue", kind: "message", T: () => IssueDetails }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* IssueDetails issue */ 4:
                    message.issue = IssueDetails.internalBinaryRead(reader, reader.uint32(), options, message.issue);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* IssueDetails issue = 4; */
        if (message.issue)
            IssueDetails.internalBinaryWrite(message.issue, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetIssueDetailsResponse
 */
export const GetIssueDetailsResponse = new GetIssueDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIssueRequest$Type extends MessageType {
    constructor() {
        super("UpdateIssueRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        message.title = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                case /* string title */ 5:
                    message.title = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        /* string title = 5; */
        if (message.title !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.title);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateIssueRequest
 */
export const UpdateIssueRequest = new UpdateIssueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateIssueResponse$Type extends MessageType {
    constructor() {
        super("UpdateIssueResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issue", kind: "message", T: () => IssueInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* IssueInfo issue */ 4:
                    message.issue = IssueInfo.internalBinaryRead(reader, reader.uint32(), options, message.issue);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* IssueInfo issue = 4; */
        if (message.issue)
            IssueInfo.internalBinaryWrite(message.issue, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateIssueResponse
 */
export const UpdateIssueResponse = new UpdateIssueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddCommentRequest$Type extends MessageType {
    constructor() {
        super("AddCommentRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "content", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        message.content = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                case /* string content */ 5:
                    message.content = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        /* string content = 5; */
        if (message.content !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.content);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddCommentRequest
 */
export const AddCommentRequest = new AddCommentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddCommentResponse$Type extends MessageType {
    constructor() {
        super("AddCommentResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "comment", kind: "message", T: () => CommentInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* CommentInfo comment */ 4:
                    message.comment = CommentInfo.internalBinaryRead(reader, reader.uint32(), options, message.comment);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* CommentInfo comment = 4; */
        if (message.comment)
            CommentInfo.internalBinaryWrite(message.comment, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddCommentResponse
 */
export const AddCommentResponse = new AddCommentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseIssueRequest$Type extends MessageType {
    constructor() {
        super("CloseIssueRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CloseIssueRequest
 */
export const CloseIssueRequest = new CloseIssueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CloseIssueResponse$Type extends MessageType {
    constructor() {
        super("CloseIssueResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CloseIssueResponse
 */
export const CloseIssueResponse = new CloseIssueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReopenIssueRequest$Type extends MessageType {
    constructor() {
        super("ReopenIssueRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReopenIssueRequest
 */
export const ReopenIssueRequest = new ReopenIssueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReopenIssueResponse$Type extends MessageType {
    constructor() {
        super("ReopenIssueResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReopenIssueResponse
 */
export const ReopenIssueResponse = new ReopenIssueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignUserRequest$Type extends MessageType {
    constructor() {
        super("AssignUserRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                case /* string userId */ 5:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        /* string userId = 5; */
        if (message.userId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AssignUserRequest
 */
export const AssignUserRequest = new AssignUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssignUserResponse$Type extends MessageType {
    constructor() {
        super("AssignUserResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AssignUserResponse
 */
export const AssignUserResponse = new AssignUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnassignUserRequest$Type extends MessageType {
    constructor() {
        super("UnassignUserRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                case /* string userId */ 5:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        /* string userId = 5; */
        if (message.userId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnassignUserRequest
 */
export const UnassignUserRequest = new UnassignUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnassignUserResponse$Type extends MessageType {
    constructor() {
        super("UnassignUserResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UnassignUserResponse
 */
export const UnassignUserResponse = new UnassignUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLabelRequest$Type extends MessageType {
    constructor() {
        super("CreateLabelRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "color", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.name = "";
        message.color = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string color */ 5:
                    message.color = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string color = 5; */
        if (message.color !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.color);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateLabelRequest
 */
export const CreateLabelRequest = new CreateLabelRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateLabelResponse$Type extends MessageType {
    constructor() {
        super("CreateLabelResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "label", kind: "message", T: () => LabelInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* LabelInfo label */ 4:
                    message.label = LabelInfo.internalBinaryRead(reader, reader.uint32(), options, message.label);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* LabelInfo label = 4; */
        if (message.label)
            LabelInfo.internalBinaryWrite(message.label, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateLabelResponse
 */
export const CreateLabelResponse = new CreateLabelResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLabelsRequest$Type extends MessageType {
    constructor() {
        super("GetLabelsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetLabelsRequest
 */
export const GetLabelsRequest = new GetLabelsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLabelsResponse$Type extends MessageType {
    constructor() {
        super("GetLabelsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "labels", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LabelInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.labels = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated LabelInfo labels */ 4:
                    message.labels.push(LabelInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated LabelInfo labels = 4; */
        for (let i = 0; i < message.labels.length; i++)
            LabelInfo.internalBinaryWrite(message.labels[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetLabelsResponse
 */
export const GetLabelsResponse = new GetLabelsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddLabelToIssueRequest$Type extends MessageType {
    constructor() {
        super("AddLabelToIssueRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "labelId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        message.labelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                case /* string labelId */ 5:
                    message.labelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        /* string labelId = 5; */
        if (message.labelId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.labelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddLabelToIssueRequest
 */
export const AddLabelToIssueRequest = new AddLabelToIssueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddLabelToIssueResponse$Type extends MessageType {
    constructor() {
        super("AddLabelToIssueResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddLabelToIssueResponse
 */
export const AddLabelToIssueResponse = new AddLabelToIssueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveLabelFromIssueRequest$Type extends MessageType {
    constructor() {
        super("RemoveLabelFromIssueRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "issueNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "labelId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.issueNumber = 0;
        message.labelId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 issueNumber */ 4:
                    message.issueNumber = reader.int32();
                    break;
                case /* string labelId */ 5:
                    message.labelId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 issueNumber = 4; */
        if (message.issueNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.issueNumber);
        /* string labelId = 5; */
        if (message.labelId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.labelId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveLabelFromIssueRequest
 */
export const RemoveLabelFromIssueRequest = new RemoveLabelFromIssueRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveLabelFromIssueResponse$Type extends MessageType {
    constructor() {
        super("RemoveLabelFromIssueResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveLabelFromIssueResponse
 */
export const RemoveLabelFromIssueResponse = new RemoveLabelFromIssueResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PullRequestInfo$Type extends MessageType {
    constructor() {
        super("PullRequestInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "authorId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "authorName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "authorAvatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "baseBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "compareBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "commentCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "additions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "deletions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "reviewStatus", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "labels", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LabelInfo },
            { no: 17, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 18, name: "updatedAt", kind: "message", T: () => Timestamp },
            { no: 19, name: "closedAt", kind: "message", T: () => Timestamp },
            { no: 20, name: "mergedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.repositoryId = "";
        message.number = 0;
        message.title = "";
        message.description = "";
        message.authorId = "";
        message.authorName = "";
        message.authorAvatar = "";
        message.baseBranch = "";
        message.compareBranch = "";
        message.state = "";
        message.commentCount = 0;
        message.additions = 0;
        message.deletions = 0;
        message.reviewStatus = "";
        message.labels = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* int32 number */ 3:
                    message.number = reader.int32();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string authorId */ 6:
                    message.authorId = reader.string();
                    break;
                case /* string authorName */ 7:
                    message.authorName = reader.string();
                    break;
                case /* string authorAvatar */ 8:
                    message.authorAvatar = reader.string();
                    break;
                case /* string baseBranch */ 9:
                    message.baseBranch = reader.string();
                    break;
                case /* string compareBranch */ 10:
                    message.compareBranch = reader.string();
                    break;
                case /* string state */ 11:
                    message.state = reader.string();
                    break;
                case /* int32 commentCount */ 12:
                    message.commentCount = reader.int32();
                    break;
                case /* int32 additions */ 13:
                    message.additions = reader.int32();
                    break;
                case /* int32 deletions */ 14:
                    message.deletions = reader.int32();
                    break;
                case /* string reviewStatus */ 15:
                    message.reviewStatus = reader.string();
                    break;
                case /* repeated LabelInfo labels */ 16:
                    message.labels.push(LabelInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp createdAt */ 17:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 18:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp closedAt */ 19:
                    message.closedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.closedAt);
                    break;
                case /* google.protobuf.Timestamp mergedAt */ 20:
                    message.mergedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.mergedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* int32 number = 3; */
        if (message.number !== 0)
            writer.tag(3, WireType.Varint).int32(message.number);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string authorId = 6; */
        if (message.authorId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.authorId);
        /* string authorName = 7; */
        if (message.authorName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.authorName);
        /* string authorAvatar = 8; */
        if (message.authorAvatar !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.authorAvatar);
        /* string baseBranch = 9; */
        if (message.baseBranch !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.baseBranch);
        /* string compareBranch = 10; */
        if (message.compareBranch !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.compareBranch);
        /* string state = 11; */
        if (message.state !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.state);
        /* int32 commentCount = 12; */
        if (message.commentCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.commentCount);
        /* int32 additions = 13; */
        if (message.additions !== 0)
            writer.tag(13, WireType.Varint).int32(message.additions);
        /* int32 deletions = 14; */
        if (message.deletions !== 0)
            writer.tag(14, WireType.Varint).int32(message.deletions);
        /* string reviewStatus = 15; */
        if (message.reviewStatus !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.reviewStatus);
        /* repeated LabelInfo labels = 16; */
        for (let i = 0; i < message.labels.length; i++)
            LabelInfo.internalBinaryWrite(message.labels[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp createdAt = 17; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 18; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp closedAt = 19; */
        if (message.closedAt)
            Timestamp.internalBinaryWrite(message.closedAt, writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp mergedAt = 20; */
        if (message.mergedAt)
            Timestamp.internalBinaryWrite(message.mergedAt, writer.tag(20, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PullRequestInfo
 */
export const PullRequestInfo = new PullRequestInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PullRequestDetails$Type extends MessageType {
    constructor() {
        super("PullRequestDetails", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "authorId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "authorName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "authorAvatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "baseBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "compareBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "additions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "deletions", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "reviewStatus", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "labels", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => LabelInfo },
            { no: 16, name: "assignees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssigneeInfo },
            { no: 17, name: "reviewers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AssigneeInfo },
            { no: 18, name: "comments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CommentInfo },
            { no: 19, name: "milestoneId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "milestoneName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 22, name: "updatedAt", kind: "message", T: () => Timestamp },
            { no: 23, name: "closedAt", kind: "message", T: () => Timestamp },
            { no: 24, name: "mergedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.repositoryId = "";
        message.number = 0;
        message.title = "";
        message.description = "";
        message.authorId = "";
        message.authorName = "";
        message.authorAvatar = "";
        message.baseBranch = "";
        message.compareBranch = "";
        message.state = "";
        message.additions = 0;
        message.deletions = 0;
        message.reviewStatus = "";
        message.labels = [];
        message.assignees = [];
        message.reviewers = [];
        message.comments = [];
        message.milestoneId = "";
        message.milestoneName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* int32 number */ 3:
                    message.number = reader.int32();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string authorId */ 6:
                    message.authorId = reader.string();
                    break;
                case /* string authorName */ 7:
                    message.authorName = reader.string();
                    break;
                case /* string authorAvatar */ 8:
                    message.authorAvatar = reader.string();
                    break;
                case /* string baseBranch */ 9:
                    message.baseBranch = reader.string();
                    break;
                case /* string compareBranch */ 10:
                    message.compareBranch = reader.string();
                    break;
                case /* string state */ 11:
                    message.state = reader.string();
                    break;
                case /* int32 additions */ 12:
                    message.additions = reader.int32();
                    break;
                case /* int32 deletions */ 13:
                    message.deletions = reader.int32();
                    break;
                case /* string reviewStatus */ 14:
                    message.reviewStatus = reader.string();
                    break;
                case /* repeated LabelInfo labels */ 15:
                    message.labels.push(LabelInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated AssigneeInfo assignees */ 16:
                    message.assignees.push(AssigneeInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated AssigneeInfo reviewers */ 17:
                    message.reviewers.push(AssigneeInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated CommentInfo comments */ 18:
                    message.comments.push(CommentInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string milestoneId */ 19:
                    message.milestoneId = reader.string();
                    break;
                case /* string milestoneName */ 20:
                    message.milestoneName = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 21:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 22:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp closedAt */ 23:
                    message.closedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.closedAt);
                    break;
                case /* google.protobuf.Timestamp mergedAt */ 24:
                    message.mergedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.mergedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* int32 number = 3; */
        if (message.number !== 0)
            writer.tag(3, WireType.Varint).int32(message.number);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string authorId = 6; */
        if (message.authorId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.authorId);
        /* string authorName = 7; */
        if (message.authorName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.authorName);
        /* string authorAvatar = 8; */
        if (message.authorAvatar !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.authorAvatar);
        /* string baseBranch = 9; */
        if (message.baseBranch !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.baseBranch);
        /* string compareBranch = 10; */
        if (message.compareBranch !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.compareBranch);
        /* string state = 11; */
        if (message.state !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.state);
        /* int32 additions = 12; */
        if (message.additions !== 0)
            writer.tag(12, WireType.Varint).int32(message.additions);
        /* int32 deletions = 13; */
        if (message.deletions !== 0)
            writer.tag(13, WireType.Varint).int32(message.deletions);
        /* string reviewStatus = 14; */
        if (message.reviewStatus !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.reviewStatus);
        /* repeated LabelInfo labels = 15; */
        for (let i = 0; i < message.labels.length; i++)
            LabelInfo.internalBinaryWrite(message.labels[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated AssigneeInfo assignees = 16; */
        for (let i = 0; i < message.assignees.length; i++)
            AssigneeInfo.internalBinaryWrite(message.assignees[i], writer.tag(16, WireType.LengthDelimited).fork(), options).join();
        /* repeated AssigneeInfo reviewers = 17; */
        for (let i = 0; i < message.reviewers.length; i++)
            AssigneeInfo.internalBinaryWrite(message.reviewers[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated CommentInfo comments = 18; */
        for (let i = 0; i < message.comments.length; i++)
            CommentInfo.internalBinaryWrite(message.comments[i], writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* string milestoneId = 19; */
        if (message.milestoneId !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.milestoneId);
        /* string milestoneName = 20; */
        if (message.milestoneName !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.milestoneName);
        /* google.protobuf.Timestamp createdAt = 21; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 22; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp closedAt = 23; */
        if (message.closedAt)
            Timestamp.internalBinaryWrite(message.closedAt, writer.tag(23, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp mergedAt = 24; */
        if (message.mergedAt)
            Timestamp.internalBinaryWrite(message.mergedAt, writer.tag(24, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PullRequestDetails
 */
export const PullRequestDetails = new PullRequestDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePullRequestRequest$Type extends MessageType {
    constructor() {
        super("CreatePullRequestRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "baseBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "compareBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "labelIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "reviewerIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "assigneeIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "milestoneId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.title = "";
        message.description = "";
        message.baseBranch = "";
        message.compareBranch = "";
        message.labelIds = [];
        message.reviewerIds = [];
        message.assigneeIds = [];
        message.milestoneId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string baseBranch */ 6:
                    message.baseBranch = reader.string();
                    break;
                case /* string compareBranch */ 7:
                    message.compareBranch = reader.string();
                    break;
                case /* repeated string labelIds */ 8:
                    message.labelIds.push(reader.string());
                    break;
                case /* repeated string reviewerIds */ 9:
                    message.reviewerIds.push(reader.string());
                    break;
                case /* repeated string assigneeIds */ 10:
                    message.assigneeIds.push(reader.string());
                    break;
                case /* string milestoneId */ 11:
                    message.milestoneId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string baseBranch = 6; */
        if (message.baseBranch !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.baseBranch);
        /* string compareBranch = 7; */
        if (message.compareBranch !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.compareBranch);
        /* repeated string labelIds = 8; */
        for (let i = 0; i < message.labelIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.labelIds[i]);
        /* repeated string reviewerIds = 9; */
        for (let i = 0; i < message.reviewerIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.reviewerIds[i]);
        /* repeated string assigneeIds = 10; */
        for (let i = 0; i < message.assigneeIds.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.assigneeIds[i]);
        /* string milestoneId = 11; */
        if (message.milestoneId !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.milestoneId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreatePullRequestRequest
 */
export const CreatePullRequestRequest = new CreatePullRequestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreatePullRequestResponse$Type extends MessageType {
    constructor() {
        super("CreatePullRequestResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequest", kind: "message", T: () => PullRequestInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* PullRequestInfo pullRequest */ 4:
                    message.pullRequest = PullRequestInfo.internalBinaryRead(reader, reader.uint32(), options, message.pullRequest);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* PullRequestInfo pullRequest = 4; */
        if (message.pullRequest)
            PullRequestInfo.internalBinaryWrite(message.pullRequest, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreatePullRequestResponse
 */
export const CreatePullRequestResponse = new CreatePullRequestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPullRequestsRequest$Type extends MessageType {
    constructor() {
        super("GetPullRequestsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.state = "";
        message.page = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string state */ 4:
                    message.state = reader.string();
                    break;
                case /* int32 page */ 5:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 6:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string state = 4; */
        if (message.state !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.state);
        /* int32 page = 5; */
        if (message.page !== 0)
            writer.tag(5, WireType.Varint).int32(message.page);
        /* int32 pageSize = 6; */
        if (message.pageSize !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPullRequestsRequest
 */
export const GetPullRequestsRequest = new GetPullRequestsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPullRequestsResponse$Type extends MessageType {
    constructor() {
        super("GetPullRequestsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PullRequestInfo },
            { no: 5, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "openCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "closedCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "mergedCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.pullRequests = [];
        message.totalCount = 0;
        message.openCount = 0;
        message.closedCount = 0;
        message.mergedCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated PullRequestInfo pullRequests */ 4:
                    message.pullRequests.push(PullRequestInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 totalCount */ 5:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 openCount */ 6:
                    message.openCount = reader.int32();
                    break;
                case /* int32 closedCount */ 7:
                    message.closedCount = reader.int32();
                    break;
                case /* int32 mergedCount */ 8:
                    message.mergedCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated PullRequestInfo pullRequests = 4; */
        for (let i = 0; i < message.pullRequests.length; i++)
            PullRequestInfo.internalBinaryWrite(message.pullRequests[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 totalCount = 5; */
        if (message.totalCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCount);
        /* int32 openCount = 6; */
        if (message.openCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.openCount);
        /* int32 closedCount = 7; */
        if (message.closedCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.closedCount);
        /* int32 mergedCount = 8; */
        if (message.mergedCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.mergedCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPullRequestsResponse
 */
export const GetPullRequestsResponse = new GetPullRequestsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPullRequestDetailsRequest$Type extends MessageType {
    constructor() {
        super("GetPullRequestDetailsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequestNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.pullRequestNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 pullRequestNumber */ 4:
                    message.pullRequestNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 pullRequestNumber = 4; */
        if (message.pullRequestNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pullRequestNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPullRequestDetailsRequest
 */
export const GetPullRequestDetailsRequest = new GetPullRequestDetailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPullRequestDetailsResponse$Type extends MessageType {
    constructor() {
        super("GetPullRequestDetailsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequest", kind: "message", T: () => PullRequestDetails }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* PullRequestDetails pullRequest */ 4:
                    message.pullRequest = PullRequestDetails.internalBinaryRead(reader, reader.uint32(), options, message.pullRequest);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* PullRequestDetails pullRequest = 4; */
        if (message.pullRequest)
            PullRequestDetails.internalBinaryWrite(message.pullRequest, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPullRequestDetailsResponse
 */
export const GetPullRequestDetailsResponse = new GetPullRequestDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePullRequestRequest$Type extends MessageType {
    constructor() {
        super("UpdatePullRequestRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequestNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.pullRequestNumber = 0;
        message.title = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 pullRequestNumber */ 4:
                    message.pullRequestNumber = reader.int32();
                    break;
                case /* string title */ 5:
                    message.title = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 pullRequestNumber = 4; */
        if (message.pullRequestNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pullRequestNumber);
        /* string title = 5; */
        if (message.title !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.title);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdatePullRequestRequest
 */
export const UpdatePullRequestRequest = new UpdatePullRequestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdatePullRequestResponse$Type extends MessageType {
    constructor() {
        super("UpdatePullRequestResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequest", kind: "message", T: () => PullRequestInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* PullRequestInfo pullRequest */ 4:
                    message.pullRequest = PullRequestInfo.internalBinaryRead(reader, reader.uint32(), options, message.pullRequest);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* PullRequestInfo pullRequest = 4; */
        if (message.pullRequest)
            PullRequestInfo.internalBinaryWrite(message.pullRequest, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdatePullRequestResponse
 */
export const UpdatePullRequestResponse = new UpdatePullRequestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosePullRequestRequest$Type extends MessageType {
    constructor() {
        super("ClosePullRequestRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequestNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.pullRequestNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 pullRequestNumber */ 4:
                    message.pullRequestNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 pullRequestNumber = 4; */
        if (message.pullRequestNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pullRequestNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClosePullRequestRequest
 */
export const ClosePullRequestRequest = new ClosePullRequestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClosePullRequestResponse$Type extends MessageType {
    constructor() {
        super("ClosePullRequestResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ClosePullRequestResponse
 */
export const ClosePullRequestResponse = new ClosePullRequestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergePullRequestRequest$Type extends MessageType {
    constructor() {
        super("MergePullRequestRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequestNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "mergeMethod", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.pullRequestNumber = 0;
        message.mergeMethod = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 pullRequestNumber */ 4:
                    message.pullRequestNumber = reader.int32();
                    break;
                case /* string mergeMethod */ 5:
                    message.mergeMethod = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 pullRequestNumber = 4; */
        if (message.pullRequestNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pullRequestNumber);
        /* string mergeMethod = 5; */
        if (message.mergeMethod !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.mergeMethod);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MergePullRequestRequest
 */
export const MergePullRequestRequest = new MergePullRequestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MergePullRequestResponse$Type extends MessageType {
    constructor() {
        super("MergePullRequestResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "mergeCommitSha", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.mergeCommitSha = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string mergeCommitSha */ 4:
                    message.mergeCommitSha = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string mergeCommitSha = 4; */
        if (message.mergeCommitSha !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.mergeCommitSha);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MergePullRequestResponse
 */
export const MergePullRequestResponse = new MergePullRequestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReopenPullRequestRequest$Type extends MessageType {
    constructor() {
        super("ReopenPullRequestRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequestNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.pullRequestNumber = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 pullRequestNumber */ 4:
                    message.pullRequestNumber = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 pullRequestNumber = 4; */
        if (message.pullRequestNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pullRequestNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReopenPullRequestRequest
 */
export const ReopenPullRequestRequest = new ReopenPullRequestRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReopenPullRequestResponse$Type extends MessageType {
    constructor() {
        super("ReopenPullRequestResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReopenPullRequestResponse
 */
export const ReopenPullRequestResponse = new ReopenPullRequestResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddReviewerRequest$Type extends MessageType {
    constructor() {
        super("AddReviewerRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequestNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.pullRequestNumber = 0;
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 pullRequestNumber */ 4:
                    message.pullRequestNumber = reader.int32();
                    break;
                case /* string userId */ 5:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 pullRequestNumber = 4; */
        if (message.pullRequestNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pullRequestNumber);
        /* string userId = 5; */
        if (message.userId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddReviewerRequest
 */
export const AddReviewerRequest = new AddReviewerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddReviewerResponse$Type extends MessageType {
    constructor() {
        super("AddReviewerResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddReviewerResponse
 */
export const AddReviewerResponse = new AddReviewerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveReviewerRequest$Type extends MessageType {
    constructor() {
        super("RemoveReviewerRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "pullRequestNumber", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.pullRequestNumber = 0;
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* int32 pullRequestNumber */ 4:
                    message.pullRequestNumber = reader.int32();
                    break;
                case /* string userId */ 5:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* int32 pullRequestNumber = 4; */
        if (message.pullRequestNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pullRequestNumber);
        /* string userId = 5; */
        if (message.userId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveReviewerRequest
 */
export const RemoveReviewerRequest = new RemoveReviewerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveReviewerResponse$Type extends MessageType {
    constructor() {
        super("RemoveReviewerResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveReviewerResponse
 */
export const RemoveReviewerResponse = new RemoveReviewerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BranchInfo$Type extends MessageType {
    constructor() {
        super("BranchInfo", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "commitSha", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commitMessage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "commitAuthor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "commitDate", kind: "message", T: () => Timestamp },
            { no: 6, name: "isDefault", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "isProtected", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.commitSha = "";
        message.commitMessage = "";
        message.commitAuthor = "";
        message.isDefault = false;
        message.isProtected = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string commitSha */ 2:
                    message.commitSha = reader.string();
                    break;
                case /* string commitMessage */ 3:
                    message.commitMessage = reader.string();
                    break;
                case /* string commitAuthor */ 4:
                    message.commitAuthor = reader.string();
                    break;
                case /* google.protobuf.Timestamp commitDate */ 5:
                    message.commitDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.commitDate);
                    break;
                case /* bool isDefault */ 6:
                    message.isDefault = reader.bool();
                    break;
                case /* bool isProtected */ 7:
                    message.isProtected = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string commitSha = 2; */
        if (message.commitSha !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.commitSha);
        /* string commitMessage = 3; */
        if (message.commitMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.commitMessage);
        /* string commitAuthor = 4; */
        if (message.commitAuthor !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.commitAuthor);
        /* google.protobuf.Timestamp commitDate = 5; */
        if (message.commitDate)
            Timestamp.internalBinaryWrite(message.commitDate, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool isDefault = 6; */
        if (message.isDefault !== false)
            writer.tag(6, WireType.Varint).bool(message.isDefault);
        /* bool isProtected = 7; */
        if (message.isProtected !== false)
            writer.tag(7, WireType.Varint).bool(message.isProtected);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BranchInfo
 */
export const BranchInfo = new BranchInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBranchesRequest$Type extends MessageType {
    constructor() {
        super("GetBranchesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBranchesRequest
 */
export const GetBranchesRequest = new GetBranchesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBranchesResponse$Type extends MessageType {
    constructor() {
        super("GetBranchesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branches", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BranchInfo },
            { no: 5, name: "defaultBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.branches = [];
        message.defaultBranch = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated BranchInfo branches */ 4:
                    message.branches.push(BranchInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string defaultBranch */ 5:
                    message.defaultBranch = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated BranchInfo branches = 4; */
        for (let i = 0; i < message.branches.length; i++)
            BranchInfo.internalBinaryWrite(message.branches[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string defaultBranch = 5; */
        if (message.defaultBranch !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.defaultBranch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBranchesResponse
 */
export const GetBranchesResponse = new GetBranchesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBranchRequest$Type extends MessageType {
    constructor() {
        super("CreateBranchRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branchName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "sourceBranch", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.branchName = "";
        message.sourceBranch = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string branchName */ 4:
                    message.branchName = reader.string();
                    break;
                case /* string sourceBranch */ 5:
                    message.sourceBranch = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string branchName = 4; */
        if (message.branchName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.branchName);
        /* string sourceBranch = 5; */
        if (message.sourceBranch !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.sourceBranch);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateBranchRequest
 */
export const CreateBranchRequest = new CreateBranchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateBranchResponse$Type extends MessageType {
    constructor() {
        super("CreateBranchResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branch", kind: "message", T: () => BranchInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* BranchInfo branch */ 4:
                    message.branch = BranchInfo.internalBinaryRead(reader, reader.uint32(), options, message.branch);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* BranchInfo branch = 4; */
        if (message.branch)
            BranchInfo.internalBinaryWrite(message.branch, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateBranchResponse
 */
export const CreateBranchResponse = new CreateBranchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBranchRequest$Type extends MessageType {
    constructor() {
        super("DeleteBranchRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branchName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.branchName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string branchName */ 4:
                    message.branchName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string branchName = 4; */
        if (message.branchName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.branchName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteBranchRequest
 */
export const DeleteBranchRequest = new DeleteBranchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteBranchResponse$Type extends MessageType {
    constructor() {
        super("DeleteBranchResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteBranchResponse
 */
export const DeleteBranchResponse = new DeleteBranchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBranchDetailsRequest$Type extends MessageType {
    constructor() {
        super("GetBranchDetailsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branchName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.branchName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string branchName */ 4:
                    message.branchName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string branchName = 4; */
        if (message.branchName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.branchName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBranchDetailsRequest
 */
export const GetBranchDetailsRequest = new GetBranchDetailsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBranchDetailsResponse$Type extends MessageType {
    constructor() {
        super("GetBranchDetailsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branch", kind: "message", T: () => BranchInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* BranchInfo branch */ 4:
                    message.branch = BranchInfo.internalBinaryRead(reader, reader.uint32(), options, message.branch);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* BranchInfo branch = 4; */
        if (message.branch)
            BranchInfo.internalBinaryWrite(message.branch, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBranchDetailsResponse
 */
export const GetBranchDetailsResponse = new GetBranchDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultBranchRequest$Type extends MessageType {
    constructor() {
        super("SetDefaultBranchRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "branchName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.branchName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string branchName */ 4:
                    message.branchName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string branchName = 4; */
        if (message.branchName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.branchName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetDefaultBranchRequest
 */
export const SetDefaultBranchRequest = new SetDefaultBranchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetDefaultBranchResponse$Type extends MessageType {
    constructor() {
        super("SetDefaultBranchResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetDefaultBranchResponse
 */
export const SetDefaultBranchResponse = new SetDefaultBranchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositorySettingsRequest$Type extends MessageType {
    constructor() {
        super("GetRepositorySettingsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositorySettingsRequest
 */
export const GetRepositorySettingsRequest = new GetRepositorySettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositorySettingsResponse$Type extends MessageType {
    constructor() {
        super("GetRepositorySettingsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "visibility", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "avatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "isArchived", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.name = "";
        message.description = "";
        message.visibility = "";
        message.avatar = "";
        message.isArchived = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string visibility */ 6:
                    message.visibility = reader.string();
                    break;
                case /* string avatar */ 7:
                    message.avatar = reader.string();
                    break;
                case /* bool isArchived */ 8:
                    message.isArchived = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string visibility = 6; */
        if (message.visibility !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.visibility);
        /* string avatar = 7; */
        if (message.avatar !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.avatar);
        /* bool isArchived = 8; */
        if (message.isArchived !== false)
            writer.tag(8, WireType.Varint).bool(message.isArchived);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositorySettingsResponse
 */
export const GetRepositorySettingsResponse = new GetRepositorySettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRepositorySettingsRequest$Type extends MessageType {
    constructor() {
        super("UpdateRepositorySettingsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "newName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "newDescription", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "avatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.newName = "";
        message.newDescription = "";
        message.avatar = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string newName */ 4:
                    message.newName = reader.string();
                    break;
                case /* string newDescription */ 5:
                    message.newDescription = reader.string();
                    break;
                case /* string avatar */ 6:
                    message.avatar = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string newName = 4; */
        if (message.newName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.newName);
        /* string newDescription = 5; */
        if (message.newDescription !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.newDescription);
        /* string avatar = 6; */
        if (message.avatar !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.avatar);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateRepositorySettingsRequest
 */
export const UpdateRepositorySettingsRequest = new UpdateRepositorySettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRepositorySettingsResponse$Type extends MessageType {
    constructor() {
        super("UpdateRepositorySettingsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateRepositorySettingsResponse
 */
export const UpdateRepositorySettingsResponse = new UpdateRepositorySettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRepositoryVisibilityRequest$Type extends MessageType {
    constructor() {
        super("UpdateRepositoryVisibilityRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "visibility", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.visibility = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string visibility */ 4:
                    message.visibility = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string visibility = 4; */
        if (message.visibility !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.visibility);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateRepositoryVisibilityRequest
 */
export const UpdateRepositoryVisibilityRequest = new UpdateRepositoryVisibilityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRepositoryVisibilityResponse$Type extends MessageType {
    constructor() {
        super("UpdateRepositoryVisibilityResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateRepositoryVisibilityResponse
 */
export const UpdateRepositoryVisibilityResponse = new UpdateRepositoryVisibilityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRepositoryRequest$Type extends MessageType {
    constructor() {
        super("DeleteRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteRepositoryRequest
 */
export const DeleteRepositoryRequest = new DeleteRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRepositoryResponse$Type extends MessageType {
    constructor() {
        super("DeleteRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteRepositoryResponse
 */
export const DeleteRepositoryResponse = new DeleteRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArchiveRepositoryRequest$Type extends MessageType {
    constructor() {
        super("ArchiveRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ArchiveRepositoryRequest
 */
export const ArchiveRepositoryRequest = new ArchiveRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ArchiveRepositoryResponse$Type extends MessageType {
    constructor() {
        super("ArchiveRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ArchiveRepositoryResponse
 */
export const ArchiveRepositoryResponse = new ArchiveRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferRepositoryRequest$Type extends MessageType {
    constructor() {
        super("TransferRepositoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "newOwnerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.newOwnerId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string newOwnerId */ 4:
                    message.newOwnerId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string newOwnerId = 4; */
        if (message.newOwnerId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.newOwnerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TransferRepositoryRequest
 */
export const TransferRepositoryRequest = new TransferRepositoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransferRepositoryResponse$Type extends MessageType {
    constructor() {
        super("TransferRepositoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TransferRepositoryResponse
 */
export const TransferRepositoryResponse = new TransferRepositoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessTokenInfo$Type extends MessageType {
    constructor() {
        super("AccessTokenInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 6, name: "lastUsedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.token = "";
        message.scopes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string token */ 3:
                    message.token = reader.string();
                    break;
                case /* repeated string scopes */ 4:
                    message.scopes.push(reader.string());
                    break;
                case /* google.protobuf.Timestamp createdAt */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp lastUsedAt */ 6:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string token = 3; */
        if (message.token !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.token);
        /* repeated string scopes = 4; */
        for (let i = 0; i < message.scopes.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.scopes[i]);
        /* google.protobuf.Timestamp createdAt = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp lastUsedAt = 6; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AccessTokenInfo
 */
export const AccessTokenInfo = new AccessTokenInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessTokensRequest$Type extends MessageType {
    constructor() {
        super("GetAccessTokensRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAccessTokensRequest
 */
export const GetAccessTokensRequest = new GetAccessTokensRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAccessTokensResponse$Type extends MessageType {
    constructor() {
        super("GetAccessTokensResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tokens", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessTokenInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.tokens = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated AccessTokenInfo tokens */ 4:
                    message.tokens.push(AccessTokenInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated AccessTokenInfo tokens = 4; */
        for (let i = 0; i < message.tokens.length; i++)
            AccessTokenInfo.internalBinaryWrite(message.tokens[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAccessTokensResponse
 */
export const GetAccessTokensResponse = new GetAccessTokensResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenRequest$Type extends MessageType {
    constructor() {
        super("CreateAccessTokenRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "scopes", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.name = "";
        message.scopes = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* repeated string scopes */ 5:
                    message.scopes.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* repeated string scopes = 5; */
        for (let i = 0; i < message.scopes.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.scopes[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateAccessTokenRequest
 */
export const CreateAccessTokenRequest = new CreateAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccessTokenResponse$Type extends MessageType {
    constructor() {
        super("CreateAccessTokenResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tokenInfo", kind: "message", T: () => AccessTokenInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* AccessTokenInfo tokenInfo */ 4:
                    message.tokenInfo = AccessTokenInfo.internalBinaryRead(reader, reader.uint32(), options, message.tokenInfo);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* AccessTokenInfo tokenInfo = 4; */
        if (message.tokenInfo)
            AccessTokenInfo.internalBinaryWrite(message.tokenInfo, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateAccessTokenResponse
 */
export const CreateAccessTokenResponse = new CreateAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAccessTokenRequest$Type extends MessageType {
    constructor() {
        super("DeleteAccessTokenRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tokenId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.tokenId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string tokenId */ 4:
                    message.tokenId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string tokenId = 4; */
        if (message.tokenId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tokenId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteAccessTokenRequest
 */
export const DeleteAccessTokenRequest = new DeleteAccessTokenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAccessTokenResponse$Type extends MessageType {
    constructor() {
        super("DeleteAccessTokenResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteAccessTokenResponse
 */
export const DeleteAccessTokenResponse = new DeleteAccessTokenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WebhookInfo$Type extends MessageType {
    constructor() {
        super("WebhookInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "events", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "secret", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "createdAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.url = "";
        message.events = [];
        message.active = false;
        message.secret = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string url */ 2:
                    message.url = reader.string();
                    break;
                case /* repeated string events */ 3:
                    message.events.push(reader.string());
                    break;
                case /* bool active */ 4:
                    message.active = reader.bool();
                    break;
                case /* string secret */ 5:
                    message.secret = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string url = 2; */
        if (message.url !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.url);
        /* repeated string events = 3; */
        for (let i = 0; i < message.events.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.events[i]);
        /* bool active = 4; */
        if (message.active !== false)
            writer.tag(4, WireType.Varint).bool(message.active);
        /* string secret = 5; */
        if (message.secret !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.secret);
        /* google.protobuf.Timestamp createdAt = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message WebhookInfo
 */
export const WebhookInfo = new WebhookInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWebhooksRequest$Type extends MessageType {
    constructor() {
        super("GetWebhooksRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetWebhooksRequest
 */
export const GetWebhooksRequest = new GetWebhooksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWebhooksResponse$Type extends MessageType {
    constructor() {
        super("GetWebhooksResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhooks", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => WebhookInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.webhooks = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated WebhookInfo webhooks */ 4:
                    message.webhooks.push(WebhookInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated WebhookInfo webhooks = 4; */
        for (let i = 0; i < message.webhooks.length; i++)
            WebhookInfo.internalBinaryWrite(message.webhooks[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetWebhooksResponse
 */
export const GetWebhooksResponse = new GetWebhooksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateWebhookRequest$Type extends MessageType {
    constructor() {
        super("CreateWebhookRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "events", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.url = "";
        message.events = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string url */ 4:
                    message.url = reader.string();
                    break;
                case /* repeated string events */ 5:
                    message.events.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string url = 4; */
        if (message.url !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.url);
        /* repeated string events = 5; */
        for (let i = 0; i < message.events.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.events[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateWebhookRequest
 */
export const CreateWebhookRequest = new CreateWebhookRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateWebhookResponse$Type extends MessageType {
    constructor() {
        super("CreateWebhookResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhook", kind: "message", T: () => WebhookInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* WebhookInfo webhook */ 4:
                    message.webhook = WebhookInfo.internalBinaryRead(reader, reader.uint32(), options, message.webhook);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* WebhookInfo webhook = 4; */
        if (message.webhook)
            WebhookInfo.internalBinaryWrite(message.webhook, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateWebhookResponse
 */
export const CreateWebhookResponse = new CreateWebhookResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWebhookRequest$Type extends MessageType {
    constructor() {
        super("UpdateWebhookRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhookId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "events", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.webhookId = "";
        message.url = "";
        message.events = [];
        message.active = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string webhookId */ 4:
                    message.webhookId = reader.string();
                    break;
                case /* string url */ 5:
                    message.url = reader.string();
                    break;
                case /* repeated string events */ 6:
                    message.events.push(reader.string());
                    break;
                case /* bool active */ 7:
                    message.active = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string webhookId = 4; */
        if (message.webhookId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookId);
        /* string url = 5; */
        if (message.url !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.url);
        /* repeated string events = 6; */
        for (let i = 0; i < message.events.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.events[i]);
        /* bool active = 7; */
        if (message.active !== false)
            writer.tag(7, WireType.Varint).bool(message.active);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateWebhookRequest
 */
export const UpdateWebhookRequest = new UpdateWebhookRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWebhookResponse$Type extends MessageType {
    constructor() {
        super("UpdateWebhookResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateWebhookResponse
 */
export const UpdateWebhookResponse = new UpdateWebhookResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteWebhookRequest$Type extends MessageType {
    constructor() {
        super("DeleteWebhookRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "webhookId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.webhookId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string webhookId */ 4:
                    message.webhookId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string webhookId = 4; */
        if (message.webhookId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.webhookId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteWebhookRequest
 */
export const DeleteWebhookRequest = new DeleteWebhookRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteWebhookResponse$Type extends MessageType {
    constructor() {
        super("DeleteWebhookResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteWebhookResponse
 */
export const DeleteWebhookResponse = new DeleteWebhookResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RepositoryMemberInfo$Type extends MessageType {
    constructor() {
        super("RepositoryMemberInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "avatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "addedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userId = "";
        message.username = "";
        message.email = "";
        message.role = "";
        message.avatar = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string userId */ 2:
                    message.userId = reader.string();
                    break;
                case /* string username */ 3:
                    message.username = reader.string();
                    break;
                case /* string email */ 4:
                    message.email = reader.string();
                    break;
                case /* string role */ 5:
                    message.role = reader.string();
                    break;
                case /* string avatar */ 6:
                    message.avatar = reader.string();
                    break;
                case /* google.protobuf.Timestamp addedAt */ 7:
                    message.addedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.addedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string userId = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string username = 3; */
        if (message.username !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.username);
        /* string email = 4; */
        if (message.email !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* string role = 5; */
        if (message.role !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.role);
        /* string avatar = 6; */
        if (message.avatar !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.avatar);
        /* google.protobuf.Timestamp addedAt = 7; */
        if (message.addedAt)
            Timestamp.internalBinaryWrite(message.addedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RepositoryMemberInfo
 */
export const RepositoryMemberInfo = new RepositoryMemberInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryMembersRequest$Type extends MessageType {
    constructor() {
        super("GetRepositoryMembersRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryMembersRequest
 */
export const GetRepositoryMembersRequest = new GetRepositoryMembersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryMembersResponse$Type extends MessageType {
    constructor() {
        super("GetRepositoryMembersResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "members", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositoryMemberInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.members = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated RepositoryMemberInfo members */ 4:
                    message.members.push(RepositoryMemberInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated RepositoryMemberInfo members = 4; */
        for (let i = 0; i < message.members.length; i++)
            RepositoryMemberInfo.internalBinaryWrite(message.members[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryMembersResponse
 */
export const GetRepositoryMembersResponse = new GetRepositoryMembersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddRepositoryMemberRequest$Type extends MessageType {
    constructor() {
        super("AddRepositoryMemberRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "userEmail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "role", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.userEmail = "";
        message.role = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string userEmail */ 4:
                    message.userEmail = reader.string();
                    break;
                case /* string role */ 5:
                    message.role = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string userEmail = 4; */
        if (message.userEmail !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userEmail);
        /* string role = 5; */
        if (message.role !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.role);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddRepositoryMemberRequest
 */
export const AddRepositoryMemberRequest = new AddRepositoryMemberRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddRepositoryMemberResponse$Type extends MessageType {
    constructor() {
        super("AddRepositoryMemberResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "member", kind: "message", T: () => RepositoryMemberInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* RepositoryMemberInfo member */ 4:
                    message.member = RepositoryMemberInfo.internalBinaryRead(reader, reader.uint32(), options, message.member);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* RepositoryMemberInfo member = 4; */
        if (message.member)
            RepositoryMemberInfo.internalBinaryWrite(message.member, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddRepositoryMemberResponse
 */
export const AddRepositoryMemberResponse = new AddRepositoryMemberResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMemberRoleRequest$Type extends MessageType {
    constructor() {
        super("UpdateMemberRoleRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "memberId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "newRole", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.memberId = "";
        message.newRole = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string memberId */ 4:
                    message.memberId = reader.string();
                    break;
                case /* string newRole */ 5:
                    message.newRole = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string memberId = 4; */
        if (message.memberId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.memberId);
        /* string newRole = 5; */
        if (message.newRole !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.newRole);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMemberRoleRequest
 */
export const UpdateMemberRoleRequest = new UpdateMemberRoleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateMemberRoleResponse$Type extends MessageType {
    constructor() {
        super("UpdateMemberRoleResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateMemberRoleResponse
 */
export const UpdateMemberRoleResponse = new UpdateMemberRoleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveRepositoryMemberRequest$Type extends MessageType {
    constructor() {
        super("RemoveRepositoryMemberRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "memberId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.memberId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string memberId */ 4:
                    message.memberId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string memberId = 4; */
        if (message.memberId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.memberId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveRepositoryMemberRequest
 */
export const RemoveRepositoryMemberRequest = new RemoveRepositoryMemberRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveRepositoryMemberResponse$Type extends MessageType {
    constructor() {
        super("RemoveRepositoryMemberResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RemoveRepositoryMemberResponse
 */
export const RemoveRepositoryMemberResponse = new RemoveRepositoryMemberResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RepositorySecretInfo$Type extends MessageType {
    constructor() {
        super("RepositorySecretInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 4, name: "updatedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Timestamp createdAt = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RepositorySecretInfo
 */
export const RepositorySecretInfo = new RepositorySecretInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositorySecretsRequest$Type extends MessageType {
    constructor() {
        super("GetRepositorySecretsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositorySecretsRequest
 */
export const GetRepositorySecretsRequest = new GetRepositorySecretsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositorySecretsResponse$Type extends MessageType {
    constructor() {
        super("GetRepositorySecretsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "secrets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositorySecretInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.secrets = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated RepositorySecretInfo secrets */ 4:
                    message.secrets.push(RepositorySecretInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated RepositorySecretInfo secrets = 4; */
        for (let i = 0; i < message.secrets.length; i++)
            RepositorySecretInfo.internalBinaryWrite(message.secrets[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositorySecretsResponse
 */
export const GetRepositorySecretsResponse = new GetRepositorySecretsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRepositorySecretRequest$Type extends MessageType {
    constructor() {
        super("CreateRepositorySecretRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.name = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string value */ 5:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string value = 5; */
        if (message.value !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateRepositorySecretRequest
 */
export const CreateRepositorySecretRequest = new CreateRepositorySecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateRepositorySecretResponse$Type extends MessageType {
    constructor() {
        super("CreateRepositorySecretResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "secret", kind: "message", T: () => RepositorySecretInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* RepositorySecretInfo secret */ 4:
                    message.secret = RepositorySecretInfo.internalBinaryRead(reader, reader.uint32(), options, message.secret);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* RepositorySecretInfo secret = 4; */
        if (message.secret)
            RepositorySecretInfo.internalBinaryWrite(message.secret, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateRepositorySecretResponse
 */
export const CreateRepositorySecretResponse = new CreateRepositorySecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRepositorySecretRequest$Type extends MessageType {
    constructor() {
        super("UpdateRepositorySecretRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "secretId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.secretId = "";
        message.value = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string secretId */ 4:
                    message.secretId = reader.string();
                    break;
                case /* string value */ 5:
                    message.value = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string secretId = 4; */
        if (message.secretId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.secretId);
        /* string value = 5; */
        if (message.value !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateRepositorySecretRequest
 */
export const UpdateRepositorySecretRequest = new UpdateRepositorySecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateRepositorySecretResponse$Type extends MessageType {
    constructor() {
        super("UpdateRepositorySecretResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateRepositorySecretResponse
 */
export const UpdateRepositorySecretResponse = new UpdateRepositorySecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRepositorySecretRequest$Type extends MessageType {
    constructor() {
        super("DeleteRepositorySecretRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "secretId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.secretId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string secretId */ 4:
                    message.secretId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string secretId = 4; */
        if (message.secretId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.secretId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteRepositorySecretRequest
 */
export const DeleteRepositorySecretRequest = new DeleteRepositorySecretRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteRepositorySecretResponse$Type extends MessageType {
    constructor() {
        super("DeleteRepositorySecretResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteRepositorySecretResponse
 */
export const DeleteRepositorySecretResponse = new DeleteRepositorySecretResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryUsageRequest$Type extends MessageType {
    constructor() {
        super("GetRepositoryUsageRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryUsageRequest
 */
export const GetRepositoryUsageRequest = new GetRepositoryUsageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryUsageResponse$Type extends MessageType {
    constructor() {
        super("GetRepositoryUsageResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "storageUsedMB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "storageLimitMB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "bandwidthUsedGB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "bandwidthLimitGB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 8, name: "gitLfsStorageMB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "codeRepositoryMB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "buildArtifactsMB", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.storageUsedMB = 0;
        message.storageLimitMB = 0;
        message.bandwidthUsedGB = 0;
        message.bandwidthLimitGB = 0;
        message.gitLfsStorageMB = 0;
        message.codeRepositoryMB = 0;
        message.buildArtifactsMB = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* double storageUsedMB */ 4:
                    message.storageUsedMB = reader.double();
                    break;
                case /* double storageLimitMB */ 5:
                    message.storageLimitMB = reader.double();
                    break;
                case /* double bandwidthUsedGB */ 6:
                    message.bandwidthUsedGB = reader.double();
                    break;
                case /* double bandwidthLimitGB */ 7:
                    message.bandwidthLimitGB = reader.double();
                    break;
                case /* double gitLfsStorageMB */ 8:
                    message.gitLfsStorageMB = reader.double();
                    break;
                case /* double codeRepositoryMB */ 9:
                    message.codeRepositoryMB = reader.double();
                    break;
                case /* double buildArtifactsMB */ 10:
                    message.buildArtifactsMB = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* double storageUsedMB = 4; */
        if (message.storageUsedMB !== 0)
            writer.tag(4, WireType.Bit64).double(message.storageUsedMB);
        /* double storageLimitMB = 5; */
        if (message.storageLimitMB !== 0)
            writer.tag(5, WireType.Bit64).double(message.storageLimitMB);
        /* double bandwidthUsedGB = 6; */
        if (message.bandwidthUsedGB !== 0)
            writer.tag(6, WireType.Bit64).double(message.bandwidthUsedGB);
        /* double bandwidthLimitGB = 7; */
        if (message.bandwidthLimitGB !== 0)
            writer.tag(7, WireType.Bit64).double(message.bandwidthLimitGB);
        /* double gitLfsStorageMB = 8; */
        if (message.gitLfsStorageMB !== 0)
            writer.tag(8, WireType.Bit64).double(message.gitLfsStorageMB);
        /* double codeRepositoryMB = 9; */
        if (message.codeRepositoryMB !== 0)
            writer.tag(9, WireType.Bit64).double(message.codeRepositoryMB);
        /* double buildArtifactsMB = 10; */
        if (message.buildArtifactsMB !== 0)
            writer.tag(10, WireType.Bit64).double(message.buildArtifactsMB);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryUsageResponse
 */
export const GetRepositoryUsageResponse = new GetRepositoryUsageResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReleaseAssetInfo$Type extends MessageType {
    constructor() {
        super("ReleaseAssetInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "releaseId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "contentType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "sizeBytes", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "downloadCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "downloadUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "uploadedAt", kind: "message", T: () => Timestamp },
            { no: 10, name: "uploaderId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "uploaderName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.releaseId = "";
        message.name = "";
        message.label = "";
        message.contentType = "";
        message.sizeBytes = 0n;
        message.downloadCount = 0;
        message.downloadUrl = "";
        message.uploaderId = "";
        message.uploaderName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string releaseId */ 2:
                    message.releaseId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string label */ 4:
                    message.label = reader.string();
                    break;
                case /* string contentType */ 5:
                    message.contentType = reader.string();
                    break;
                case /* int64 sizeBytes */ 6:
                    message.sizeBytes = reader.int64().toBigInt();
                    break;
                case /* int32 downloadCount */ 7:
                    message.downloadCount = reader.int32();
                    break;
                case /* string downloadUrl */ 8:
                    message.downloadUrl = reader.string();
                    break;
                case /* google.protobuf.Timestamp uploadedAt */ 9:
                    message.uploadedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.uploadedAt);
                    break;
                case /* string uploaderId */ 10:
                    message.uploaderId = reader.string();
                    break;
                case /* string uploaderName */ 11:
                    message.uploaderName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string releaseId = 2; */
        if (message.releaseId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.releaseId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string label = 4; */
        if (message.label !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.label);
        /* string contentType = 5; */
        if (message.contentType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.contentType);
        /* int64 sizeBytes = 6; */
        if (message.sizeBytes !== 0n)
            writer.tag(6, WireType.Varint).int64(message.sizeBytes);
        /* int32 downloadCount = 7; */
        if (message.downloadCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.downloadCount);
        /* string downloadUrl = 8; */
        if (message.downloadUrl !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.downloadUrl);
        /* google.protobuf.Timestamp uploadedAt = 9; */
        if (message.uploadedAt)
            Timestamp.internalBinaryWrite(message.uploadedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* string uploaderId = 10; */
        if (message.uploaderId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.uploaderId);
        /* string uploaderName = 11; */
        if (message.uploaderName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.uploaderName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReleaseAssetInfo
 */
export const ReleaseAssetInfo = new ReleaseAssetInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReleaseInfo$Type extends MessageType {
    constructor() {
        super("ReleaseInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tagName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "releaseName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "authorId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "authorName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "authorAvatar", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "isPrerelease", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "isDraft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "targetCommitish", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "assetCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 14, name: "publishedAt", kind: "message", T: () => Timestamp },
            { no: 15, name: "assets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReleaseAssetInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.repositoryId = "";
        message.tagName = "";
        message.releaseName = "";
        message.description = "";
        message.authorId = "";
        message.authorName = "";
        message.authorAvatar = "";
        message.isPrerelease = false;
        message.isDraft = false;
        message.targetCommitish = "";
        message.assetCount = 0;
        message.assets = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* string tagName */ 3:
                    message.tagName = reader.string();
                    break;
                case /* string releaseName */ 4:
                    message.releaseName = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string authorId */ 6:
                    message.authorId = reader.string();
                    break;
                case /* string authorName */ 7:
                    message.authorName = reader.string();
                    break;
                case /* string authorAvatar */ 8:
                    message.authorAvatar = reader.string();
                    break;
                case /* bool isPrerelease */ 9:
                    message.isPrerelease = reader.bool();
                    break;
                case /* bool isDraft */ 10:
                    message.isDraft = reader.bool();
                    break;
                case /* string targetCommitish */ 11:
                    message.targetCommitish = reader.string();
                    break;
                case /* int32 assetCount */ 12:
                    message.assetCount = reader.int32();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 13:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp publishedAt */ 14:
                    message.publishedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.publishedAt);
                    break;
                case /* repeated ReleaseAssetInfo assets */ 15:
                    message.assets.push(ReleaseAssetInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* string tagName = 3; */
        if (message.tagName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tagName);
        /* string releaseName = 4; */
        if (message.releaseName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.releaseName);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string authorId = 6; */
        if (message.authorId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.authorId);
        /* string authorName = 7; */
        if (message.authorName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.authorName);
        /* string authorAvatar = 8; */
        if (message.authorAvatar !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.authorAvatar);
        /* bool isPrerelease = 9; */
        if (message.isPrerelease !== false)
            writer.tag(9, WireType.Varint).bool(message.isPrerelease);
        /* bool isDraft = 10; */
        if (message.isDraft !== false)
            writer.tag(10, WireType.Varint).bool(message.isDraft);
        /* string targetCommitish = 11; */
        if (message.targetCommitish !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.targetCommitish);
        /* int32 assetCount = 12; */
        if (message.assetCount !== 0)
            writer.tag(12, WireType.Varint).int32(message.assetCount);
        /* google.protobuf.Timestamp createdAt = 13; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp publishedAt = 14; */
        if (message.publishedAt)
            Timestamp.internalBinaryWrite(message.publishedAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated ReleaseAssetInfo assets = 15; */
        for (let i = 0; i < message.assets.length; i++)
            ReleaseAssetInfo.internalBinaryWrite(message.assets[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReleaseInfo
 */
export const ReleaseInfo = new ReleaseInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateReleaseRequest$Type extends MessageType {
    constructor() {
        super("CreateReleaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tagName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "releaseName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "targetCommitish", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "isPrerelease", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "isDraft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.tagName = "";
        message.releaseName = "";
        message.description = "";
        message.targetCommitish = "";
        message.isPrerelease = false;
        message.isDraft = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string tagName */ 4:
                    message.tagName = reader.string();
                    break;
                case /* string releaseName */ 5:
                    message.releaseName = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* string targetCommitish */ 7:
                    message.targetCommitish = reader.string();
                    break;
                case /* bool isPrerelease */ 8:
                    message.isPrerelease = reader.bool();
                    break;
                case /* bool isDraft */ 9:
                    message.isDraft = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string tagName = 4; */
        if (message.tagName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tagName);
        /* string releaseName = 5; */
        if (message.releaseName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.releaseName);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* string targetCommitish = 7; */
        if (message.targetCommitish !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.targetCommitish);
        /* bool isPrerelease = 8; */
        if (message.isPrerelease !== false)
            writer.tag(8, WireType.Varint).bool(message.isPrerelease);
        /* bool isDraft = 9; */
        if (message.isDraft !== false)
            writer.tag(9, WireType.Varint).bool(message.isDraft);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateReleaseRequest
 */
export const CreateReleaseRequest = new CreateReleaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateReleaseResponse$Type extends MessageType {
    constructor() {
        super("CreateReleaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "release", kind: "message", T: () => ReleaseInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* ReleaseInfo release */ 4:
                    message.release = ReleaseInfo.internalBinaryRead(reader, reader.uint32(), options, message.release);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* ReleaseInfo release = 4; */
        if (message.release)
            ReleaseInfo.internalBinaryWrite(message.release, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateReleaseResponse
 */
export const CreateReleaseResponse = new CreateReleaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReleasesRequest$Type extends MessageType {
    constructor() {
        super("GetReleasesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "includeDrafts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.includeDrafts = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* bool includeDrafts */ 4:
                    message.includeDrafts = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* bool includeDrafts = 4; */
        if (message.includeDrafts !== false)
            writer.tag(4, WireType.Varint).bool(message.includeDrafts);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetReleasesRequest
 */
export const GetReleasesRequest = new GetReleasesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReleasesResponse$Type extends MessageType {
    constructor() {
        super("GetReleasesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "releases", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReleaseInfo },
            { no: 5, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.releases = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated ReleaseInfo releases */ 4:
                    message.releases.push(ReleaseInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 totalCount */ 5:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated ReleaseInfo releases = 4; */
        for (let i = 0; i < message.releases.length; i++)
            ReleaseInfo.internalBinaryWrite(message.releases[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 totalCount = 5; */
        if (message.totalCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetReleasesResponse
 */
export const GetReleasesResponse = new GetReleasesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReleaseRequest$Type extends MessageType {
    constructor() {
        super("GetReleaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tagName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.tagName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string tagName */ 4:
                    message.tagName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string tagName = 4; */
        if (message.tagName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tagName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetReleaseRequest
 */
export const GetReleaseRequest = new GetReleaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetReleaseResponse$Type extends MessageType {
    constructor() {
        super("GetReleaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "release", kind: "message", T: () => ReleaseInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* ReleaseInfo release */ 4:
                    message.release = ReleaseInfo.internalBinaryRead(reader, reader.uint32(), options, message.release);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* ReleaseInfo release = 4; */
        if (message.release)
            ReleaseInfo.internalBinaryWrite(message.release, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetReleaseResponse
 */
export const GetReleaseResponse = new GetReleaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReleaseRequest$Type extends MessageType {
    constructor() {
        super("UpdateReleaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tagName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "releaseName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "isPrerelease", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "isDraft", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.tagName = "";
        message.releaseName = "";
        message.description = "";
        message.isPrerelease = false;
        message.isDraft = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string tagName */ 4:
                    message.tagName = reader.string();
                    break;
                case /* string releaseName */ 5:
                    message.releaseName = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* bool isPrerelease */ 7:
                    message.isPrerelease = reader.bool();
                    break;
                case /* bool isDraft */ 8:
                    message.isDraft = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string tagName = 4; */
        if (message.tagName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tagName);
        /* string releaseName = 5; */
        if (message.releaseName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.releaseName);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* bool isPrerelease = 7; */
        if (message.isPrerelease !== false)
            writer.tag(7, WireType.Varint).bool(message.isPrerelease);
        /* bool isDraft = 8; */
        if (message.isDraft !== false)
            writer.tag(8, WireType.Varint).bool(message.isDraft);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateReleaseRequest
 */
export const UpdateReleaseRequest = new UpdateReleaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateReleaseResponse$Type extends MessageType {
    constructor() {
        super("UpdateReleaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "release", kind: "message", T: () => ReleaseInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* ReleaseInfo release */ 4:
                    message.release = ReleaseInfo.internalBinaryRead(reader, reader.uint32(), options, message.release);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* ReleaseInfo release = 4; */
        if (message.release)
            ReleaseInfo.internalBinaryWrite(message.release, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UpdateReleaseResponse
 */
export const UpdateReleaseResponse = new UpdateReleaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteReleaseRequest$Type extends MessageType {
    constructor() {
        super("DeleteReleaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tagName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.tagName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string tagName */ 4:
                    message.tagName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string tagName = 4; */
        if (message.tagName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tagName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteReleaseRequest
 */
export const DeleteReleaseRequest = new DeleteReleaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteReleaseResponse$Type extends MessageType {
    constructor() {
        super("DeleteReleaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteReleaseResponse
 */
export const DeleteReleaseResponse = new DeleteReleaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadReleaseAssetRequest$Type extends MessageType {
    constructor() {
        super("UploadReleaseAssetRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "tagName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "assetName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "contentType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.tagName = "";
        message.assetName = "";
        message.label = "";
        message.contentType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string tagName */ 4:
                    message.tagName = reader.string();
                    break;
                case /* string assetName */ 5:
                    message.assetName = reader.string();
                    break;
                case /* string label */ 6:
                    message.label = reader.string();
                    break;
                case /* string contentType */ 7:
                    message.contentType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string tagName = 4; */
        if (message.tagName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.tagName);
        /* string assetName = 5; */
        if (message.assetName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.assetName);
        /* string label = 6; */
        if (message.label !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.label);
        /* string contentType = 7; */
        if (message.contentType !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.contentType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadReleaseAssetRequest
 */
export const UploadReleaseAssetRequest = new UploadReleaseAssetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UploadReleaseAssetResponse$Type extends MessageType {
    constructor() {
        super("UploadReleaseAssetResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "asset", kind: "message", T: () => ReleaseAssetInfo },
            { no: 5, name: "uploadUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.uploadUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* ReleaseAssetInfo asset */ 4:
                    message.asset = ReleaseAssetInfo.internalBinaryRead(reader, reader.uint32(), options, message.asset);
                    break;
                case /* string uploadUrl */ 5:
                    message.uploadUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* ReleaseAssetInfo asset = 4; */
        if (message.asset)
            ReleaseAssetInfo.internalBinaryWrite(message.asset, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string uploadUrl = 5; */
        if (message.uploadUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.uploadUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message UploadReleaseAssetResponse
 */
export const UploadReleaseAssetResponse = new UploadReleaseAssetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteReleaseAssetRequest$Type extends MessageType {
    constructor() {
        super("DeleteReleaseAssetRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "assetId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        message.assetId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                case /* string assetId */ 4:
                    message.assetId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        /* string assetId = 4; */
        if (message.assetId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.assetId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteReleaseAssetRequest
 */
export const DeleteReleaseAssetRequest = new DeleteReleaseAssetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteReleaseAssetResponse$Type extends MessageType {
    constructor() {
        super("DeleteReleaseAssetResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteReleaseAssetResponse
 */
export const DeleteReleaseAssetResponse = new DeleteReleaseAssetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetupWorkspaceRequest$Type extends MessageType {
    constructor() {
        super("SetupWorkspaceRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.ownerId = "";
        message.repositoryName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string repositoryName */ 3:
                    message.repositoryName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string repositoryName = 3; */
        if (message.repositoryName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.repositoryName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetupWorkspaceRequest
 */
export const SetupWorkspaceRequest = new SetupWorkspaceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetupWorkspaceResponse$Type extends MessageType {
    constructor() {
        super("SetupWorkspaceResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "workspaceUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.workspaceUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string workspaceUrl */ 4:
                    message.workspaceUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string workspaceUrl = 4; */
        if (message.workspaceUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.workspaceUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SetupWorkspaceResponse
 */
export const SetupWorkspaceResponse = new SetupWorkspaceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionInfo$Type extends MessageType {
    constructor() {
        super("SessionInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "deviceName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "browserName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "osName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "ipAddress", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 8, name: "lastAccessedAt", kind: "message", T: () => Timestamp },
            { no: 9, name: "isCurrent", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "userEmail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "isActive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.deviceName = "";
        message.browserName = "";
        message.osName = "";
        message.ipAddress = "";
        message.location = "";
        message.isCurrent = false;
        message.userId = "";
        message.userEmail = "";
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string deviceName */ 2:
                    message.deviceName = reader.string();
                    break;
                case /* string browserName */ 3:
                    message.browserName = reader.string();
                    break;
                case /* string osName */ 4:
                    message.osName = reader.string();
                    break;
                case /* string ipAddress */ 5:
                    message.ipAddress = reader.string();
                    break;
                case /* string location */ 6:
                    message.location = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp lastAccessedAt */ 8:
                    message.lastAccessedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastAccessedAt);
                    break;
                case /* bool isCurrent */ 9:
                    message.isCurrent = reader.bool();
                    break;
                case /* string userId */ 10:
                    message.userId = reader.string();
                    break;
                case /* string userEmail */ 11:
                    message.userEmail = reader.string();
                    break;
                case /* bool isActive */ 12:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string deviceName = 2; */
        if (message.deviceName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.deviceName);
        /* string browserName = 3; */
        if (message.browserName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.browserName);
        /* string osName = 4; */
        if (message.osName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.osName);
        /* string ipAddress = 5; */
        if (message.ipAddress !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.ipAddress);
        /* string location = 6; */
        if (message.location !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.location);
        /* google.protobuf.Timestamp createdAt = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp lastAccessedAt = 8; */
        if (message.lastAccessedAt)
            Timestamp.internalBinaryWrite(message.lastAccessedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool isCurrent = 9; */
        if (message.isCurrent !== false)
            writer.tag(9, WireType.Varint).bool(message.isCurrent);
        /* string userId = 10; */
        if (message.userId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.userId);
        /* string userEmail = 11; */
        if (message.userEmail !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.userEmail);
        /* bool isActive = 12; */
        if (message.isActive !== false)
            writer.tag(12, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SessionInfo
 */
export const SessionInfo = new SessionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSessionsRequest$Type extends MessageType {
    constructor() {
        super("GetUserSessionsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserSessionsRequest
 */
export const GetUserSessionsRequest = new GetUserSessionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSessionsResponse$Type extends MessageType {
    constructor() {
        super("GetUserSessionsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sessions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SessionInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.sessions = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated SessionInfo sessions */ 4:
                    message.sessions.push(SessionInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated SessionInfo sessions = 4; */
        for (let i = 0; i < message.sessions.length; i++)
            SessionInfo.internalBinaryWrite(message.sessions[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserSessionsResponse
 */
export const GetUserSessionsResponse = new GetUserSessionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeSessionRequest$Type extends MessageType {
    constructor() {
        super("RevokeSessionRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.sessionId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string sessionId */ 2:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string sessionId = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeSessionRequest
 */
export const RevokeSessionRequest = new RevokeSessionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeSessionResponse$Type extends MessageType {
    constructor() {
        super("RevokeSessionResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeSessionResponse
 */
export const RevokeSessionResponse = new RevokeSessionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeAllSessionsRequest$Type extends MessageType {
    constructor() {
        super("RevokeAllSessionsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeAllSessionsRequest
 */
export const RevokeAllSessionsRequest = new RevokeAllSessionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeAllSessionsResponse$Type extends MessageType {
    constructor() {
        super("RevokeAllSessionsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeAllSessionsResponse
 */
export const RevokeAllSessionsResponse = new RevokeAllSessionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillingPlanInfo$Type extends MessageType {
    constructor() {
        super("BillingPlanInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "displayName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "priceMonthly", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "priceYearly", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "storageLimitMb", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 8, name: "bandwidthLimitGb", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "features", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "isActive", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.name = "";
        message.displayName = "";
        message.priceMonthly = 0;
        message.priceYearly = 0;
        message.currency = "";
        message.storageLimitMb = 0n;
        message.bandwidthLimitGb = 0;
        message.features = [];
        message.isActive = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string displayName */ 3:
                    message.displayName = reader.string();
                    break;
                case /* double priceMonthly */ 4:
                    message.priceMonthly = reader.double();
                    break;
                case /* double priceYearly */ 5:
                    message.priceYearly = reader.double();
                    break;
                case /* string currency */ 6:
                    message.currency = reader.string();
                    break;
                case /* int64 storageLimitMb */ 7:
                    message.storageLimitMb = reader.int64().toBigInt();
                    break;
                case /* double bandwidthLimitGb */ 8:
                    message.bandwidthLimitGb = reader.double();
                    break;
                case /* repeated string features */ 9:
                    message.features.push(reader.string());
                    break;
                case /* bool isActive */ 10:
                    message.isActive = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string displayName = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* double priceMonthly = 4; */
        if (message.priceMonthly !== 0)
            writer.tag(4, WireType.Bit64).double(message.priceMonthly);
        /* double priceYearly = 5; */
        if (message.priceYearly !== 0)
            writer.tag(5, WireType.Bit64).double(message.priceYearly);
        /* string currency = 6; */
        if (message.currency !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.currency);
        /* int64 storageLimitMb = 7; */
        if (message.storageLimitMb !== 0n)
            writer.tag(7, WireType.Varint).int64(message.storageLimitMb);
        /* double bandwidthLimitGb = 8; */
        if (message.bandwidthLimitGb !== 0)
            writer.tag(8, WireType.Bit64).double(message.bandwidthLimitGb);
        /* repeated string features = 9; */
        for (let i = 0; i < message.features.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.features[i]);
        /* bool isActive = 10; */
        if (message.isActive !== false)
            writer.tag(10, WireType.Varint).bool(message.isActive);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BillingPlanInfo
 */
export const BillingPlanInfo = new BillingPlanInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubscriptionInfo$Type extends MessageType {
    constructor() {
        super("SubscriptionInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "plan", kind: "message", T: () => BillingPlanInfo },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "billingInterval", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "currentPeriodStart", kind: "message", T: () => Timestamp },
            { no: 7, name: "currentPeriodEnd", kind: "message", T: () => Timestamp },
            { no: 8, name: "cancelAtPeriodEnd", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "createdAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userId = "";
        message.status = "";
        message.billingInterval = "";
        message.cancelAtPeriodEnd = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string userId */ 2:
                    message.userId = reader.string();
                    break;
                case /* BillingPlanInfo plan */ 3:
                    message.plan = BillingPlanInfo.internalBinaryRead(reader, reader.uint32(), options, message.plan);
                    break;
                case /* string status */ 4:
                    message.status = reader.string();
                    break;
                case /* string billingInterval */ 5:
                    message.billingInterval = reader.string();
                    break;
                case /* google.protobuf.Timestamp currentPeriodStart */ 6:
                    message.currentPeriodStart = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.currentPeriodStart);
                    break;
                case /* google.protobuf.Timestamp currentPeriodEnd */ 7:
                    message.currentPeriodEnd = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.currentPeriodEnd);
                    break;
                case /* bool cancelAtPeriodEnd */ 8:
                    message.cancelAtPeriodEnd = reader.bool();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 9:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string userId = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* BillingPlanInfo plan = 3; */
        if (message.plan)
            BillingPlanInfo.internalBinaryWrite(message.plan, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string status = 4; */
        if (message.status !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.status);
        /* string billingInterval = 5; */
        if (message.billingInterval !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.billingInterval);
        /* google.protobuf.Timestamp currentPeriodStart = 6; */
        if (message.currentPeriodStart)
            Timestamp.internalBinaryWrite(message.currentPeriodStart, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp currentPeriodEnd = 7; */
        if (message.currentPeriodEnd)
            Timestamp.internalBinaryWrite(message.currentPeriodEnd, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool cancelAtPeriodEnd = 8; */
        if (message.cancelAtPeriodEnd !== false)
            writer.tag(8, WireType.Varint).bool(message.cancelAtPeriodEnd);
        /* google.protobuf.Timestamp createdAt = 9; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SubscriptionInfo
 */
export const SubscriptionInfo = new SubscriptionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentTransactionInfo$Type extends MessageType {
    constructor() {
        super("PaymentTransactionInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "paymentMethod", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "paymentProvider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "providerReference", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 9, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "userEmail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "invoiceNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.amount = 0;
        message.currency = "";
        message.status = "";
        message.paymentMethod = "";
        message.paymentProvider = "";
        message.providerReference = "";
        message.userId = "";
        message.userEmail = "";
        message.invoiceNumber = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* double amount */ 2:
                    message.amount = reader.double();
                    break;
                case /* string currency */ 3:
                    message.currency = reader.string();
                    break;
                case /* string status */ 4:
                    message.status = reader.string();
                    break;
                case /* string paymentMethod */ 5:
                    message.paymentMethod = reader.string();
                    break;
                case /* string paymentProvider */ 6:
                    message.paymentProvider = reader.string();
                    break;
                case /* string providerReference */ 7:
                    message.providerReference = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string userId */ 9:
                    message.userId = reader.string();
                    break;
                case /* string userEmail */ 10:
                    message.userEmail = reader.string();
                    break;
                case /* string invoiceNumber */ 11:
                    message.invoiceNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* double amount = 2; */
        if (message.amount !== 0)
            writer.tag(2, WireType.Bit64).double(message.amount);
        /* string currency = 3; */
        if (message.currency !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.currency);
        /* string status = 4; */
        if (message.status !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.status);
        /* string paymentMethod = 5; */
        if (message.paymentMethod !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.paymentMethod);
        /* string paymentProvider = 6; */
        if (message.paymentProvider !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.paymentProvider);
        /* string providerReference = 7; */
        if (message.providerReference !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.providerReference);
        /* google.protobuf.Timestamp createdAt = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* string userId = 9; */
        if (message.userId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.userId);
        /* string userEmail = 10; */
        if (message.userEmail !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.userEmail);
        /* string invoiceNumber = 11; */
        if (message.invoiceNumber !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.invoiceNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PaymentTransactionInfo
 */
export const PaymentTransactionInfo = new PaymentTransactionInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceInfo$Type extends MessageType {
    constructor() {
        super("InvoiceInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "invoiceNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "currency", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "issuedAt", kind: "message", T: () => Timestamp },
            { no: 8, name: "paidAt", kind: "message", T: () => Timestamp },
            { no: 9, name: "billingPeriodStart", kind: "message", T: () => Timestamp },
            { no: 10, name: "billingPeriodEnd", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.invoiceNumber = "";
        message.amount = 0;
        message.currency = "";
        message.description = "";
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string invoiceNumber */ 2:
                    message.invoiceNumber = reader.string();
                    break;
                case /* double amount */ 3:
                    message.amount = reader.double();
                    break;
                case /* string currency */ 4:
                    message.currency = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string status */ 6:
                    message.status = reader.string();
                    break;
                case /* google.protobuf.Timestamp issuedAt */ 7:
                    message.issuedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.issuedAt);
                    break;
                case /* google.protobuf.Timestamp paidAt */ 8:
                    message.paidAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.paidAt);
                    break;
                case /* google.protobuf.Timestamp billingPeriodStart */ 9:
                    message.billingPeriodStart = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.billingPeriodStart);
                    break;
                case /* google.protobuf.Timestamp billingPeriodEnd */ 10:
                    message.billingPeriodEnd = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.billingPeriodEnd);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string invoiceNumber = 2; */
        if (message.invoiceNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invoiceNumber);
        /* double amount = 3; */
        if (message.amount !== 0)
            writer.tag(3, WireType.Bit64).double(message.amount);
        /* string currency = 4; */
        if (message.currency !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.currency);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string status = 6; */
        if (message.status !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.status);
        /* google.protobuf.Timestamp issuedAt = 7; */
        if (message.issuedAt)
            Timestamp.internalBinaryWrite(message.issuedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp paidAt = 8; */
        if (message.paidAt)
            Timestamp.internalBinaryWrite(message.paidAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp billingPeriodStart = 9; */
        if (message.billingPeriodStart)
            Timestamp.internalBinaryWrite(message.billingPeriodStart, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp billingPeriodEnd = 10; */
        if (message.billingPeriodEnd)
            Timestamp.internalBinaryWrite(message.billingPeriodEnd, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceInfo
 */
export const InvoiceInfo = new InvoiceInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillingPlansRequest$Type extends MessageType {
    constructor() {
        super("GetBillingPlansRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBillingPlansRequest
 */
export const GetBillingPlansRequest = new GetBillingPlansRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetBillingPlansResponse$Type extends MessageType {
    constructor() {
        super("GetBillingPlansResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "plans", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BillingPlanInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.plans = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated BillingPlanInfo plans */ 4:
                    message.plans.push(BillingPlanInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated BillingPlanInfo plans = 4; */
        for (let i = 0; i < message.plans.length; i++)
            BillingPlanInfo.internalBinaryWrite(message.plans[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetBillingPlansResponse
 */
export const GetBillingPlansResponse = new GetBillingPlansResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSubscriptionRequest$Type extends MessageType {
    constructor() {
        super("GetUserSubscriptionRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserSubscriptionRequest
 */
export const GetUserSubscriptionRequest = new GetUserSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserSubscriptionResponse$Type extends MessageType {
    constructor() {
        super("GetUserSubscriptionResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subscription", kind: "message", T: () => SubscriptionInfo },
            { no: 5, name: "currentPlan", kind: "message", T: () => BillingPlanInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* SubscriptionInfo subscription */ 4:
                    message.subscription = SubscriptionInfo.internalBinaryRead(reader, reader.uint32(), options, message.subscription);
                    break;
                case /* BillingPlanInfo currentPlan */ 5:
                    message.currentPlan = BillingPlanInfo.internalBinaryRead(reader, reader.uint32(), options, message.currentPlan);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* SubscriptionInfo subscription = 4; */
        if (message.subscription)
            SubscriptionInfo.internalBinaryWrite(message.subscription, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* BillingPlanInfo currentPlan = 5; */
        if (message.currentPlan)
            BillingPlanInfo.internalBinaryWrite(message.currentPlan, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserSubscriptionResponse
 */
export const GetUserSubscriptionResponse = new GetUserSubscriptionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSubscriptionRequest$Type extends MessageType {
    constructor() {
        super("CreateSubscriptionRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "planId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "billingInterval", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.planId = "";
        message.billingInterval = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string planId */ 2:
                    message.planId = reader.string();
                    break;
                case /* string billingInterval */ 3:
                    message.billingInterval = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string planId = 2; */
        if (message.planId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.planId);
        /* string billingInterval = 3; */
        if (message.billingInterval !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.billingInterval);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSubscriptionRequest
 */
export const CreateSubscriptionRequest = new CreateSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSubscriptionResponse$Type extends MessageType {
    constructor() {
        super("CreateSubscriptionResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subscription", kind: "message", T: () => SubscriptionInfo },
            { no: 5, name: "checkoutSessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.checkoutSessionId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* SubscriptionInfo subscription */ 4:
                    message.subscription = SubscriptionInfo.internalBinaryRead(reader, reader.uint32(), options, message.subscription);
                    break;
                case /* string checkoutSessionId */ 5:
                    message.checkoutSessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* SubscriptionInfo subscription = 4; */
        if (message.subscription)
            SubscriptionInfo.internalBinaryWrite(message.subscription, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string checkoutSessionId = 5; */
        if (message.checkoutSessionId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.checkoutSessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateSubscriptionResponse
 */
export const CreateSubscriptionResponse = new CreateSubscriptionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitiatePaymentRequest$Type extends MessageType {
    constructor() {
        super("InitiatePaymentRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subscriptionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "paymentMethod", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "returnUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "paymentDetails", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.subscriptionId = "";
        message.paymentMethod = "";
        message.returnUrl = "";
        message.paymentDetails = {};
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string subscriptionId */ 2:
                    message.subscriptionId = reader.string();
                    break;
                case /* string paymentMethod */ 3:
                    message.paymentMethod = reader.string();
                    break;
                case /* string returnUrl */ 4:
                    message.returnUrl = reader.string();
                    break;
                case /* map<string, string> paymentDetails */ 5:
                    this.binaryReadMap5(message.paymentDetails, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap5(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for InitiatePaymentRequest.paymentDetails");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string subscriptionId = 2; */
        if (message.subscriptionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subscriptionId);
        /* string paymentMethod = 3; */
        if (message.paymentMethod !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.paymentMethod);
        /* string returnUrl = 4; */
        if (message.returnUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.returnUrl);
        /* map<string, string> paymentDetails = 5; */
        for (let k of globalThis.Object.keys(message.paymentDetails))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.paymentDetails[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InitiatePaymentRequest
 */
export const InitiatePaymentRequest = new InitiatePaymentRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InitiatePaymentResponse$Type extends MessageType {
    constructor() {
        super("InitiatePaymentResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "transactionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "checkoutUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "paymentInstructions", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.transactionId = "";
        message.checkoutUrl = "";
        message.paymentInstructions = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string transactionId */ 4:
                    message.transactionId = reader.string();
                    break;
                case /* string checkoutUrl */ 5:
                    message.checkoutUrl = reader.string();
                    break;
                case /* string paymentInstructions */ 6:
                    message.paymentInstructions = reader.string();
                    break;
                case /* map<string, string> metadata */ 7:
                    this.binaryReadMap7(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    binaryReadMap7(map, reader, options) {
        let len = reader.uint32(), end = reader.pos + len, key, val;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for InitiatePaymentResponse.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string transactionId = 4; */
        if (message.transactionId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.transactionId);
        /* string checkoutUrl = 5; */
        if (message.checkoutUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.checkoutUrl);
        /* string paymentInstructions = 6; */
        if (message.paymentInstructions !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.paymentInstructions);
        /* map<string, string> metadata = 7; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InitiatePaymentResponse
 */
export const InitiatePaymentResponse = new InitiatePaymentResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentStatusRequest$Type extends MessageType {
    constructor() {
        super("GetPaymentStatusRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "transactionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.transactionId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string transactionId */ 2:
                    message.transactionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string transactionId = 2; */
        if (message.transactionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.transactionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaymentStatusRequest
 */
export const GetPaymentStatusRequest = new GetPaymentStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentStatusResponse$Type extends MessageType {
    constructor() {
        super("GetPaymentStatusResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "transaction", kind: "message", T: () => PaymentTransactionInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* PaymentTransactionInfo transaction */ 4:
                    message.transaction = PaymentTransactionInfo.internalBinaryRead(reader, reader.uint32(), options, message.transaction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* PaymentTransactionInfo transaction = 4; */
        if (message.transaction)
            PaymentTransactionInfo.internalBinaryWrite(message.transaction, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaymentStatusResponse
 */
export const GetPaymentStatusResponse = new GetPaymentStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentHistoryRequest$Type extends MessageType {
    constructor() {
        super("GetPaymentHistoryRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.page = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 page */ 2:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 page = 2; */
        if (message.page !== 0)
            writer.tag(2, WireType.Varint).int32(message.page);
        /* int32 pageSize = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaymentHistoryRequest
 */
export const GetPaymentHistoryRequest = new GetPaymentHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentHistoryResponse$Type extends MessageType {
    constructor() {
        super("GetPaymentHistoryResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "transactions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PaymentTransactionInfo },
            { no: 5, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.transactions = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated PaymentTransactionInfo transactions */ 4:
                    message.transactions.push(PaymentTransactionInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 totalCount */ 5:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated PaymentTransactionInfo transactions = 4; */
        for (let i = 0; i < message.transactions.length; i++)
            PaymentTransactionInfo.internalBinaryWrite(message.transactions[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 totalCount = 5; */
        if (message.totalCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaymentHistoryResponse
 */
export const GetPaymentHistoryResponse = new GetPaymentHistoryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicesRequest$Type extends MessageType {
    constructor() {
        super("GetInvoicesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "pageSize", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.page = 0;
        message.pageSize = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 page */ 2:
                    message.page = reader.int32();
                    break;
                case /* int32 pageSize */ 3:
                    message.pageSize = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 page = 2; */
        if (message.page !== 0)
            writer.tag(2, WireType.Varint).int32(message.page);
        /* int32 pageSize = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetInvoicesRequest
 */
export const GetInvoicesRequest = new GetInvoicesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInvoicesResponse$Type extends MessageType {
    constructor() {
        super("GetInvoicesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "invoices", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoiceInfo },
            { no: 5, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.invoices = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated InvoiceInfo invoices */ 4:
                    message.invoices.push(InvoiceInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 totalCount */ 5:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated InvoiceInfo invoices = 4; */
        for (let i = 0; i < message.invoices.length; i++)
            InvoiceInfo.internalBinaryWrite(message.invoices[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 totalCount = 5; */
        if (message.totalCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetInvoicesResponse
 */
export const GetInvoicesResponse = new GetInvoicesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DownloadInvoiceRequest$Type extends MessageType {
    constructor() {
        super("DownloadInvoiceRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "invoiceId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.invoiceId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string invoiceId */ 2:
                    message.invoiceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string invoiceId = 2; */
        if (message.invoiceId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invoiceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DownloadInvoiceRequest
 */
export const DownloadInvoiceRequest = new DownloadInvoiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DownloadInvoiceResponse$Type extends MessageType {
    constructor() {
        super("DownloadInvoiceResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "downloadUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.downloadUrl = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* string downloadUrl */ 4:
                    message.downloadUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* string downloadUrl = 4; */
        if (message.downloadUrl !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.downloadUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DownloadInvoiceResponse
 */
export const DownloadInvoiceResponse = new DownloadInvoiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelSubscriptionRequest$Type extends MessageType {
    constructor() {
        super("CancelSubscriptionRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cancelImmediately", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.cancelImmediately = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* bool cancelImmediately */ 2:
                    message.cancelImmediately = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* bool cancelImmediately = 2; */
        if (message.cancelImmediately !== false)
            writer.tag(2, WireType.Varint).bool(message.cancelImmediately);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelSubscriptionRequest
 */
export const CancelSubscriptionRequest = new CancelSubscriptionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CancelSubscriptionResponse$Type extends MessageType {
    constructor() {
        super("CancelSubscriptionResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "subscription", kind: "message", T: () => SubscriptionInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* SubscriptionInfo subscription */ 4:
                    message.subscription = SubscriptionInfo.internalBinaryRead(reader, reader.uint32(), options, message.subscription);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* SubscriptionInfo subscription = 4; */
        if (message.subscription)
            SubscriptionInfo.internalBinaryWrite(message.subscription, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CancelSubscriptionResponse
 */
export const CancelSubscriptionResponse = new CancelSubscriptionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActivityInfo$Type extends MessageType {
    constructor() {
        super("ActivityInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 3, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "userAvatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "activityType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "targetId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "metadata", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userId = "";
        message.userName = "";
        message.userAvatarUrl = "";
        message.activityType = "";
        message.repositoryId = "";
        message.repositoryName = "";
        message.targetId = "";
        message.message = "";
        message.metadata = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* string userId */ 3:
                    message.userId = reader.string();
                    break;
                case /* string userName */ 4:
                    message.userName = reader.string();
                    break;
                case /* string userAvatarUrl */ 5:
                    message.userAvatarUrl = reader.string();
                    break;
                case /* string activityType */ 6:
                    message.activityType = reader.string();
                    break;
                case /* string repositoryId */ 7:
                    message.repositoryId = reader.string();
                    break;
                case /* string repositoryName */ 8:
                    message.repositoryName = reader.string();
                    break;
                case /* string targetId */ 9:
                    message.targetId = reader.string();
                    break;
                case /* string message */ 10:
                    message.message = reader.string();
                    break;
                case /* string metadata */ 11:
                    message.metadata = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp createdAt = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string userId = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        /* string userName = 4; */
        if (message.userName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userName);
        /* string userAvatarUrl = 5; */
        if (message.userAvatarUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userAvatarUrl);
        /* string activityType = 6; */
        if (message.activityType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.activityType);
        /* string repositoryId = 7; */
        if (message.repositoryId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.repositoryId);
        /* string repositoryName = 8; */
        if (message.repositoryName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.repositoryName);
        /* string targetId = 9; */
        if (message.targetId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.targetId);
        /* string message = 10; */
        if (message.message !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.message);
        /* string metadata = 11; */
        if (message.metadata !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.metadata);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ActivityInfo
 */
export const ActivityInfo = new ActivityInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserActivitiesRequest$Type extends MessageType {
    constructor() {
        super("GetUserActivitiesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.userId = "";
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string userId */ 2:
                    message.userId = reader.string();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string userId = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserActivitiesRequest
 */
export const GetUserActivitiesRequest = new GetUserActivitiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserActivitiesResponse$Type extends MessageType {
    constructor() {
        super("GetUserActivitiesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.activities = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated ActivityInfo activities */ 4:
                    message.activities.push(ActivityInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated ActivityInfo activities = 4; */
        for (let i = 0; i < message.activities.length; i++)
            ActivityInfo.internalBinaryWrite(message.activities[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserActivitiesResponse
 */
export const GetUserActivitiesResponse = new GetUserActivitiesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFollowingActivitiesRequest$Type extends MessageType {
    constructor() {
        super("GetFollowingActivitiesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 limit */ 2:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 limit = 2; */
        if (message.limit !== 0)
            writer.tag(2, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFollowingActivitiesRequest
 */
export const GetFollowingActivitiesRequest = new GetFollowingActivitiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetFollowingActivitiesResponse$Type extends MessageType {
    constructor() {
        super("GetFollowingActivitiesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.activities = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated ActivityInfo activities */ 4:
                    message.activities.push(ActivityInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated ActivityInfo activities = 4; */
        for (let i = 0; i < message.activities.length; i++)
            ActivityInfo.internalBinaryWrite(message.activities[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetFollowingActivitiesResponse
 */
export const GetFollowingActivitiesResponse = new GetFollowingActivitiesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryActivitiesRequest$Type extends MessageType {
    constructor() {
        super("GetRepositoryActivitiesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryActivitiesRequest
 */
export const GetRepositoryActivitiesRequest = new GetRepositoryActivitiesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRepositoryActivitiesResponse$Type extends MessageType {
    constructor() {
        super("GetRepositoryActivitiesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "activities", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ActivityInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.activities = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated ActivityInfo activities */ 4:
                    message.activities.push(ActivityInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated ActivityInfo activities = 4; */
        for (let i = 0; i < message.activities.length; i++)
            ActivityInfo.internalBinaryWrite(message.activities[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetRepositoryActivitiesResponse
 */
export const GetRepositoryActivitiesResponse = new GetRepositoryActivitiesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CommitActivityDay$Type extends MessageType {
    constructor() {
        super("CommitActivityDay", [
            { no: 1, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.date = "";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string date */ 1:
                    message.date = reader.string();
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string date = 1; */
        if (message.date !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.date);
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CommitActivityDay
 */
export const CommitActivityDay = new CommitActivityDay$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserCommitActivityRequest$Type extends MessageType {
    constructor() {
        super("GetUserCommitActivityRequest", [
            { no: 1, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "startDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "endDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.username = "";
        message.startDate = "";
        message.endDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string username */ 1:
                    message.username = reader.string();
                    break;
                case /* string startDate */ 2:
                    message.startDate = reader.string();
                    break;
                case /* string endDate */ 3:
                    message.endDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string username = 1; */
        if (message.username !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.username);
        /* string startDate = 2; */
        if (message.startDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.startDate);
        /* string endDate = 3; */
        if (message.endDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.endDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserCommitActivityRequest
 */
export const GetUserCommitActivityRequest = new GetUserCommitActivityRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserCommitActivityResponse$Type extends MessageType {
    constructor() {
        super("GetUserCommitActivityResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "days", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CommitActivityDay },
            { no: 5, name: "totalCommits", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.days = [];
        message.totalCommits = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated CommitActivityDay days */ 4:
                    message.days.push(CommitActivityDay.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 totalCommits */ 5:
                    message.totalCommits = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated CommitActivityDay days = 4; */
        for (let i = 0; i < message.days.length; i++)
            CommitActivityDay.internalBinaryWrite(message.days[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 totalCommits = 5; */
        if (message.totalCommits !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalCommits);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserCommitActivityResponse
 */
export const GetUserCommitActivityResponse = new GetUserCommitActivityResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordCommitRequest$Type extends MessageType {
    constructor() {
        super("RecordCommitRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "commitDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.repositoryId = "";
        message.commitDate = "";
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string repositoryId */ 2:
                    message.repositoryId = reader.string();
                    break;
                case /* string commitDate */ 3:
                    message.commitDate = reader.string();
                    break;
                case /* int32 count */ 4:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string repositoryId = 2; */
        if (message.repositoryId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.repositoryId);
        /* string commitDate = 3; */
        if (message.commitDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.commitDate);
        /* int32 count = 4; */
        if (message.count !== 0)
            writer.tag(4, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RecordCommitRequest
 */
export const RecordCommitRequest = new RecordCommitRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RecordCommitResponse$Type extends MessageType {
    constructor() {
        super("RecordCommitResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RecordCommitResponse
 */
export const RecordCommitResponse = new RecordCommitResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SSHKeyInfo$Type extends MessageType {
    constructor() {
        super("SSHKeyInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "publicKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "fingerprint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "keyType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 7, name: "lastUsedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.title = "";
        message.publicKey = "";
        message.fingerprint = "";
        message.keyType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string publicKey */ 3:
                    message.publicKey = reader.string();
                    break;
                case /* string fingerprint */ 4:
                    message.fingerprint = reader.string();
                    break;
                case /* string keyType */ 5:
                    message.keyType = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp lastUsedAt */ 7:
                    message.lastUsedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUsedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string publicKey = 3; */
        if (message.publicKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.publicKey);
        /* string fingerprint = 4; */
        if (message.fingerprint !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.fingerprint);
        /* string keyType = 5; */
        if (message.keyType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.keyType);
        /* google.protobuf.Timestamp createdAt = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp lastUsedAt = 7; */
        if (message.lastUsedAt)
            Timestamp.internalBinaryWrite(message.lastUsedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SSHKeyInfo
 */
export const SSHKeyInfo = new SSHKeyInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSSHKeyRequest$Type extends MessageType {
    constructor() {
        super("AddSSHKeyRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "publicKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.title = "";
        message.publicKey = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string publicKey */ 3:
                    message.publicKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string publicKey = 3; */
        if (message.publicKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.publicKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddSSHKeyRequest
 */
export const AddSSHKeyRequest = new AddSSHKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddSSHKeyResponse$Type extends MessageType {
    constructor() {
        super("AddSSHKeyResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "key", kind: "message", T: () => SSHKeyInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* SSHKeyInfo key */ 4:
                    message.key = SSHKeyInfo.internalBinaryRead(reader, reader.uint32(), options, message.key);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* SSHKeyInfo key = 4; */
        if (message.key)
            SSHKeyInfo.internalBinaryWrite(message.key, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddSSHKeyResponse
 */
export const AddSSHKeyResponse = new AddSSHKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSSHKeysRequest$Type extends MessageType {
    constructor() {
        super("GetSSHKeysRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSSHKeysRequest
 */
export const GetSSHKeysRequest = new GetSSHKeysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSSHKeysResponse$Type extends MessageType {
    constructor() {
        super("GetSSHKeysResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SSHKeyInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.keys = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated SSHKeyInfo keys */ 4:
                    message.keys.push(SSHKeyInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated SSHKeyInfo keys = 4; */
        for (let i = 0; i < message.keys.length; i++)
            SSHKeyInfo.internalBinaryWrite(message.keys[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSSHKeysResponse
 */
export const GetSSHKeysResponse = new GetSSHKeysResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSSHKeyRequest$Type extends MessageType {
    constructor() {
        super("DeleteSSHKeyRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "keyId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.keyId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string keyId */ 2:
                    message.keyId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string keyId = 2; */
        if (message.keyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.keyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteSSHKeyRequest
 */
export const DeleteSSHKeyRequest = new DeleteSSHKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteSSHKeyResponse$Type extends MessageType {
    constructor() {
        super("DeleteSSHKeyResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteSSHKeyResponse
 */
export const DeleteSSHKeyResponse = new DeleteSSHKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GPGKeyInfo$Type extends MessageType {
    constructor() {
        super("GPGKeyInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "publicKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "keyId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "fingerprint", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 7, name: "expiresAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.title = "";
        message.publicKey = "";
        message.keyId = "";
        message.fingerprint = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string publicKey */ 3:
                    message.publicKey = reader.string();
                    break;
                case /* string keyId */ 4:
                    message.keyId = reader.string();
                    break;
                case /* string fingerprint */ 5:
                    message.fingerprint = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp expiresAt */ 7:
                    message.expiresAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.expiresAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string publicKey = 3; */
        if (message.publicKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.publicKey);
        /* string keyId = 4; */
        if (message.keyId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.keyId);
        /* string fingerprint = 5; */
        if (message.fingerprint !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.fingerprint);
        /* google.protobuf.Timestamp createdAt = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp expiresAt = 7; */
        if (message.expiresAt)
            Timestamp.internalBinaryWrite(message.expiresAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GPGKeyInfo
 */
export const GPGKeyInfo = new GPGKeyInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddGPGKeyRequest$Type extends MessageType {
    constructor() {
        super("AddGPGKeyRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "publicKey", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.title = "";
        message.publicKey = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string publicKey */ 3:
                    message.publicKey = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string publicKey = 3; */
        if (message.publicKey !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.publicKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddGPGKeyRequest
 */
export const AddGPGKeyRequest = new AddGPGKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddGPGKeyResponse$Type extends MessageType {
    constructor() {
        super("AddGPGKeyResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "key", kind: "message", T: () => GPGKeyInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* GPGKeyInfo key */ 4:
                    message.key = GPGKeyInfo.internalBinaryRead(reader, reader.uint32(), options, message.key);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* GPGKeyInfo key = 4; */
        if (message.key)
            GPGKeyInfo.internalBinaryWrite(message.key, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AddGPGKeyResponse
 */
export const AddGPGKeyResponse = new AddGPGKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGPGKeysRequest$Type extends MessageType {
    constructor() {
        super("GetGPGKeysRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGPGKeysRequest
 */
export const GetGPGKeysRequest = new GetGPGKeysRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetGPGKeysResponse$Type extends MessageType {
    constructor() {
        super("GetGPGKeysResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "keys", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GPGKeyInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.keys = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated GPGKeyInfo keys */ 4:
                    message.keys.push(GPGKeyInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated GPGKeyInfo keys = 4; */
        for (let i = 0; i < message.keys.length; i++)
            GPGKeyInfo.internalBinaryWrite(message.keys[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetGPGKeysResponse
 */
export const GetGPGKeysResponse = new GetGPGKeysResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteGPGKeyRequest$Type extends MessageType {
    constructor() {
        super("DeleteGPGKeyRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "keyId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.keyId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string keyId */ 2:
                    message.keyId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string keyId = 2; */
        if (message.keyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.keyId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteGPGKeyRequest
 */
export const DeleteGPGKeyRequest = new DeleteGPGKeyRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteGPGKeyResponse$Type extends MessageType {
    constructor() {
        super("DeleteGPGKeyResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteGPGKeyResponse
 */
export const DeleteGPGKeyResponse = new DeleteGPGKeyResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDashboardMetricsRequest$Type extends MessageType {
    constructor() {
        super("GetDashboardMetricsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "period", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.period = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string period */ 2:
                    message.period = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string period = 2; */
        if (message.period !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.period);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetDashboardMetricsRequest
 */
export const GetDashboardMetricsRequest = new GetDashboardMetricsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DashboardMetrics$Type extends MessageType {
    constructor() {
        super("DashboardMetrics", [
            { no: 1, name: "period", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "newUsers", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "newPayments", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "newRepositories", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.period = "";
        message.newUsers = 0;
        message.newPayments = 0;
        message.newRepositories = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string period */ 1:
                    message.period = reader.string();
                    break;
                case /* int32 newUsers */ 2:
                    message.newUsers = reader.int32();
                    break;
                case /* int32 newPayments */ 3:
                    message.newPayments = reader.int32();
                    break;
                case /* int32 newRepositories */ 4:
                    message.newRepositories = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string period = 1; */
        if (message.period !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.period);
        /* int32 newUsers = 2; */
        if (message.newUsers !== 0)
            writer.tag(2, WireType.Varint).int32(message.newUsers);
        /* int32 newPayments = 3; */
        if (message.newPayments !== 0)
            writer.tag(3, WireType.Varint).int32(message.newPayments);
        /* int32 newRepositories = 4; */
        if (message.newRepositories !== 0)
            writer.tag(4, WireType.Varint).int32(message.newRepositories);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DashboardMetrics
 */
export const DashboardMetrics = new DashboardMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDashboardMetricsResponse$Type extends MessageType {
    constructor() {
        super("GetDashboardMetricsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "metrics", kind: "message", T: () => DashboardMetrics }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* DashboardMetrics metrics */ 4:
                    message.metrics = DashboardMetrics.internalBinaryRead(reader, reader.uint32(), options, message.metrics);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* DashboardMetrics metrics = 4; */
        if (message.metrics)
            DashboardMetrics.internalBinaryWrite(message.metrics, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetDashboardMetricsResponse
 */
export const GetDashboardMetricsResponse = new GetDashboardMetricsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaginatedUsersRequest$Type extends MessageType {
    constructor() {
        super("GetPaginatedUsersRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.page = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 page */ 2:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 page = 2; */
        if (message.page !== 0)
            writer.tag(2, WireType.Varint).int32(message.page);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaginatedUsersRequest
 */
export const GetPaginatedUsersRequest = new GetPaginatedUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdminUserInfo$Type extends MessageType {
    constructor() {
        super("AdminUserInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "firstName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "lastName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "country", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "userRole", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "userStatus", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "createdAt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "avatarUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "bio", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.email = "";
        message.userName = "";
        message.firstName = "";
        message.lastName = "";
        message.country = "";
        message.userRole = "";
        message.userStatus = 0;
        message.createdAt = "";
        message.avatarUrl = "";
        message.bio = "";
        message.location = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string email */ 2:
                    message.email = reader.string();
                    break;
                case /* string userName */ 3:
                    message.userName = reader.string();
                    break;
                case /* string firstName */ 4:
                    message.firstName = reader.string();
                    break;
                case /* string lastName */ 5:
                    message.lastName = reader.string();
                    break;
                case /* string country */ 6:
                    message.country = reader.string();
                    break;
                case /* string userRole */ 7:
                    message.userRole = reader.string();
                    break;
                case /* int32 userStatus */ 8:
                    message.userStatus = reader.int32();
                    break;
                case /* string createdAt */ 9:
                    message.createdAt = reader.string();
                    break;
                case /* string avatarUrl */ 10:
                    message.avatarUrl = reader.string();
                    break;
                case /* string bio */ 11:
                    message.bio = reader.string();
                    break;
                case /* string location */ 12:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string email = 2; */
        if (message.email !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.email);
        /* string userName = 3; */
        if (message.userName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userName);
        /* string firstName = 4; */
        if (message.firstName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.firstName);
        /* string lastName = 5; */
        if (message.lastName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.lastName);
        /* string country = 6; */
        if (message.country !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.country);
        /* string userRole = 7; */
        if (message.userRole !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.userRole);
        /* int32 userStatus = 8; */
        if (message.userStatus !== 0)
            writer.tag(8, WireType.Varint).int32(message.userStatus);
        /* string createdAt = 9; */
        if (message.createdAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.createdAt);
        /* string avatarUrl = 10; */
        if (message.avatarUrl !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.avatarUrl);
        /* string bio = 11; */
        if (message.bio !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.bio);
        /* string location = 12; */
        if (message.location !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AdminUserInfo
 */
export const AdminUserInfo = new AdminUserInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaginatedUsersResponse$Type extends MessageType {
    constructor() {
        super("GetPaginatedUsersResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "users", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AdminUserInfo },
            { no: 5, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.users = [];
        message.page = 0;
        message.limit = 0;
        message.totalCount = 0;
        message.totalPages = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated AdminUserInfo users */ 4:
                    message.users.push(AdminUserInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 page */ 5:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* int32 totalCount */ 7:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 totalPages */ 8:
                    message.totalPages = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated AdminUserInfo users = 4; */
        for (let i = 0; i < message.users.length; i++)
            AdminUserInfo.internalBinaryWrite(message.users[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 page = 5; */
        if (message.page !== 0)
            writer.tag(5, WireType.Varint).int32(message.page);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* int32 totalCount = 7; */
        if (message.totalCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCount);
        /* int32 totalPages = 8; */
        if (message.totalPages !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalPages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaginatedUsersResponse
 */
export const GetPaginatedUsersResponse = new GetPaginatedUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRepositoriesAdminRequest$Type extends MessageType {
    constructor() {
        super("SearchRepositoriesAdminRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "searchTerm", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.searchTerm = "";
        message.page = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string searchTerm */ 2:
                    message.searchTerm = reader.string();
                    break;
                case /* int32 page */ 3:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string searchTerm = 2; */
        if (message.searchTerm !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.searchTerm);
        /* int32 page = 3; */
        if (message.page !== 0)
            writer.tag(3, WireType.Varint).int32(message.page);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchRepositoriesAdminRequest
 */
export const SearchRepositoriesAdminRequest = new SearchRepositoriesAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RepositorySearchResult$Type extends MessageType {
    constructor() {
        super("RepositorySearchResult", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ownerName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "visibility", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "starCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "forkCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "createdAt", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.ownerId = "";
        message.ownerName = "";
        message.name = "";
        message.description = "";
        message.visibility = "";
        message.starCount = 0;
        message.forkCount = 0;
        message.createdAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string ownerName */ 3:
                    message.ownerName = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string visibility */ 6:
                    message.visibility = reader.string();
                    break;
                case /* int32 starCount */ 7:
                    message.starCount = reader.int32();
                    break;
                case /* int32 forkCount */ 8:
                    message.forkCount = reader.int32();
                    break;
                case /* string createdAt */ 9:
                    message.createdAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string ownerName = 3; */
        if (message.ownerName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ownerName);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string visibility = 6; */
        if (message.visibility !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.visibility);
        /* int32 starCount = 7; */
        if (message.starCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.starCount);
        /* int32 forkCount = 8; */
        if (message.forkCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.forkCount);
        /* string createdAt = 9; */
        if (message.createdAt !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.createdAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RepositorySearchResult
 */
export const RepositorySearchResult = new RepositorySearchResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRepositoriesAdminResponse$Type extends MessageType {
    constructor() {
        super("SearchRepositoriesAdminResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositorySearchResult },
            { no: 5, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.repositories = [];
        message.page = 0;
        message.limit = 0;
        message.totalCount = 0;
        message.totalPages = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated RepositorySearchResult repositories */ 4:
                    message.repositories.push(RepositorySearchResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 page */ 5:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* int32 totalCount */ 7:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 totalPages */ 8:
                    message.totalPages = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated RepositorySearchResult repositories = 4; */
        for (let i = 0; i < message.repositories.length; i++)
            RepositorySearchResult.internalBinaryWrite(message.repositories[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 page = 5; */
        if (message.page !== 0)
            writer.tag(5, WireType.Varint).int32(message.page);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* int32 totalCount = 7; */
        if (message.totalCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCount);
        /* int32 totalPages = 8; */
        if (message.totalPages !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalPages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SearchRepositoriesAdminResponse
 */
export const SearchRepositoriesAdminResponse = new SearchRepositoriesAdminResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserRepositoriesAdminRequest$Type extends MessageType {
    constructor() {
        super("GetUserRepositoriesAdminRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string userId */ 2:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string userId = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserRepositoriesAdminRequest
 */
export const GetUserRepositoriesAdminRequest = new GetUserRepositoriesAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserRepositoriesAdminResponse$Type extends MessageType {
    constructor() {
        super("GetUserRepositoriesAdminResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositorySearchResult }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.repositories = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated RepositorySearchResult repositories */ 4:
                    message.repositories.push(RepositorySearchResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated RepositorySearchResult repositories = 4; */
        for (let i = 0; i < message.repositories.length; i++)
            RepositorySearchResult.internalBinaryWrite(message.repositories[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserRepositoriesAdminResponse
 */
export const GetUserRepositoriesAdminResponse = new GetUserRepositoriesAdminResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SessionStatItem$Type extends MessageType {
    constructor() {
        super("SessionStatItem", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "percentage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.name = "";
        message.count = 0;
        message.percentage = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                case /* float percentage */ 3:
                    message.percentage = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        /* float percentage = 3; */
        if (message.percentage !== 0)
            writer.tag(3, WireType.Bit32).float(message.percentage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SessionStatItem
 */
export const SessionStatItem = new SessionStatItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionStatsRequest$Type extends MessageType {
    constructor() {
        super("GetSessionStatsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSessionStatsRequest
 */
export const GetSessionStatsRequest = new GetSessionStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSessionStatsResponse$Type extends MessageType {
    constructor() {
        super("GetSessionStatsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "byCountry", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SessionStatItem },
            { no: 5, name: "byOS", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SessionStatItem },
            { no: 6, name: "byBrowser", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SessionStatItem },
            { no: 7, name: "totalActiveSessions", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.byCountry = [];
        message.byOS = [];
        message.byBrowser = [];
        message.totalActiveSessions = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated SessionStatItem byCountry */ 4:
                    message.byCountry.push(SessionStatItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated SessionStatItem byOS */ 5:
                    message.byOS.push(SessionStatItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated SessionStatItem byBrowser */ 6:
                    message.byBrowser.push(SessionStatItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 totalActiveSessions */ 7:
                    message.totalActiveSessions = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated SessionStatItem byCountry = 4; */
        for (let i = 0; i < message.byCountry.length; i++)
            SessionStatItem.internalBinaryWrite(message.byCountry[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated SessionStatItem byOS = 5; */
        for (let i = 0; i < message.byOS.length; i++)
            SessionStatItem.internalBinaryWrite(message.byOS[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated SessionStatItem byBrowser = 6; */
        for (let i = 0; i < message.byBrowser.length; i++)
            SessionStatItem.internalBinaryWrite(message.byBrowser[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* int32 totalActiveSessions = 7; */
        if (message.totalActiveSessions !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalActiveSessions);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetSessionStatsResponse
 */
export const GetSessionStatsResponse = new GetSessionStatsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TopRepositoryInfo$Type extends MessageType {
    constructor() {
        super("TopRepositoryInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ownerId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "ownerName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "primaryLanguage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "primaryLanguageColor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "starCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "forkCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "visibility", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.ownerId = "";
        message.ownerName = "";
        message.name = "";
        message.description = "";
        message.primaryLanguage = "";
        message.primaryLanguageColor = "";
        message.starCount = 0;
        message.forkCount = 0;
        message.visibility = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string ownerId */ 2:
                    message.ownerId = reader.string();
                    break;
                case /* string ownerName */ 3:
                    message.ownerName = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* string primaryLanguage */ 6:
                    message.primaryLanguage = reader.string();
                    break;
                case /* string primaryLanguageColor */ 7:
                    message.primaryLanguageColor = reader.string();
                    break;
                case /* int32 starCount */ 8:
                    message.starCount = reader.int32();
                    break;
                case /* int32 forkCount */ 9:
                    message.forkCount = reader.int32();
                    break;
                case /* string visibility */ 10:
                    message.visibility = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string ownerId = 2; */
        if (message.ownerId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ownerId);
        /* string ownerName = 3; */
        if (message.ownerName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ownerName);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* string primaryLanguage = 6; */
        if (message.primaryLanguage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.primaryLanguage);
        /* string primaryLanguageColor = 7; */
        if (message.primaryLanguageColor !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.primaryLanguageColor);
        /* int32 starCount = 8; */
        if (message.starCount !== 0)
            writer.tag(8, WireType.Varint).int32(message.starCount);
        /* int32 forkCount = 9; */
        if (message.forkCount !== 0)
            writer.tag(9, WireType.Varint).int32(message.forkCount);
        /* string visibility = 10; */
        if (message.visibility !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.visibility);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TopRepositoryInfo
 */
export const TopRepositoryInfo = new TopRepositoryInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTopRepositoriesRequest$Type extends MessageType {
    constructor() {
        super("GetTopRepositoriesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 limit */ 2:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 limit = 2; */
        if (message.limit !== 0)
            writer.tag(2, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetTopRepositoriesRequest
 */
export const GetTopRepositoriesRequest = new GetTopRepositoriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetTopRepositoriesResponse$Type extends MessageType {
    constructor() {
        super("GetTopRepositoriesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TopRepositoryInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.repositories = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated TopRepositoryInfo repositories */ 4:
                    message.repositories.push(TopRepositoryInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated TopRepositoryInfo repositories = 4; */
        for (let i = 0; i < message.repositories.length; i++)
            TopRepositoryInfo.internalBinaryWrite(message.repositories[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetTopRepositoriesResponse
 */
export const GetTopRepositoriesResponse = new GetTopRepositoriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllRepositoriesRequest$Type extends MessageType {
    constructor() {
        super("GetAllRepositoriesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.page = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 page */ 2:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 page = 2; */
        if (message.page !== 0)
            writer.tag(2, WireType.Varint).int32(message.page);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAllRepositoriesRequest
 */
export const GetAllRepositoriesRequest = new GetAllRepositoriesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllRepositoriesResponse$Type extends MessageType {
    constructor() {
        super("GetAllRepositoriesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositories", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepositorySearchResult },
            { no: 5, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.repositories = [];
        message.page = 0;
        message.limit = 0;
        message.totalCount = 0;
        message.totalPages = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated RepositorySearchResult repositories */ 4:
                    message.repositories.push(RepositorySearchResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 page */ 5:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* int32 totalCount */ 7:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 totalPages */ 8:
                    message.totalPages = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated RepositorySearchResult repositories = 4; */
        for (let i = 0; i < message.repositories.length; i++)
            RepositorySearchResult.internalBinaryWrite(message.repositories[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 page = 5; */
        if (message.page !== 0)
            writer.tag(5, WireType.Varint).int32(message.page);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* int32 totalCount = 7; */
        if (message.totalCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCount);
        /* int32 totalPages = 8; */
        if (message.totalPages !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalPages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAllRepositoriesResponse
 */
export const GetAllRepositoriesResponse = new GetAllRepositoriesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllSessionsRequest$Type extends MessageType {
    constructor() {
        super("GetAllSessionsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.page = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 page */ 2:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 page = 2; */
        if (message.page !== 0)
            writer.tag(2, WireType.Varint).int32(message.page);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAllSessionsRequest
 */
export const GetAllSessionsRequest = new GetAllSessionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllSessionsResponse$Type extends MessageType {
    constructor() {
        super("GetAllSessionsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sessions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SessionInfo },
            { no: 5, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.sessions = [];
        message.page = 0;
        message.limit = 0;
        message.totalCount = 0;
        message.totalPages = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated SessionInfo sessions */ 4:
                    message.sessions.push(SessionInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 page */ 5:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* int32 totalCount */ 7:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 totalPages */ 8:
                    message.totalPages = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated SessionInfo sessions = 4; */
        for (let i = 0; i < message.sessions.length; i++)
            SessionInfo.internalBinaryWrite(message.sessions[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 page = 5; */
        if (message.page !== 0)
            writer.tag(5, WireType.Varint).int32(message.page);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* int32 totalCount = 7; */
        if (message.totalCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCount);
        /* int32 totalPages = 8; */
        if (message.totalPages !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalPages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAllSessionsResponse
 */
export const GetAllSessionsResponse = new GetAllSessionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeSessionAdminRequest$Type extends MessageType {
    constructor() {
        super("RevokeSessionAdminRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sessionId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.sessionId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string sessionId */ 2:
                    message.sessionId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string sessionId = 2; */
        if (message.sessionId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.sessionId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeSessionAdminRequest
 */
export const RevokeSessionAdminRequest = new RevokeSessionAdminRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevokeSessionAdminResponse$Type extends MessageType {
    constructor() {
        super("RevokeSessionAdminResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message RevokeSessionAdminResponse
 */
export const RevokeSessionAdminResponse = new RevokeSessionAdminResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PaymentStats$Type extends MessageType {
    constructor() {
        super("PaymentStats", [
            { no: 1, name: "totalRevenue", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "completedPayments", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "pendingPayments", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "failedPayments", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "revenueChangePercent", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "completedChangePercent", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.totalRevenue = "";
        message.completedPayments = 0;
        message.pendingPayments = 0;
        message.failedPayments = 0;
        message.revenueChangePercent = 0;
        message.completedChangePercent = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string totalRevenue */ 1:
                    message.totalRevenue = reader.string();
                    break;
                case /* int32 completedPayments */ 2:
                    message.completedPayments = reader.int32();
                    break;
                case /* int32 pendingPayments */ 3:
                    message.pendingPayments = reader.int32();
                    break;
                case /* int32 failedPayments */ 4:
                    message.failedPayments = reader.int32();
                    break;
                case /* float revenueChangePercent */ 5:
                    message.revenueChangePercent = reader.float();
                    break;
                case /* float completedChangePercent */ 6:
                    message.completedChangePercent = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string totalRevenue = 1; */
        if (message.totalRevenue !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.totalRevenue);
        /* int32 completedPayments = 2; */
        if (message.completedPayments !== 0)
            writer.tag(2, WireType.Varint).int32(message.completedPayments);
        /* int32 pendingPayments = 3; */
        if (message.pendingPayments !== 0)
            writer.tag(3, WireType.Varint).int32(message.pendingPayments);
        /* int32 failedPayments = 4; */
        if (message.failedPayments !== 0)
            writer.tag(4, WireType.Varint).int32(message.failedPayments);
        /* float revenueChangePercent = 5; */
        if (message.revenueChangePercent !== 0)
            writer.tag(5, WireType.Bit32).float(message.revenueChangePercent);
        /* float completedChangePercent = 6; */
        if (message.completedChangePercent !== 0)
            writer.tag(6, WireType.Bit32).float(message.completedChangePercent);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PaymentStats
 */
export const PaymentStats = new PaymentStats$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentStatsRequest$Type extends MessageType {
    constructor() {
        super("GetPaymentStatsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaymentStatsRequest
 */
export const GetPaymentStatsRequest = new GetPaymentStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetPaymentStatsResponse$Type extends MessageType {
    constructor() {
        super("GetPaymentStatsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "stats", kind: "message", T: () => PaymentStats }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* PaymentStats stats */ 4:
                    message.stats = PaymentStats.internalBinaryRead(reader, reader.uint32(), options, message.stats);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* PaymentStats stats = 4; */
        if (message.stats)
            PaymentStats.internalBinaryWrite(message.stats, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetPaymentStatsResponse
 */
export const GetPaymentStatsResponse = new GetPaymentStatsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPaymentsRequest$Type extends MessageType {
    constructor() {
        super("GetAllPaymentsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.page = 0;
        message.limit = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* int32 page */ 2:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 3:
                    message.limit = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* int32 page = 2; */
        if (message.page !== 0)
            writer.tag(2, WireType.Varint).int32(message.page);
        /* int32 limit = 3; */
        if (message.limit !== 0)
            writer.tag(3, WireType.Varint).int32(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAllPaymentsRequest
 */
export const GetAllPaymentsRequest = new GetAllPaymentsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAllPaymentsResponse$Type extends MessageType {
    constructor() {
        super("GetAllPaymentsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payments", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PaymentTransactionInfo },
            { no: 5, name: "page", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "totalPages", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.payments = [];
        message.page = 0;
        message.limit = 0;
        message.totalCount = 0;
        message.totalPages = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated PaymentTransactionInfo payments */ 4:
                    message.payments.push(PaymentTransactionInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 page */ 5:
                    message.page = reader.int32();
                    break;
                case /* int32 limit */ 6:
                    message.limit = reader.int32();
                    break;
                case /* int32 totalCount */ 7:
                    message.totalCount = reader.int32();
                    break;
                case /* int32 totalPages */ 8:
                    message.totalPages = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated PaymentTransactionInfo payments = 4; */
        for (let i = 0; i < message.payments.length; i++)
            PaymentTransactionInfo.internalBinaryWrite(message.payments[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 page = 5; */
        if (message.page !== 0)
            writer.tag(5, WireType.Varint).int32(message.page);
        /* int32 limit = 6; */
        if (message.limit !== 0)
            writer.tag(6, WireType.Varint).int32(message.limit);
        /* int32 totalCount = 7; */
        if (message.totalCount !== 0)
            writer.tag(7, WireType.Varint).int32(message.totalCount);
        /* int32 totalPages = 8; */
        if (message.totalPages !== 0)
            writer.tag(8, WireType.Varint).int32(message.totalPages);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetAllPaymentsResponse
 */
export const GetAllPaymentsResponse = new GetAllPaymentsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseInfo$Type extends MessageType {
    constructor() {
        super("DatabaseInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dbType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "port", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "databaseName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 11, name: "updatedAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userId = "";
        message.name = "";
        message.dbType = "";
        message.status = "";
        message.host = "";
        message.port = 0;
        message.username = "";
        message.databaseName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string userId */ 2:
                    message.userId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string dbType */ 4:
                    message.dbType = reader.string();
                    break;
                case /* string status */ 5:
                    message.status = reader.string();
                    break;
                case /* string host */ 6:
                    message.host = reader.string();
                    break;
                case /* int32 port */ 7:
                    message.port = reader.int32();
                    break;
                case /* string username */ 8:
                    message.username = reader.string();
                    break;
                case /* string databaseName */ 9:
                    message.databaseName = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 10:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updatedAt */ 11:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string userId = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string dbType = 4; */
        if (message.dbType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dbType);
        /* string status = 5; */
        if (message.status !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.status);
        /* string host = 6; */
        if (message.host !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.host);
        /* int32 port = 7; */
        if (message.port !== 0)
            writer.tag(7, WireType.Varint).int32(message.port);
        /* string username = 8; */
        if (message.username !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.username);
        /* string databaseName = 9; */
        if (message.databaseName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.databaseName);
        /* google.protobuf.Timestamp createdAt = 10; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updatedAt = 11; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DatabaseInfo
 */
export const DatabaseInfo = new DatabaseInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DatabaseWithCredentials$Type extends MessageType {
    constructor() {
        super("DatabaseWithCredentials", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "dbType", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "host", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "port", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "username", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "password", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "databaseName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "connectionString", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "createdAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userId = "";
        message.name = "";
        message.dbType = "";
        message.status = "";
        message.host = "";
        message.port = 0;
        message.username = "";
        message.password = "";
        message.databaseName = "";
        message.connectionString = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string userId */ 2:
                    message.userId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string dbType */ 4:
                    message.dbType = reader.string();
                    break;
                case /* string status */ 5:
                    message.status = reader.string();
                    break;
                case /* string host */ 6:
                    message.host = reader.string();
                    break;
                case /* int32 port */ 7:
                    message.port = reader.int32();
                    break;
                case /* string username */ 8:
                    message.username = reader.string();
                    break;
                case /* string password */ 9:
                    message.password = reader.string();
                    break;
                case /* string databaseName */ 10:
                    message.databaseName = reader.string();
                    break;
                case /* string connectionString */ 11:
                    message.connectionString = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 12:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string userId = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string dbType = 4; */
        if (message.dbType !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.dbType);
        /* string status = 5; */
        if (message.status !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.status);
        /* string host = 6; */
        if (message.host !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.host);
        /* int32 port = 7; */
        if (message.port !== 0)
            writer.tag(7, WireType.Varint).int32(message.port);
        /* string username = 8; */
        if (message.username !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.username);
        /* string password = 9; */
        if (message.password !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.password);
        /* string databaseName = 10; */
        if (message.databaseName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.databaseName);
        /* string connectionString = 11; */
        if (message.connectionString !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.connectionString);
        /* google.protobuf.Timestamp createdAt = 12; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DatabaseWithCredentials
 */
export const DatabaseWithCredentials = new DatabaseWithCredentials$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDatabaseRequest$Type extends MessageType {
    constructor() {
        super("CreateDatabaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dbType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.name = "";
        message.dbType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* string dbType */ 3:
                    message.dbType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* string dbType = 3; */
        if (message.dbType !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dbType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateDatabaseRequest
 */
export const CreateDatabaseRequest = new CreateDatabaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateDatabaseResponse$Type extends MessageType {
    constructor() {
        super("CreateDatabaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "database", kind: "message", T: () => DatabaseInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* DatabaseInfo database */ 4:
                    message.database = DatabaseInfo.internalBinaryRead(reader, reader.uint32(), options, message.database);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* DatabaseInfo database = 4; */
        if (message.database)
            DatabaseInfo.internalBinaryWrite(message.database, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CreateDatabaseResponse
 */
export const CreateDatabaseResponse = new CreateDatabaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserDatabasesRequest$Type extends MessageType {
    constructor() {
        super("GetUserDatabasesRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserDatabasesRequest
 */
export const GetUserDatabasesRequest = new GetUserDatabasesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserDatabasesResponse$Type extends MessageType {
    constructor() {
        super("GetUserDatabasesResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "databases", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DatabaseInfo }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.databases = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated DatabaseInfo databases */ 4:
                    message.databases.push(DatabaseInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated DatabaseInfo databases = 4; */
        for (let i = 0; i < message.databases.length; i++)
            DatabaseInfo.internalBinaryWrite(message.databases[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserDatabasesResponse
 */
export const GetUserDatabasesResponse = new GetUserDatabasesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDatabaseRequest$Type extends MessageType {
    constructor() {
        super("GetDatabaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "databaseId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.databaseId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string databaseId */ 2:
                    message.databaseId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string databaseId = 2; */
        if (message.databaseId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.databaseId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetDatabaseRequest
 */
export const GetDatabaseRequest = new GetDatabaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetDatabaseResponse$Type extends MessageType {
    constructor() {
        super("GetDatabaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "database", kind: "message", T: () => DatabaseWithCredentials }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* DatabaseWithCredentials database */ 4:
                    message.database = DatabaseWithCredentials.internalBinaryRead(reader, reader.uint32(), options, message.database);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* DatabaseWithCredentials database = 4; */
        if (message.database)
            DatabaseWithCredentials.internalBinaryWrite(message.database, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetDatabaseResponse
 */
export const GetDatabaseResponse = new GetDatabaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDatabaseRequest$Type extends MessageType {
    constructor() {
        super("DeleteDatabaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "databaseId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.databaseId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string databaseId */ 2:
                    message.databaseId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string databaseId = 2; */
        if (message.databaseId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.databaseId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteDatabaseRequest
 */
export const DeleteDatabaseRequest = new DeleteDatabaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteDatabaseResponse$Type extends MessageType {
    constructor() {
        super("DeleteDatabaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteDatabaseResponse
 */
export const DeleteDatabaseResponse = new DeleteDatabaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartDatabaseRequest$Type extends MessageType {
    constructor() {
        super("StartDatabaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "databaseId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.databaseId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string databaseId */ 2:
                    message.databaseId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string databaseId = 2; */
        if (message.databaseId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.databaseId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StartDatabaseRequest
 */
export const StartDatabaseRequest = new StartDatabaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartDatabaseResponse$Type extends MessageType {
    constructor() {
        super("StartDatabaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StartDatabaseResponse
 */
export const StartDatabaseResponse = new StartDatabaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopDatabaseRequest$Type extends MessageType {
    constructor() {
        super("StopDatabaseRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "databaseId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.databaseId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string databaseId */ 2:
                    message.databaseId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string databaseId = 2; */
        if (message.databaseId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.databaseId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StopDatabaseRequest
 */
export const StopDatabaseRequest = new StopDatabaseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StopDatabaseResponse$Type extends MessageType {
    constructor() {
        super("StopDatabaseResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message StopDatabaseResponse
 */
export const StopDatabaseResponse = new StopDatabaseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NotificationInfo$Type extends MessageType {
    constructor() {
        super("NotificationInfo", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "repositoryId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "repositoryName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "repositoryOwner", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "authorId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "authorUsername", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "createdAt", kind: "message", T: () => Timestamp },
            { no: 14, name: "readAt", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = "";
        message.userId = "";
        message.type = "";
        message.repositoryId = "";
        message.repositoryName = "";
        message.repositoryOwner = "";
        message.title = "";
        message.description = "";
        message.url = "";
        message.authorId = "";
        message.authorUsername = "";
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string userId */ 2:
                    message.userId = reader.string();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* string repositoryId */ 4:
                    message.repositoryId = reader.string();
                    break;
                case /* string repositoryName */ 5:
                    message.repositoryName = reader.string();
                    break;
                case /* string repositoryOwner */ 6:
                    message.repositoryOwner = reader.string();
                    break;
                case /* string title */ 7:
                    message.title = reader.string();
                    break;
                case /* string description */ 8:
                    message.description = reader.string();
                    break;
                case /* string url */ 9:
                    message.url = reader.string();
                    break;
                case /* string authorId */ 10:
                    message.authorId = reader.string();
                    break;
                case /* string authorUsername */ 11:
                    message.authorUsername = reader.string();
                    break;
                case /* string status */ 12:
                    message.status = reader.string();
                    break;
                case /* google.protobuf.Timestamp createdAt */ 13:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp readAt */ 14:
                    message.readAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.readAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string userId = 2; */
        if (message.userId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userId);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* string repositoryId = 4; */
        if (message.repositoryId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.repositoryId);
        /* string repositoryName = 5; */
        if (message.repositoryName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.repositoryName);
        /* string repositoryOwner = 6; */
        if (message.repositoryOwner !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.repositoryOwner);
        /* string title = 7; */
        if (message.title !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.title);
        /* string description = 8; */
        if (message.description !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.description);
        /* string url = 9; */
        if (message.url !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.url);
        /* string authorId = 10; */
        if (message.authorId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.authorId);
        /* string authorUsername = 11; */
        if (message.authorUsername !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.authorUsername);
        /* string status = 12; */
        if (message.status !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.status);
        /* google.protobuf.Timestamp createdAt = 13; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp readAt = 14; */
        if (message.readAt)
            Timestamp.internalBinaryWrite(message.readAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message NotificationInfo
 */
export const NotificationInfo = new NotificationInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserNotificationsRequest$Type extends MessageType {
    constructor() {
        super("GetUserNotificationsRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "limit", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.status = "";
        message.type = "";
        message.limit = 0;
        message.offset = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string status */ 2:
                    message.status = reader.string();
                    break;
                case /* string type */ 3:
                    message.type = reader.string();
                    break;
                case /* int32 limit */ 4:
                    message.limit = reader.int32();
                    break;
                case /* int32 offset */ 5:
                    message.offset = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string status = 2; */
        if (message.status !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.status);
        /* string type = 3; */
        if (message.type !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.type);
        /* int32 limit = 4; */
        if (message.limit !== 0)
            writer.tag(4, WireType.Varint).int32(message.limit);
        /* int32 offset = 5; */
        if (message.offset !== 0)
            writer.tag(5, WireType.Varint).int32(message.offset);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserNotificationsRequest
 */
export const GetUserNotificationsRequest = new GetUserNotificationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetUserNotificationsResponse$Type extends MessageType {
    constructor() {
        super("GetUserNotificationsResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "notifications", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => NotificationInfo },
            { no: 5, name: "unreadCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "totalCount", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        message.notifications = [];
        message.unreadCount = 0;
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                case /* repeated NotificationInfo notifications */ 4:
                    message.notifications.push(NotificationInfo.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 unreadCount */ 5:
                    message.unreadCount = reader.int32();
                    break;
                case /* int32 totalCount */ 6:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        /* repeated NotificationInfo notifications = 4; */
        for (let i = 0; i < message.notifications.length; i++)
            NotificationInfo.internalBinaryWrite(message.notifications[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 unreadCount = 5; */
        if (message.unreadCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.unreadCount);
        /* int32 totalCount = 6; */
        if (message.totalCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message GetUserNotificationsResponse
 */
export const GetUserNotificationsResponse = new GetUserNotificationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkNotificationAsReadRequest$Type extends MessageType {
    constructor() {
        super("MarkNotificationAsReadRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "notificationId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.notificationId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string notificationId */ 2:
                    message.notificationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string notificationId = 2; */
        if (message.notificationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.notificationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MarkNotificationAsReadRequest
 */
export const MarkNotificationAsReadRequest = new MarkNotificationAsReadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkNotificationAsReadResponse$Type extends MessageType {
    constructor() {
        super("MarkNotificationAsReadResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MarkNotificationAsReadResponse
 */
export const MarkNotificationAsReadResponse = new MarkNotificationAsReadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkAllNotificationsAsReadRequest$Type extends MessageType {
    constructor() {
        super("MarkAllNotificationsAsReadRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MarkAllNotificationsAsReadRequest
 */
export const MarkAllNotificationsAsReadRequest = new MarkAllNotificationsAsReadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MarkAllNotificationsAsReadResponse$Type extends MessageType {
    constructor() {
        super("MarkAllNotificationsAsReadResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message MarkAllNotificationsAsReadResponse
 */
export const MarkAllNotificationsAsReadResponse = new MarkAllNotificationsAsReadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteNotificationRequest$Type extends MessageType {
    constructor() {
        super("DeleteNotificationRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "notificationId", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.token = "";
        message.notificationId = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                case /* string notificationId */ 2:
                    message.notificationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        /* string notificationId = 2; */
        if (message.notificationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.notificationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteNotificationRequest
 */
export const DeleteNotificationRequest = new DeleteNotificationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteNotificationResponse$Type extends MessageType {
    constructor() {
        super("DeleteNotificationResponse", [
            { no: 1, name: "successFull", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.successFull = false;
        message.status = 0;
        message.reason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool successFull */ 1:
                    message.successFull = reader.bool();
                    break;
                case /* int32 status */ 2:
                    message.status = reader.int32();
                    break;
                case /* string reason */ 3:
                    message.reason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool successFull = 1; */
        if (message.successFull !== false)
            writer.tag(1, WireType.Varint).bool(message.successFull);
        /* int32 status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* string reason = 3; */
        if (message.reason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.reason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DeleteNotificationResponse
 */
export const DeleteNotificationResponse = new DeleteNotificationResponse$Type();
/**
 * @generated ServiceType for protobuf service AppApi
 */
export const AppApi = new ServiceType("AppApi", [
    { name: "SayHello", options: {}, I: Empty, O: CommonResponse },
    { name: "Login", options: {}, I: LoginRequest, O: LoginResponse },
    { name: "Register", options: {}, I: RegisterRequest, O: CommonResponse },
    { name: "CheckUserNameIsAvailable", options: {}, I: CheckUserNameIsAvailableRequest, O: CommonResponse },
    { name: "ForgotPassowrd", options: {}, I: ForgotPassowrdRequest, O: CommonResponse },
    { name: "ResetPassword", options: {}, I: ResetPasswordRequest, O: CommonResponse },
    { name: "VerifyEmail", options: {}, I: VerifyEmailRequest, O: CommonResponse },
    { name: "VerifyEmailByToken", options: {}, I: VerifyEmailByTokenRequest, O: CommonResponse },
    { name: "ResendVerificationEmail", options: {}, I: ResendVerificationEmailRequest, O: CommonResponse },
    { name: "GetGoogleOAuthURL", options: {}, I: GetOAuthURLRequest, O: GetOAuthURLResponse },
    { name: "GetGitHubOAuthURL", options: {}, I: GetOAuthURLRequest, O: GetOAuthURLResponse },
    { name: "HandleGoogleOAuthCallback", options: {}, I: OAuthCallbackRequest, O: OAuthCallbackResponse },
    { name: "HandleGitHubOAuthCallback", options: {}, I: OAuthCallbackRequest, O: OAuthCallbackResponse },
    { name: "Enable2FA", options: {}, I: Enable2FARequest, O: Enable2FAResponse },
    { name: "Verify2FA", options: {}, I: Verify2FARequest, O: Verify2FAResponse },
    { name: "Disable2FA", options: {}, I: Disable2FARequest, O: Disable2FAResponse },
    { name: "VerifyLogin2FA", options: {}, I: VerifyLogin2FARequest, O: VerifyLogin2FAResponse },
    { name: "ChangeUserRole", options: {}, I: UserRoleChangeRequest, O: CommonResponse },
    { name: "GetUserProfile", options: {}, I: GetUserProfileRequest, O: UserProfileResponse },
    { name: "GetPublicUserProfile", options: {}, I: GetPublicUserProfileRequest, O: PublicUserProfileResponse },
    { name: "UpdateProfile", options: {}, I: UpdateProfileRequest, O: CommonResponse },
    { name: "RequestPasswordChangeCode", options: {}, I: RequestPasswordChangeCodeRequest, O: CommonResponse },
    { name: "ChangePassword", options: {}, I: ChangePasswordRequest, O: CommonResponse },
    { name: "FollowUser", options: {}, I: FollowUserRequest, O: FollowUserResponse },
    { name: "UnfollowUser", options: {}, I: UnfollowUserRequest, O: UnfollowUserResponse },
    { name: "IsFollowing", options: {}, I: IsFollowingRequest, O: IsFollowingResponse },
    { name: "GetFollowers", options: {}, I: GetFollowersRequest, O: GetFollowersResponse },
    { name: "GetFollowing", options: {}, I: GetFollowingRequest, O: GetFollowingResponse },
    { name: "AddSocialLink", options: {}, I: AddSocialLinkRequest, O: AddSocialLinkResponse },
    { name: "UpdateSocialLink", options: {}, I: UpdateSocialLinkRequest, O: UpdateSocialLinkResponse },
    { name: "DeleteSocialLink", options: {}, I: DeleteSocialLinkRequest, O: DeleteSocialLinkResponse },
    { name: "GetSocialLinks", options: {}, I: GetSocialLinksRequest, O: GetSocialLinksResponse },
    { name: "GetPublicSocialLinks", options: {}, I: GetPublicSocialLinksRequest, O: GetPublicSocialLinksResponse },
    { name: "AddUserEmail", options: {}, I: AddUserEmailRequest, O: AddUserEmailResponse },
    { name: "UpdateEmailPublicStatus", options: {}, I: UpdateEmailPublicStatusRequest, O: UpdateEmailPublicStatusResponse },
    { name: "SetPrimaryEmail", options: {}, I: SetPrimaryEmailRequest, O: SetPrimaryEmailResponse },
    { name: "DeleteUserEmail", options: {}, I: DeleteUserEmailRequest, O: DeleteUserEmailResponse },
    { name: "GetUserEmails", options: {}, I: GetUserEmailsRequest, O: GetUserEmailsResponse },
    { name: "GetPublicEmails", options: {}, I: GetPublicEmailsRequest, O: GetPublicEmailsResponse },
    { name: "VerifyUserEmail", options: {}, I: VerifyUserEmailRequest, O: VerifyUserEmailResponse },
    { name: "AddSSHKey", options: {}, I: AddSSHKeyRequest, O: AddSSHKeyResponse },
    { name: "GetSSHKeys", options: {}, I: GetSSHKeysRequest, O: GetSSHKeysResponse },
    { name: "DeleteSSHKey", options: {}, I: DeleteSSHKeyRequest, O: DeleteSSHKeyResponse },
    { name: "AddGPGKey", options: {}, I: AddGPGKeyRequest, O: AddGPGKeyResponse },
    { name: "GetGPGKeys", options: {}, I: GetGPGKeysRequest, O: GetGPGKeysResponse },
    { name: "DeleteGPGKey", options: {}, I: DeleteGPGKeyRequest, O: DeleteGPGKeyResponse },
    { name: "UserLogout", options: {}, I: Token, O: CommonResponse },
    { name: "ValidateToken", options: {}, I: Token, O: CommonResponse },
    { name: "InvalidateUserTokens", options: {}, I: InvalidateTokenRequest, O: CommonResponse },
    { name: "GetUserSessions", options: {}, I: GetUserSessionsRequest, O: GetUserSessionsResponse },
    { name: "RevokeSession", options: {}, I: RevokeSessionRequest, O: RevokeSessionResponse },
    { name: "RevokeAllSessions", options: {}, I: RevokeAllSessionsRequest, O: RevokeAllSessionsResponse },
    { name: "CreateRepository", options: {}, I: CreateRepositoryRequest, O: CreateRepositoryResponse },
    { name: "GetUserRepositories", options: {}, I: GetUserRepositoriesRequest, O: GetUserRepositoriesResponse },
    { name: "GetStarredRepositories", options: {}, I: GetStarredRepositoriesRequest, O: GetStarredRepositoriesResponse },
    { name: "StarRepository", options: {}, I: StarRepositoryRequest, O: StarRepositoryResponse },
    { name: "UnstarRepository", options: {}, I: UnstarRepositoryRequest, O: UnstarRepositoryResponse },
    { name: "IsRepositoryStarred", options: {}, I: IsRepositoryStarredRequest, O: IsRepositoryStarredResponse },
    { name: "WatchRepository", options: {}, I: WatchRepositoryRequest, O: WatchRepositoryResponse },
    { name: "UnwatchRepository", options: {}, I: UnwatchRepositoryRequest, O: UnwatchRepositoryResponse },
    { name: "IsRepositoryWatched", options: {}, I: IsRepositoryWatchedRequest, O: IsRepositoryWatchedResponse },
    { name: "ForkRepository", options: {}, I: ForkRepositoryRequest, O: ForkRepositoryResponse },
    { name: "GetRepositoryFiles", options: {}, I: GetRepositoryFilesRequest, O: GetRepositoryFilesResponse },
    { name: "GetRepositoryDetails", options: {}, I: GetRepositoryDetailsRequest, O: GetRepositoryDetailsResponse },
    { name: "GetFileContent", options: {}, I: GetFileContentRequest, O: GetFileContentResponse },
    { name: "SetupWorkspace", options: {}, I: SetupWorkspaceRequest, O: SetupWorkspaceResponse },
    { name: "CreateIssue", options: {}, I: CreateIssueRequest, O: CreateIssueResponse },
    { name: "GetIssues", options: {}, I: GetIssuesRequest, O: GetIssuesResponse },
    { name: "GetIssueDetails", options: {}, I: GetIssueDetailsRequest, O: GetIssueDetailsResponse },
    { name: "UpdateIssue", options: {}, I: UpdateIssueRequest, O: UpdateIssueResponse },
    { name: "AddComment", options: {}, I: AddCommentRequest, O: AddCommentResponse },
    { name: "CloseIssue", options: {}, I: CloseIssueRequest, O: CloseIssueResponse },
    { name: "ReopenIssue", options: {}, I: ReopenIssueRequest, O: ReopenIssueResponse },
    { name: "AssignUser", options: {}, I: AssignUserRequest, O: AssignUserResponse },
    { name: "UnassignUser", options: {}, I: UnassignUserRequest, O: UnassignUserResponse },
    { name: "CreateLabel", options: {}, I: CreateLabelRequest, O: CreateLabelResponse },
    { name: "GetLabels", options: {}, I: GetLabelsRequest, O: GetLabelsResponse },
    { name: "AddLabelToIssue", options: {}, I: AddLabelToIssueRequest, O: AddLabelToIssueResponse },
    { name: "RemoveLabelFromIssue", options: {}, I: RemoveLabelFromIssueRequest, O: RemoveLabelFromIssueResponse },
    { name: "CreatePullRequest", options: {}, I: CreatePullRequestRequest, O: CreatePullRequestResponse },
    { name: "GetPullRequests", options: {}, I: GetPullRequestsRequest, O: GetPullRequestsResponse },
    { name: "GetPullRequestDetails", options: {}, I: GetPullRequestDetailsRequest, O: GetPullRequestDetailsResponse },
    { name: "UpdatePullRequest", options: {}, I: UpdatePullRequestRequest, O: UpdatePullRequestResponse },
    { name: "ClosePullRequest", options: {}, I: ClosePullRequestRequest, O: ClosePullRequestResponse },
    { name: "MergePullRequest", options: {}, I: MergePullRequestRequest, O: MergePullRequestResponse },
    { name: "ReopenPullRequest", options: {}, I: ReopenPullRequestRequest, O: ReopenPullRequestResponse },
    { name: "AddReviewer", options: {}, I: AddReviewerRequest, O: AddReviewerResponse },
    { name: "RemoveReviewer", options: {}, I: RemoveReviewerRequest, O: RemoveReviewerResponse },
    { name: "GetBranches", options: {}, I: GetBranchesRequest, O: GetBranchesResponse },
    { name: "GetBranchDetails", options: {}, I: GetBranchDetailsRequest, O: GetBranchDetailsResponse },
    { name: "CreateBranch", options: {}, I: CreateBranchRequest, O: CreateBranchResponse },
    { name: "DeleteBranch", options: {}, I: DeleteBranchRequest, O: DeleteBranchResponse },
    { name: "SetDefaultBranch", options: {}, I: SetDefaultBranchRequest, O: SetDefaultBranchResponse },
    { name: "GetRepositorySettings", options: {}, I: GetRepositorySettingsRequest, O: GetRepositorySettingsResponse },
    { name: "UpdateRepositorySettings", options: {}, I: UpdateRepositorySettingsRequest, O: UpdateRepositorySettingsResponse },
    { name: "UpdateRepositoryVisibility", options: {}, I: UpdateRepositoryVisibilityRequest, O: UpdateRepositoryVisibilityResponse },
    { name: "DeleteRepository", options: {}, I: DeleteRepositoryRequest, O: DeleteRepositoryResponse },
    { name: "ArchiveRepository", options: {}, I: ArchiveRepositoryRequest, O: ArchiveRepositoryResponse },
    { name: "TransferRepository", options: {}, I: TransferRepositoryRequest, O: TransferRepositoryResponse },
    { name: "GetAccessTokens", options: {}, I: GetAccessTokensRequest, O: GetAccessTokensResponse },
    { name: "CreateAccessToken", options: {}, I: CreateAccessTokenRequest, O: CreateAccessTokenResponse },
    { name: "DeleteAccessToken", options: {}, I: DeleteAccessTokenRequest, O: DeleteAccessTokenResponse },
    { name: "GetWebhooks", options: {}, I: GetWebhooksRequest, O: GetWebhooksResponse },
    { name: "CreateWebhook", options: {}, I: CreateWebhookRequest, O: CreateWebhookResponse },
    { name: "UpdateWebhook", options: {}, I: UpdateWebhookRequest, O: UpdateWebhookResponse },
    { name: "DeleteWebhook", options: {}, I: DeleteWebhookRequest, O: DeleteWebhookResponse },
    { name: "GetRepositoryMembers", options: {}, I: GetRepositoryMembersRequest, O: GetRepositoryMembersResponse },
    { name: "AddRepositoryMember", options: {}, I: AddRepositoryMemberRequest, O: AddRepositoryMemberResponse },
    { name: "UpdateMemberRole", options: {}, I: UpdateMemberRoleRequest, O: UpdateMemberRoleResponse },
    { name: "RemoveRepositoryMember", options: {}, I: RemoveRepositoryMemberRequest, O: RemoveRepositoryMemberResponse },
    { name: "GetRepositorySecrets", options: {}, I: GetRepositorySecretsRequest, O: GetRepositorySecretsResponse },
    { name: "CreateRepositorySecret", options: {}, I: CreateRepositorySecretRequest, O: CreateRepositorySecretResponse },
    { name: "UpdateRepositorySecret", options: {}, I: UpdateRepositorySecretRequest, O: UpdateRepositorySecretResponse },
    { name: "DeleteRepositorySecret", options: {}, I: DeleteRepositorySecretRequest, O: DeleteRepositorySecretResponse },
    { name: "GetRepositoryUsage", options: {}, I: GetRepositoryUsageRequest, O: GetRepositoryUsageResponse },
    { name: "CreateRelease", options: {}, I: CreateReleaseRequest, O: CreateReleaseResponse },
    { name: "GetReleases", options: {}, I: GetReleasesRequest, O: GetReleasesResponse },
    { name: "GetRelease", options: {}, I: GetReleaseRequest, O: GetReleaseResponse },
    { name: "UpdateRelease", options: {}, I: UpdateReleaseRequest, O: UpdateReleaseResponse },
    { name: "DeleteRelease", options: {}, I: DeleteReleaseRequest, O: DeleteReleaseResponse },
    { name: "UploadReleaseAsset", options: {}, I: UploadReleaseAssetRequest, O: UploadReleaseAssetResponse },
    { name: "DeleteReleaseAsset", options: {}, I: DeleteReleaseAssetRequest, O: DeleteReleaseAssetResponse },
    { name: "GetBillingPlans", options: {}, I: GetBillingPlansRequest, O: GetBillingPlansResponse },
    { name: "GetUserSubscription", options: {}, I: GetUserSubscriptionRequest, O: GetUserSubscriptionResponse },
    { name: "CreateSubscription", options: {}, I: CreateSubscriptionRequest, O: CreateSubscriptionResponse },
    { name: "InitiatePayment", options: {}, I: InitiatePaymentRequest, O: InitiatePaymentResponse },
    { name: "GetPaymentStatus", options: {}, I: GetPaymentStatusRequest, O: GetPaymentStatusResponse },
    { name: "GetPaymentHistory", options: {}, I: GetPaymentHistoryRequest, O: GetPaymentHistoryResponse },
    { name: "GetInvoices", options: {}, I: GetInvoicesRequest, O: GetInvoicesResponse },
    { name: "DownloadInvoice", options: {}, I: DownloadInvoiceRequest, O: DownloadInvoiceResponse },
    { name: "CancelSubscription", options: {}, I: CancelSubscriptionRequest, O: CancelSubscriptionResponse },
    { name: "GetUserActivities", options: {}, I: GetUserActivitiesRequest, O: GetUserActivitiesResponse },
    { name: "GetFollowingActivities", options: {}, I: GetFollowingActivitiesRequest, O: GetFollowingActivitiesResponse },
    { name: "GetRepositoryActivities", options: {}, I: GetRepositoryActivitiesRequest, O: GetRepositoryActivitiesResponse },
    { name: "GetUserCommitActivity", options: {}, I: GetUserCommitActivityRequest, O: GetUserCommitActivityResponse },
    { name: "RecordCommit", options: {}, I: RecordCommitRequest, O: RecordCommitResponse },
    { name: "GetDashboardMetrics", options: {}, I: GetDashboardMetricsRequest, O: GetDashboardMetricsResponse },
    { name: "GetPaginatedUsers", options: {}, I: GetPaginatedUsersRequest, O: GetPaginatedUsersResponse },
    { name: "SearchRepositoriesAdmin", options: {}, I: SearchRepositoriesAdminRequest, O: SearchRepositoriesAdminResponse },
    { name: "GetUserRepositoriesAdmin", options: {}, I: GetUserRepositoriesAdminRequest, O: GetUserRepositoriesAdminResponse },
    { name: "GetSessionStats", options: {}, I: GetSessionStatsRequest, O: GetSessionStatsResponse },
    { name: "GetTopRepositories", options: {}, I: GetTopRepositoriesRequest, O: GetTopRepositoriesResponse },
    { name: "GetAllRepositories", options: {}, I: GetAllRepositoriesRequest, O: GetAllRepositoriesResponse },
    { name: "GetAllSessions", options: {}, I: GetAllSessionsRequest, O: GetAllSessionsResponse },
    { name: "RevokeSessionAdmin", options: {}, I: RevokeSessionAdminRequest, O: RevokeSessionAdminResponse },
    { name: "GetPaymentStats", options: {}, I: GetPaymentStatsRequest, O: GetPaymentStatsResponse },
    { name: "GetAllPayments", options: {}, I: GetAllPaymentsRequest, O: GetAllPaymentsResponse },
    { name: "CreateDatabase", options: {}, I: CreateDatabaseRequest, O: CreateDatabaseResponse },
    { name: "GetUserDatabases", options: {}, I: GetUserDatabasesRequest, O: GetUserDatabasesResponse },
    { name: "GetDatabase", options: {}, I: GetDatabaseRequest, O: GetDatabaseResponse },
    { name: "DeleteDatabase", options: {}, I: DeleteDatabaseRequest, O: DeleteDatabaseResponse },
    { name: "StartDatabase", options: {}, I: StartDatabaseRequest, O: StartDatabaseResponse },
    { name: "StopDatabase", options: {}, I: StopDatabaseRequest, O: StopDatabaseResponse },
    { name: "GetUserNotifications", options: {}, I: GetUserNotificationsRequest, O: GetUserNotificationsResponse },
    { name: "MarkNotificationAsRead", options: {}, I: MarkNotificationAsReadRequest, O: MarkNotificationAsReadResponse },
    { name: "MarkAllNotificationsAsRead", options: {}, I: MarkAllNotificationsAsReadRequest, O: MarkAllNotificationsAsReadResponse },
    { name: "DeleteNotification", options: {}, I: DeleteNotificationRequest, O: DeleteNotificationResponse }
]);
